import * as n from "react";
import { Component as br, useState as A, useRef as B, useEffect as U, useLayoutEffect as $e, isValidElement as un, cloneElement as fa, forwardRef as so, useContext as Tn, createContext as Bn, useMemo as ke, useCallback as re, Fragment as lo, Children as ta, createRef as co } from "react";
import { createPortal as pa } from "react-dom";
import { c as io, a as uo, t as Er, b as mo, f as fo } from "./format-CVedM0M8.js";
const po = "_page_1l6cf_5", _o = "_inner_1l6cf_25", yo = "_pageScroll_1l6cf_38", bo = "_innerScroll_1l6cf_39", bn = {
  page: po,
  inner: _o,
  pageScroll: yo,
  innerScroll: bo
};
function Eo({
  gnbHeight: e = 64,
  minWidth: t = 1024,
  scroll: a = "grid",
  className: r = "",
  style: o,
  children: s
}) {
  const l = a === "page";
  return /* @__PURE__ */ n.createElement(
    "main",
    {
      className: [bn.page, l && bn.pageScroll, "axe-page", r].filter(Boolean).join(" "),
      style: { height: `calc(100vh - ${e}px)`, ...o }
    },
    /* @__PURE__ */ n.createElement("div", { className: [bn.inner, l && bn.innerScroll].filter(Boolean).join(" "), style: { minWidth: t } }, s)
  );
}
const ho = "_body_1wgsn_4", go = {
  body: ho
};
function n0({ className: e = "", style: t, children: a }) {
  return /* @__PURE__ */ n.createElement("div", { className: [go.body, "axe-page-body", e].filter(Boolean).join(" "), style: t }, a);
}
const vo = "_orbitPortalRoot_177qv_2", ko = {
  orbitPortalRoot: vo
};
class Vt extends br {
  constructor() {
    super(...arguments), this.getPortalRoot = () => {
      const t = this.props.portalClassName || ko.orbitPortalRoot, a = Array.from(document.body.childNodes).find((r) => r.className === t);
      if (!a) {
        const r = document.createElement("div");
        return r.className = t, document.body.appendChild(r), r;
      }
      return a;
    };
  }
  render() {
    return pa(this.props.children, this.getPortalRoot());
  }
}
const wo = "_anchor_7h2m7_2", No = "_tip_7h2m7_5", Na = {
  anchor: wo,
  tip: No
};
let $o = 0;
function It({
  content: e,
  children: t,
  placement: a = "bottom",
  delay: r = 250,
  focusable: o,
  describe: s = !0,
  className: l = "",
  keepWrapper: c
}) {
  const [i, m] = A(!1), [u, f] = A({ top: 0, left: 0 }), p = B(null), _ = B(null), y = B(null), d = B("");
  d.current || (d.current = `axe-tip-${++$o}`);
  const b = () => {
    y.current && (clearTimeout(y.current), y.current = null);
  }, N = (h) => {
    b(), h <= 0 ? m(!0) : y.current = setTimeout(() => m(!0), h);
  }, $ = () => {
    b(), m(!1);
  };
  U(() => b, []), $e(() => {
    if (!i) return;
    const h = () => {
      const w = p.current, E = _.current;
      if (!w || !E) return;
      const D = w.getBoundingClientRect(), C = E.offsetHeight, q = E.offsetWidth;
      let M = a === "top" ? D.top - C - 6 : D.bottom + 6;
      a === "bottom" && M + C > window.innerHeight - 4 && D.top - C - 6 > 4 && (M = D.top - C - 6), a === "top" && M < 4 && D.bottom + 6 + C < window.innerHeight - 4 && (M = D.bottom + 6);
      const I = Math.max(4, Math.min(D.left + D.width / 2 - q / 2, window.innerWidth - q - 4));
      f((T) => T.top === M && T.left === I ? T : { top: M, left: I });
    };
    return h(), window.addEventListener("resize", h), window.addEventListener("scroll", h, !0), () => {
      window.removeEventListener("resize", h), window.removeEventListener("scroll", h, !0);
    };
  }, [i, a, e]), U(() => {
    if (!i) return;
    const h = (w) => {
      w.key !== "Escape" || w.isComposing || (w.preventDefault(), w.stopPropagation(), $());
    };
    return document.addEventListener("keydown", h, !0), () => document.removeEventListener("keydown", h, !0);
  }, [i]);
  const g = e != null && e !== !1 && e !== "";
  if (!g && !c) return t;
  const x = g && un(t) ? fa(t, i && s ? { "aria-describedby": d.current } : {}) : t;
  return /* @__PURE__ */ n.createElement(
    "span",
    {
      ref: p,
      className: [Na.anchor, l].filter(Boolean).join(" "),
      tabIndex: o ? 0 : void 0,
      onMouseEnter: () => {
        g && N(r);
      },
      onMouseLeave: $,
      onFocus: () => {
        g && N(0);
      },
      onBlur: $
    },
    x,
    g && i && /* @__PURE__ */ n.createElement(Vt, null, /* @__PURE__ */ n.createElement(
      "div",
      {
        ref: _,
        id: d.current,
        role: "tooltip",
        className: Na.tip,
        style: { top: u.top, left: u.left },
        onMouseEnter: b,
        onMouseLeave: $
      },
      e
    ))
  );
}
const xo = "_bar_gkpv7_1", Do = "_menu_gkpv7_17", Ao = "_title_gkpv7_27", Co = "_info_gkpv7_29", So = "_badge_gkpv7_37", Mo = "_badge_muted_gkpv7_38", qo = "_badge_ok_gkpv7_39", To = "_badge_warn_gkpv7_40", Bo = "_meta_gkpv7_42", Lo = "_actions_gkpv7_26", jo = "_notice_gkpv7_59", Io = "_notice_info_gkpv7_65", Ro = "_notice_ok_gkpv7_66", Oo = "_notice_err_gkpv7_67", Ge = {
  bar: xo,
  menu: Do,
  title: Ao,
  info: Co,
  badge: So,
  badge_muted: Mo,
  badge_ok: qo,
  badge_warn: To,
  meta: Bo,
  actions: Lo,
  notice: jo,
  notice_info: Io,
  notice_ok: Ro,
  notice_err: Oo
};
function Po({
  title: e,
  onMenu: t,
  info: a,
  badge: r,
  meta: o,
  notice: s,
  children: l
}) {
  var c;
  return /* @__PURE__ */ n.createElement("header", { className: Ge.bar }, t && /* @__PURE__ */ n.createElement("button", { type: "button", className: Ge.menu, "aria-label": "메뉴", onClick: t }, "☰"), /* @__PURE__ */ n.createElement("h1", { className: Ge.title }, e), a && /* @__PURE__ */ n.createElement(It, { content: a, focusable: !0, describe: !1 }, /* @__PURE__ */ n.createElement("span", { className: Ge.info, role: "img", "aria-label": `안내: ${typeof a == "string" ? a : "자세히"}` }, "i")), (Array.isArray(r) ? r : [r]).filter(Boolean).map((i, m) => {
    var u;
    return /* @__PURE__ */ n.createElement("span", { key: m, className: [Ge.badge, Ge[`badge_${(u = i.tone) != null ? u : "muted"}`]].join(" ") }, i.label);
  }), o && /* @__PURE__ */ n.createElement("span", { className: Ge.meta }, o), /* @__PURE__ */ n.createElement("span", { className: Ge.actions }, s && s.text && /* @__PURE__ */ n.createElement("span", { className: [Ge.notice, Ge[`notice_${(c = s.tone) != null ? c : "info"}`]].join(" "), role: s.tone === "err" ? "alert" : "status" }, s.text), l));
}
const zo = {
  print: /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("path", { d: "M7 8V4h10v4" }), /* @__PURE__ */ n.createElement("path", { d: "M7 16H5.5A2.5 2.5 0 0 1 3 13.5v-3A2.5 2.5 0 0 1 5.5 8h13A2.5 2.5 0 0 1 21 10.5v3a2.5 2.5 0 0 1-2.5 2.5H17" }), /* @__PURE__ */ n.createElement("rect", { x: "7", y: "13", width: "10", height: "7", rx: "1" })),
  download: /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("path", { d: "M12 4v11" }), /* @__PURE__ */ n.createElement("path", { d: "M7.5 11l4.5 4.5 4.5-4.5" }), /* @__PURE__ */ n.createElement("path", { d: "M5 20h14" })),
  edit: /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("path", { d: "M4 20h4L19 9a2.1 2.1 0 0 0-3-3L5 17v3z" }), /* @__PURE__ */ n.createElement("path", { d: "M14.5 7.5l3 3" })),
  /* 코드도움·찾기 — 돋보기. 글꼴마다 모양이 다른 문자(⌕ ▦)를 쓰지 않는다 */
  search: /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("circle", { cx: "10.5", cy: "10.5", r: "6" }), /* @__PURE__ */ n.createElement("path", { d: "M15 15l5.5 5.5" })),
  /* 날짜 선택 — 달력. 윗변 고리 두 개 + 머리줄 */
  calendar: /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("rect", { x: "4", y: "5.5", width: "16", height: "14.5", rx: "2" }), /* @__PURE__ */ n.createElement("path", { d: "M4 10h16" }), /* @__PURE__ */ n.createElement("path", { d: "M8.5 3.5v4M15.5 3.5v4" })),
  trash: /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("path", { d: "M4 7h16" }), /* @__PURE__ */ n.createElement("path", { d: "M9 7V5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" }), /* @__PURE__ */ n.createElement("path", { d: "M6.2 7l.9 12.1A2 2 0 0 0 9.1 21h5.8a2 2 0 0 0 2-1.9L17.8 7" }), /* @__PURE__ */ n.createElement("path", { d: "M10 11v6M14 11v6" }))
}, Xo = {
  panel: "▣",
  "chevron-open": "∨",
  "chevron-closed": "＞",
  collapse: "◀",
  expand: "▶",
  mail: "✉",
  chat: "💬",
  save: "💾",
  close: "✕"
};
function Fo({ name: e, className: t }) {
  return /* @__PURE__ */ n.createElement("span", { className: t, "aria-hidden": "true" }, Xo[e]);
}
function mn({ name: e, size: t = 15, className: a }) {
  return /* @__PURE__ */ n.createElement(
    "svg",
    {
      className: a,
      width: t,
      height: t,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "1.8",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      style: { verticalAlign: "-2px" },
      "aria-hidden": "true"
    },
    zo[e]
  );
}
const Ho = "_btn_q02rt_1", Wo = "_sm_q02rt_18", Ko = "_primary_q02rt_21", Uo = "_dark_q02rt_23", Go = "_danger_q02rt_25", Yo = "_soon_q02rt_29", Vo = "_soonTag_q02rt_30", Qo = "_blocked_q02rt_39", Jo = "_kbd_q02rt_51", Zo = "_iconBtn_q02rt_54", es = "_link_q02rt_70", it = {
  btn: Ho,
  sm: Wo,
  primary: Ko,
  dark: Uo,
  danger: Go,
  soon: Yo,
  soonTag: Vo,
  blocked: Qo,
  kbd: Jo,
  iconBtn: Zo,
  link: es
}, et = so(function(t, a) {
  const {
    variant: r = "default",
    size: o = "md",
    icon: s,
    kbd: l,
    soon: c,
    blockedReason: i,
    children: m,
    className: u = "",
    type: f = "button",
    onClick: p,
    title: _,
    disabled: y,
    ...d
  } = t, b = c || i || "", N = b !== "", $ = "blockedReason" in t, g = /* @__PURE__ */ n.createElement(
    "button",
    {
      ref: a,
      type: f,
      className: [it.btn, it[r], o === "sm" ? it.sm : "", c ? it.soon : N ? it.blocked : "", u].filter(Boolean).join(" "),
      "aria-disabled": N ? !0 : void 0,
      disabled: N ? void 0 : y,
      title: N ? void 0 : _,
      onClick: N ? (x) => x.preventDefault() : p,
      ...d
    },
    s && /* @__PURE__ */ n.createElement(mn, { name: s, size: o === "sm" ? 12 : 14 }),
    m,
    l && /* @__PURE__ */ n.createElement("kbd", { className: it.kbd }, l),
    c && /* @__PURE__ */ n.createElement("em", { className: it.soonTag }, "준비 중")
  );
  return N || $ ? /* @__PURE__ */ n.createElement(It, { content: b, keepWrapper: $ }, g) : g;
});
function na({ label: e, children: t, className: a = "", type: r = "button", ...o }) {
  return /* @__PURE__ */ n.createElement(It, { content: e, describe: !1 }, /* @__PURE__ */ n.createElement(
    "button",
    {
      type: r,
      className: [it.iconBtn, a].filter(Boolean).join(" "),
      "aria-label": e,
      ...o
    },
    t
  ));
}
function _a({ children: e, className: t = "", type: a = "button", ...r }) {
  return /* @__PURE__ */ n.createElement("button", { type: a, className: [it.link, t].filter(Boolean).join(" "), ...r }, e);
}
const ts = "_wrap_10shm_1", ns = "_btn_10shm_2", as = "_on_10shm_6", rs = "_caret_10shm_8", os = "_pop_10shm_9", ss = "_sec_10shm_14", ls = "_item_10shm_17", cs = "_danger_10shm_24", pt = {
  wrap: ts,
  btn: ns,
  on: as,
  caret: rs,
  pop: os,
  sec: ss,
  item: ls,
  danger: cs
}, is = (e, t, a, r = {}) => ({ kind: "item", key: e, label: t, onClick: a, ...r }), a0 = (e, t, a) => ({ kind: "section", key: e, label: t, note: a });
function us({ label: e, entries: t, disabled: a, title: r }) {
  const [o, s] = A(!1), l = B(null), c = B(null), i = B(null), m = () => {
    var f, p;
    return Array.from((p = (f = i.current) == null ? void 0 : f.querySelectorAll("[role=menuitem]:not(:disabled)")) != null ? p : []);
  };
  U(() => {
    var f;
    o && ((f = m()[0]) == null || f.focus());
  }, [o]), U(() => {
    if (!o) return;
    const f = (_) => {
      l.current && !l.current.contains(_.target) && s(!1);
    }, p = (_) => {
      var y;
      _.key !== "Escape" || _.isComposing || (_.preventDefault(), _.stopPropagation(), s(!1), (y = c.current) == null || y.focus());
    };
    return document.addEventListener("mousedown", f), document.addEventListener("keydown", p, !0), () => {
      document.removeEventListener("mousedown", f), document.removeEventListener("keydown", p, !0);
    };
  }, [o]);
  const u = (f) => {
    const p = m();
    if (p.length === 0) return;
    const _ = p.indexOf(document.activeElement);
    let y = -1;
    if (f.key === "ArrowDown") y = (_ + 1) % p.length;
    else if (f.key === "ArrowUp") y = (_ <= 0 ? p.length : _) - 1;
    else if (f.key === "Home") y = 0;
    else if (f.key === "End") y = p.length - 1;
    else if (f.key === "Tab") {
      s(!1);
      return;
    } else return;
    f.preventDefault(), p[y].focus();
  };
  return /* @__PURE__ */ n.createElement("span", { className: pt.wrap, ref: l }, /* @__PURE__ */ n.createElement(It, { content: o ? void 0 : r, keepWrapper: !0 }, /* @__PURE__ */ n.createElement(
    "button",
    {
      ref: c,
      type: "button",
      className: [pt.btn, o ? pt.on : ""].join(" "),
      disabled: a,
      "aria-haspopup": "menu",
      "aria-expanded": o,
      onClick: () => s((f) => !f),
      onKeyDown: (f) => {
        f.key === "ArrowDown" && !o && (f.preventDefault(), s(!0));
      }
    },
    e,
    /* @__PURE__ */ n.createElement("span", { className: pt.caret, "aria-hidden": "true" }, "▾")
  )), o && /* @__PURE__ */ n.createElement("div", { ref: i, className: pt.pop, role: "menu", onKeyDown: u }, t.map((f) => f.kind === "section" ? /* @__PURE__ */ n.createElement("div", { key: f.key, className: pt.sec }, f.label, f.note && /* @__PURE__ */ n.createElement("small", null, f.note)) : /* @__PURE__ */ n.createElement(
    "button",
    {
      key: f.key,
      type: "button",
      role: "menuitem",
      disabled: f.disabled,
      className: [pt.item, f.danger ? pt.danger : ""].join(" "),
      onClick: () => {
        var p;
        s(!1), (p = c.current) == null || p.focus(), f.onClick();
      }
    },
    /* @__PURE__ */ n.createElement("span", null, f.label),
    f.disabled && f.reason && /* @__PURE__ */ n.createElement("small", null, f.reason)
  ))));
}
const ms = "_pop_12uut_2", ds = "_auto_12uut_12", fs = "_head_12uut_13", ps = "_title_12uut_18", _s = "_close_12uut_19", ys = "_body_12uut_21", bs = "_flush_12uut_22", Es = "_foot_12uut_23", _t = {
  pop: ms,
  auto: ds,
  head: fs,
  title: ps,
  close: _s,
  body: ys,
  flush: bs,
  foot: Es
}, En = 8;
function r0({
  x: e,
  y: t,
  title: a,
  ariaLabel: r,
  onClose: o,
  children: s,
  footer: l,
  closeLabel: c = "닫기",
  width: i,
  closeOnScroll: m = !1,
  flush: u = !1,
  initialFocus: f,
  className: p
}) {
  const _ = B(null), [y, d] = A({ left: e, top: t }), b = B(o);
  b.current = o;
  const N = () => {
    const g = _.current;
    if (!g) return;
    const x = g.offsetWidth, h = g.offsetHeight, w = Math.max(En, Math.min(e, window.innerWidth - x - En)), E = t + h > window.innerHeight - En ? Math.max(En, t - h - 32) : t;
    d((D) => D.left === w && D.top === E ? D : { left: w, top: E });
  };
  $e(N, [e, t]), U(() => {
    const g = _.current;
    if (!g || typeof ResizeObserver == "undefined") return;
    const x = new ResizeObserver(N);
    return x.observe(g), () => x.disconnect();
  }, [e, t]), U(() => {
    const g = (E) => {
      _.current && !_.current.contains(E.target) && b.current(!1);
    }, x = (E) => {
      E.key === "Escape" && (E.stopPropagation(), b.current(!0));
    }, h = (E) => {
      var D;
      (!(E.target instanceof Node) || !((D = _.current) != null && D.contains(E.target))) && b.current(!1);
    }, w = window.setTimeout(() => document.addEventListener("mousedown", g), 0);
    return document.addEventListener("keydown", x, !0), m && window.addEventListener("scroll", h, !0), () => {
      window.clearTimeout(w), document.removeEventListener("mousedown", g), document.removeEventListener("keydown", x, !0), window.removeEventListener("scroll", h, !0);
    };
  }, [m]), U(() => {
    var g, x;
    f && ((x = (g = _.current) == null ? void 0 : g.querySelector(f)) == null || x.focus());
  }, [f]);
  const $ = /* @__PURE__ */ n.createElement(
    "div",
    {
      ref: _,
      className: `${_t.pop}${i ? "" : ` ${_t.auto}`}${p ? ` ${p}` : ""}`,
      style: { left: y.left, top: y.top, ...i ? { width: i } : null },
      role: "dialog",
      "aria-label": r
    },
    /* @__PURE__ */ n.createElement("div", { className: _t.head }, /* @__PURE__ */ n.createElement("span", { className: _t.title }, a), /* @__PURE__ */ n.createElement("button", { type: "button", className: _t.close, onClick: () => b.current(!0), "aria-label": c }, "✕")),
    /* @__PURE__ */ n.createElement("div", { className: `${_t.body}${u ? ` ${_t.flush}` : ""}` }, s),
    l != null && /* @__PURE__ */ n.createElement("div", { className: _t.foot }, l)
  );
  return typeof document == "undefined" ? $ : pa($, document.body);
}
const hs = "_panel_pg53c_2", gs = "_head_pg53c_3", vs = "_kicker_pg53c_4", ks = "_actions_pg53c_5", ws = "_link_pg53c_6", Ns = "_menuHits_pg53c_8", $s = "_turns_pg53c_11", xs = "_turn_pg53c_11", Ds = "_q_pg53c_13", As = "_a_pg53c_5", Cs = "_aText_pg53c_15", Ss = "_step_pg53c_16", Ms = "_caret_pg53c_17", qs = "_err_pg53c_19", Me = {
  panel: hs,
  head: gs,
  kicker: vs,
  actions: ks,
  link: ws,
  menuHits: Ns,
  turns: $s,
  turn: xs,
  q: Ds,
  a: As,
  aText: Cs,
  step: Ss,
  caret: Ms,
  err: qs
};
function o0({ turns: e, busy: t, menuHits: a, onNavigate: r, onReset: o, onClose: s, labels: l }) {
  const c = B(null), i = e.length ? e[e.length - 1].answer.length : 0;
  return U(() => {
    var m;
    (m = c.current) == null || m.scrollIntoView({ block: "nearest" });
  }, [e.length, i]), /* @__PURE__ */ n.createElement("section", { className: Me.panel, "aria-live": "polite" }, /* @__PURE__ */ n.createElement("header", { className: Me.head }, /* @__PURE__ */ n.createElement("span", { className: Me.kicker }, l.kicker), /* @__PURE__ */ n.createElement("span", { className: Me.actions }, /* @__PURE__ */ n.createElement("button", { type: "button", className: Me.link, onClick: o, disabled: t }, l.reset), /* @__PURE__ */ n.createElement("button", { type: "button", className: Me.link, onClick: s, "aria-label": l.closePanel }, l.close))), a.length > 0 && /* @__PURE__ */ n.createElement("div", { className: Me.menuHits }, /* @__PURE__ */ n.createElement("span", null, l.relatedMenus), a.map((m) => /* @__PURE__ */ n.createElement("button", { type: "button", key: m.path, onClick: () => r(m.path) }, m.label, " ↗"))), /* @__PURE__ */ n.createElement("div", { className: Me.turns }, e.map((m) => {
    var u;
    return /* @__PURE__ */ n.createElement("article", { key: m.id, className: Me.turn }, /* @__PURE__ */ n.createElement("div", { className: Me.q }, m.question), /* @__PURE__ */ n.createElement("div", { className: Me.a }, m.answer && /* @__PURE__ */ n.createElement("div", { className: Me.aText }, m.answer), m.streaming && /* @__PURE__ */ n.createElement("div", { className: Me.step }, (u = m.step) != null ? u : m.answer ? "" : l.waiting, /* @__PURE__ */ n.createElement("span", { className: Me.caret })), m.error && /* @__PURE__ */ n.createElement("div", { className: Me.err }, m.error)));
  }), /* @__PURE__ */ n.createElement("div", { ref: c })));
}
function s0(e, t, a = !0) {
  const r = B(t);
  r.current = t, U(() => {
    if (!a) return;
    const o = (s) => {
      if (s.key !== "Enter" || !(s.ctrlKey || s.metaKey) || s.isComposing || s.repeat || s.defaultPrevented) return;
      const l = e.current, c = document.activeElement;
      !l || !c || !l.contains(c) || (s.preventDefault(), r.current());
    };
    return document.addEventListener("keydown", o), () => document.removeEventListener("keydown", o);
  }, [e, a]);
}
function Ts() {
  const e = typeof navigator != "undefined" && (navigator.platform || navigator.userAgent) || "";
  return /Mac|iPhone|iPad/i.test(e) ? "⌘+Enter" : "Ctrl+Enter";
}
const Bs = "_bar_1g564_2", Ls = "_sticky_1g564_12", js = "_start_1g564_19", Is = "_end_1g564_20", Rs = "_status_1g564_22", Os = "_dirty_1g564_23", Ps = "_kbd_1g564_25", xt = {
  bar: Bs,
  sticky: Ls,
  start: js,
  end: Is,
  status: Rs,
  dirty: Os,
  kbd: Ps
};
function l0({ start: e, children: t, status: a, dirty: r, inline: o, shortcutHint: s, className: l = "" }) {
  return /* @__PURE__ */ n.createElement("div", { className: ["axe-save-bar", xt.bar, o ? "" : xt.sticky, l].filter(Boolean).join(" "), role: "group", "aria-label": "저장" }, /* @__PURE__ */ n.createElement("span", { className: xt.start }, e), /* @__PURE__ */ n.createElement("span", { className: xt.end }, a && /* @__PURE__ */ n.createElement("span", { className: [xt.status, r ? xt.dirty : ""].filter(Boolean).join(" "), "aria-live": "polite" }, a), t, s && /* @__PURE__ */ n.createElement("kbd", { className: xt.kbd }, Ts())));
}
const zs = "_root_j67qt_2", Xs = "_closed_j67qt_3", Fs = "_tab_j67qt_6", Hs = "_collapse_j67qt_7", Ws = "_body_j67qt_16", Ks = "_card_j67qt_32", Us = "_head_j67qt_37", Gs = "_cardOpen_j67qt_44", Ys = "_headBtn_j67qt_47", Vs = "_icon_j67qt_56", Qs = "_badge_j67qt_57", Js = "_trailing_j67qt_58", Zs = "_chev_j67qt_59", el = "_panelWrap_j67qt_63", tl = "_panelOpen_j67qt_67", nl = "_panelBody_j67qt_68", al = "_panelInner_j67qt_69", rl = "_panelSettled_j67qt_70", ge = {
  root: zs,
  closed: Xs,
  tab: Fs,
  collapse: Hs,
  body: Ws,
  card: Ks,
  head: Us,
  cardOpen: Gs,
  headBtn: Ys,
  icon: Vs,
  badge: Qs,
  trailing: Js,
  chev: Zs,
  panelWrap: el,
  panelOpen: tl,
  panelBody: nl,
  panelInner: al,
  panelSettled: rl
}, ol = 1280, sl = 8, hr = "axe-side-bar:";
function ll(e) {
  if (!e) return null;
  try {
    const t = window.localStorage.getItem(hr + e);
    return t === "1" ? !0 : t === "0" ? !1 : null;
  } catch {
    return null;
  }
}
function cl(e, t) {
  if (e)
    try {
      window.localStorage.setItem(hr + e, t ? "1" : "0");
    } catch {
    }
}
function c0({
  enabled: e = !0,
  defaultOpen: t = !0,
  width: a = 260,
  collapseBelow: r = ol,
  storageKey: o,
  className: s = "",
  children: l
}) {
  var p;
  const c = B(ll(o)), [i, m] = A((p = c.current) != null ? p : t), u = B(c.current !== null);
  if (U(() => {
    if (!e || !r || typeof window.matchMedia != "function") return;
    const _ = window.matchMedia(`(max-width: ${r - 1}px)`), y = () => {
      u.current || m(!_.matches && t);
    };
    return y(), _.addEventListener ? _.addEventListener("change", y) : _.addListener(y), () => {
      _.removeEventListener ? _.removeEventListener("change", y) : _.removeListener(y);
    };
  }, [e, r, t]), !e) return null;
  const f = () => {
    u.current = !0, cl(o, !i), m(!i);
  };
  return /* @__PURE__ */ n.createElement(
    "aside",
    {
      className: ["axe-side-bar", ge.root, i ? "" : ge.closed, s].filter(Boolean).join(" "),
      style: { width: i ? a : sl }
    },
    /* @__PURE__ */ n.createElement("div", { className: ge.tab }, /* @__PURE__ */ n.createElement(It, { content: i ? "정보 패널 접기" : "정보 패널 펼치기", describe: !1 }, /* @__PURE__ */ n.createElement(
      "button",
      {
        type: "button",
        className: ge.collapse,
        onClick: f,
        "aria-label": i ? "정보 패널 접기" : "정보 패널 펼치기",
        "aria-expanded": i
      },
      /* @__PURE__ */ n.createElement(Fo, { name: i ? "collapse" : "expand" })
    ))),
    /* @__PURE__ */ n.createElement("div", { className: ge.body }, l)
  );
}
const gr = Bn(null);
function i0({ children: e, defaultOpenId: t = null, exclusive: a = !0 }) {
  const [r, o] = A(t);
  return a ? /* @__PURE__ */ n.createElement(gr.Provider, { value: { openId: r, setOpenId: o } }, e) : /* @__PURE__ */ n.createElement(n.Fragment, null, e);
}
const vr = "axe-side-panel:";
function il(e) {
  if (!e) return null;
  try {
    const t = window.localStorage.getItem(vr + e);
    return t === "1" ? !0 : t === "0" ? !1 : null;
  } catch {
    return null;
  }
}
function ul(e, t) {
  if (e)
    try {
      window.localStorage.setItem(vr + e, t ? "1" : "0");
    } catch {
    }
}
function u0({
  title: e,
  enabled: t = !0,
  defaultOpen: a = !0,
  icon: r,
  badge: o,
  trailing: s,
  storageKey: l,
  panelId: c,
  className: i = "",
  children: m
}) {
  var h;
  const u = Tn(gr), f = !!u && c != null, p = B(il(l)), [_, y] = A((h = p.current) != null ? h : a), d = f ? u.openId === c : _, [b, N] = A(d), [$, g] = A(d);
  if (!t) return null;
  d && !b && N(!0);
  const x = () => {
    const w = !d;
    ul(l, w), N(!0), g(!1), f ? u.setOpenId(w ? c : null) : y(w);
  };
  return /* @__PURE__ */ n.createElement("section", { className: ["axe-side-card", ge.card, d ? ge.cardOpen : "", i].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("header", { className: ge.head, onClick: x }, /* @__PURE__ */ n.createElement("button", { type: "button", className: ge.headBtn, "aria-expanded": d }, r && /* @__PURE__ */ n.createElement("span", { className: ge.icon, "aria-hidden": "true" }, r), /* @__PURE__ */ n.createElement("strong", null, e)), o && /* @__PURE__ */ n.createElement("span", { className: ge.badge }, o), s && /* @__PURE__ */ n.createElement("span", { className: ge.trailing, onClick: (w) => w.stopPropagation() }, s), /* @__PURE__ */ n.createElement(
    "svg",
    {
      className: ge.chev,
      width: "14",
      height: "14",
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "2.2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      "aria-hidden": "true"
    },
    /* @__PURE__ */ n.createElement("path", { d: "M6 9l6 6 6-6" })
  )), b && /* @__PURE__ */ n.createElement(
    "div",
    {
      className: [ge.panelWrap, d ? ge.panelOpen : ""].filter(Boolean).join(" "),
      onTransitionEnd: (w) => {
        w.target === w.currentTarget && w.propertyName === "grid-template-rows" && g(!0);
      }
    },
    /* @__PURE__ */ n.createElement("div", { className: [ge.panelBody, d && $ ? ge.panelSettled : ""].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("div", { className: ge.panelInner }, m))
  ));
}
const ml = "_guide_qnh7l_1", dl = "_title_qnh7l_5", fl = "_desc_qnh7l_6", pl = "_act_qnh7l_7", _l = "_why_qnh7l_13", yl = "_steps_qnh7l_14", bl = "_no_qnh7l_20", El = "_cur_qnh7l_24", hl = "_link_qnh7l_26", at = {
  guide: ml,
  title: dl,
  desc: fl,
  act: pl,
  why: _l,
  steps: yl,
  no: bl,
  cur: El,
  link: hl
};
function m0({ title: e, desc: t, action: a, steps: r }) {
  return /* @__PURE__ */ n.createElement("section", { className: at.guide, "aria-label": e }, /* @__PURE__ */ n.createElement("h2", { className: at.title }, e), t && /* @__PURE__ */ n.createElement("p", { className: at.desc }, t), a && /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("button", { type: "button", className: at.act, disabled: a.disabled, onClick: a.onClick }, a.label), a.disabled && a.reason && /* @__PURE__ */ n.createElement("p", { className: at.why }, a.reason)), r && r.length > 0 && /* @__PURE__ */ n.createElement("ol", { className: at.steps }, r.map((o, s) => /* @__PURE__ */ n.createElement("li", { key: o.label, className: o.current ? at.cur : void 0 }, /* @__PURE__ */ n.createElement("span", { className: at.no }, s + 1), o.onClick && !o.current ? /* @__PURE__ */ n.createElement("button", { type: "button", className: at.link, onClick: o.onClick }, o.label) : /* @__PURE__ */ n.createElement("span", null, o.label), o.hint && /* @__PURE__ */ n.createElement("small", null, o.hint)))));
}
const gl = "_list_1w2rs_1", vl = "_row_1w2rs_2", kl = "_label_1w2rs_6", wl = "_value_1w2rs_7", Nl = "_emphasis_1w2rs_8", $l = "_changed_1w2rs_10", zt = {
  list: gl,
  row: vl,
  label: kl,
  value: wl,
  emphasis: Nl,
  changed: $l
};
function d0({ items: e, className: t }) {
  return /* @__PURE__ */ n.createElement("dl", { className: [zt.list, t != null ? t : ""].join(" ") }, e.map((a, r) => /* @__PURE__ */ n.createElement("div", { key: r, className: [zt.row, a.emphasis ? zt.emphasis : ""].join(" ") }, /* @__PURE__ */ n.createElement("dt", { className: zt.label }, a.label), /* @__PURE__ */ n.createElement("dd", { className: [zt.value, a.changed ? zt.changed : ""].join(" ") }, a.value))));
}
const xl = "_underline_xl221_2", Dl = "_active_xl221_24", Al = "_segmented_xl221_33", Xn = {
  underline: xl,
  active: Dl,
  segmented: Al
};
function kr({
  items: e,
  value: t,
  onChange: a,
  variant: r = "underline",
  className: o = "",
  "aria-label": s
}) {
  return /* @__PURE__ */ n.createElement(
    "nav",
    {
      className: [r === "segmented" ? Xn.segmented : Xn.underline, o].filter(Boolean).join(" "),
      role: "tablist",
      "aria-label": s
    },
    e.map((l) => /* @__PURE__ */ n.createElement(
      "button",
      {
        key: l.key,
        type: "button",
        role: "tab",
        "aria-selected": l.key === t,
        className: l.key === t ? Xn.active : "",
        onClick: () => a(l.key)
      },
      l.label
    ))
  );
}
const Cl = "_bar_1adxf_1", Sl = "_actions_1adxf_17", Ml = "_field_1adxf_24", ql = "_fieldLabel_1adxf_25", Tl = "_readout_1adxf_33", Bl = "_search_1adxf_44", Ll = "_detail_1adxf_58", jl = "_pill_1adxf_71", Il = "_hint_1adxf_82", Ve = {
  bar: Cl,
  actions: Sl,
  field: Ml,
  fieldLabel: ql,
  readout: Tl,
  search: Bl,
  detail: Ll,
  pill: jl,
  hint: Il
}, Rl = /* @__PURE__ */ new Set(["text", "search", "number", "tel", "email", "url", "password", ""]);
function Ol(e) {
  if (e.key !== "Enter" || e.defaultPrevented || e.nativeEvent.isComposing || e.ctrlKey || e.metaKey || e.altKey || e.shiftKey) return !1;
  const t = e.target;
  return !(!(t instanceof HTMLInputElement) || !e.currentTarget.contains(t) || !Rl.has(t.type) || t.readOnly || t.disabled || t.getAttribute("role") === "combobox" || t.getAttribute("aria-expanded") === "true");
}
function f0({
  children: e,
  onSearch: t,
  searchLabel: a = "조회",
  searchDisabled: r,
  searchTitle: o,
  detailSearch: s = !1,
  onDetailSearch: l,
  detailLabel: c = "상세검색",
  onReset: i,
  resetLabel: m = "초기화",
  resetDisabled: u,
  trailing: f,
  enterSearch: p = !0
}) {
  const _ = (y) => {
    !p || !t || r || !Ol(y) || (y.preventDefault(), t());
  };
  return /* @__PURE__ */ n.createElement("section", { className: Ve.bar, onKeyDown: _ }, e, /* @__PURE__ */ n.createElement("span", { className: Ve.actions }, f, i && /* @__PURE__ */ n.createElement("button", { type: "button", className: Ve.detail, onClick: i, disabled: u }, m), s && /* @__PURE__ */ n.createElement("button", { type: "button", className: Ve.detail, onClick: l }, "⌕ ", c), t && /* @__PURE__ */ n.createElement(It, { content: o, keepWrapper: !0 }, /* @__PURE__ */ n.createElement("button", { type: "button", className: Ve.search, onClick: t, disabled: r }, "⌕ ", a))));
}
function Pl({ label: e, children: t }) {
  return /* @__PURE__ */ n.createElement("label", { className: Ve.field }, /* @__PURE__ */ n.createElement("span", { className: Ve.fieldLabel }, e), t);
}
function p0({ children: e }) {
  return /* @__PURE__ */ n.createElement("span", { className: Ve.readout }, e);
}
function _0({ children: e }) {
  return /* @__PURE__ */ n.createElement("span", { className: Ve.pill, role: "status" }, e);
}
function y0({ children: e }) {
  return /* @__PURE__ */ n.createElement("span", { className: Ve.hint }, e);
}
function zl(e) {
  return `${e.gisu}기 (${e.startDa} ~ ${e.endDa})${e.closeYn ? " · 마감" : ""}`;
}
function b0({ rows: e, value: t, onChange: a, disabled: r, label: o = "기수" }) {
  return /* @__PURE__ */ n.createElement(Pl, { label: o }, /* @__PURE__ */ n.createElement(
    "select",
    {
      value: t != null ? t : "",
      "aria-label": o,
      disabled: r,
      style: { width: "var(--axe-field-w-lg, 240px)" },
      onChange: (s) => a(Number(s.target.value))
    },
    e.map((s) => /* @__PURE__ */ n.createElement("option", { key: s.gisu, value: s.gisu }, zl(s)))
  ));
}
class wr {
  constructor(t, a) {
    this._resizeObserver = null, this.initializeResizeObserver = () => {
      this._resizeObserver = new ResizeObserver((r) => {
        try {
          for (const o of r) {
            const s = o.borderBoxSize[0];
            this._callback({ width: s.inlineSize, height: s.blockSize }, o);
          }
        } catch (o) {
          console.error(o);
        }
      }), this._resizeObserver.observe(this._element);
    }, this.refresh = () => {
    }, this.detach = () => {
      this._resizeObserver && this._resizeObserver.disconnect();
    }, this.reset = () => {
    }, this._element = t, this._callback = a, this.initializeResizeObserver();
  }
}
function Nr(e, t) {
  return !e || e.key !== t ? { key: t, dir: "asc" } : e.dir === "asc" ? { key: t, dir: "desc" } : null;
}
function $r(e, t) {
  return !e || e.key !== t ? "none" : e.dir === "asc" ? "ascending" : "descending";
}
function xr(e, t) {
  return e ? `${t(e.key)} ${e.dir === "asc" ? "오름차순" : "내림차순"} 정렬` : "정렬을 해제했습니다";
}
function Xl(e) {
  const t = e.replace(/\s+/g, " ").trim();
  if (!t || t === "-") return null;
  const a = /^([-+]?)\(?[₩$]?\s*([\d,]*\.?\d+)\)?\s*(%|원|개|건)?$/.exec(t);
  if (a && /^\d{1,3}(,\d{3})*(\.\d+)?$|^\d*\.?\d+$/.test(a[2])) {
    const r = parseFloat(a[2].replace(/,/g, ""));
    return a[1] === "-" || /^[-+]?\(/.test(t) ? -r : r;
  }
  return t;
}
function Dr(e, t, a) {
  if (e === null || t === null) return e === t ? 0 : e === null ? 1 : -1;
  let r;
  return typeof e == "number" && typeof t == "number" ? r = e - t : typeof e == "number" ? r = -1 : typeof t == "number" ? r = 1 : r = e.localeCompare(t, "ko", { numeric: !0, sensitivity: "base" }), a === "asc" ? r : -r;
}
function Fl(e, t) {
  const a = [], r = (l) => {
    l.sort((c, i) => Dr(e[c.i].value, e[i.i].value, t) || c.i - i.i), l.forEach((c) => {
      a.push(c.i), r(c.kids);
    });
  };
  let o = [], s = [];
  return e.forEach((l, c) => {
    if (l.level === null) {
      r(o), o = [], s = [], a.push(c);
      return;
    }
    for (; s.length && s[s.length - 1].level >= l.level; ) s.pop();
    const i = { i: c, kids: [] };
    (s.length ? s[s.length - 1].node.kids : o).push(i), s.push({ level: l.level, node: i });
  }), r(o), a;
}
function Hl(e, t) {
  const a = new Set(t), r = e.filter((s) => a.has(s)), o = new Set(r);
  for (let s = t.length - 1; s >= 0; s -= 1) {
    const l = t[s];
    if (o.has(l)) continue;
    const c = s + 1 < t.length ? r.indexOf(t[s + 1]) : -1;
    c < 0 ? r.push(l) : r.splice(c, 0, l), o.add(l);
  }
  return r;
}
function Wl(e, t) {
  const a = /* @__PURE__ */ new Map();
  t.forEach((c, i) => a.set(c, i));
  const r = e.map((c) => {
    var i;
    return (i = a.get(c)) != null ? i : -1;
  }), o = [], s = new Array(r.length).fill(-1);
  r.forEach((c, i) => {
    if (c < 0) return;
    let m = 0, u = o.length;
    for (; m < u; ) {
      const f = m + u >> 1;
      r[o[f]] < c ? m = f + 1 : u = f;
    }
    m > 0 && (s[i] = o[m - 1]), o[m] = i;
  });
  const l = /* @__PURE__ */ new Set();
  for (let c = o.length ? o[o.length - 1] : -1; c >= 0; c = s[c]) l.add(e[c]);
  return l;
}
const Kl = 'input, select, textarea, button, a[href], [role="checkbox"], [role="button"]', Ul = ".axe-group-row, .axe-input-row, .axe-total-row, [data-sort-fixed]";
function Gl(e) {
  const t = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Map();
  for (const r of e) {
    a.forEach((s, l) => {
      s <= 1 ? a.delete(l) : a.set(l, s - 1);
    });
    let o = 0;
    for (const s of Array.from(r.cells)) {
      for (; a.has(o); ) o += 1;
      const l = s.colSpan || 1;
      if (t.set(s, o), s.rowSpan > 1) for (let c = o; c < o + l; c += 1) a.set(c, s.rowSpan);
      o += l;
    }
  }
  return t;
}
function Yl(e) {
  const t = e.tHead;
  if (!t) return [];
  const a = Gl(Array.from(t.rows)), r = [];
  return a.forEach((o, s) => {
    var c, i;
    if (s.tagName !== "TH" || (s.colSpan || 1) !== 1 || s.dataset.sortable === "false" || s.hasAttribute("aria-sort") && s.dataset.axeSort === void 0 || s.querySelector(Kl)) return;
    const l = ((c = s.textContent) != null ? c : "").replace(/\s+/g, " ").trim();
    l && r.push({ th: s, col: o, key: (i = s.dataset.sortKey) != null ? i : String(o), label: l });
  }), r;
}
function $a(e, t) {
  var r;
  let a = 0;
  for (const o of Array.from(e.cells)) {
    const s = o.colSpan || 1;
    if (t < a + s) {
      const l = o.dataset.sortValue;
      if (l !== void 0) {
        const i = Number(l);
        return l === "" ? null : Number.isFinite(i) ? i : l;
      }
      const c = o.querySelector('input:not([type="checkbox"]):not([type="radio"]), select');
      return Xl(c ? c.value : (r = o.textContent) != null ? r : "");
    }
    a += s;
  }
  return null;
}
function Vl(e) {
  if (e.matches(Ul) || e.cells.length === 1 && (e.cells[0].colSpan || 1) > 1) return null;
  const t = Number(e.getAttribute("aria-level"));
  return Number.isFinite(t) && t >= 1 ? t : 1;
}
function Ql() {
  return { parent: null, base: [], shown: [], sig: "" };
}
function Jl(e) {
  const t = Array.from(e.tBodies);
  if (t.length > 1) return { parent: e, items: t, bodies: !0 };
  const a = t[0];
  if (!a) return null;
  const r = Array.from(a.rows);
  return r.some((o) => Array.from(o.cells).some((s) => s.rowSpan > 1)) ? null : { parent: a, items: r, bodies: !1 };
}
const Ar = (e, t) => e.length === t.length && e.every((a, r) => a === t[r]);
function Zl(e, t, a) {
  if (Ar(t, a)) return;
  const r = Wl(t, a);
  let o = a.length ? a[a.length - 1].nextElementSibling : null;
  for (let s = t.length - 1; s >= 0; s -= 1) {
    const l = t[s];
    r.has(l) || e.insertBefore(l, o), o = l;
  }
}
function ec(e, t, a, r) {
  if (t) {
    const l = e.map((c, i) => ({ b: c, i, v: c.rows[0] ? $a(c.rows[0], a) : null }));
    return l.sort((c, i) => Dr(c.v, i.v, r) || c.i - i.i), l.map((c) => c.b);
  }
  const o = e, s = o.map((l) => {
    const c = Vl(l);
    return { level: c, value: c === null ? null : $a(l, a) };
  });
  return Fl(s, r).map((l) => o[l]);
}
function tc(e, t, a) {
  const r = Jl(e);
  if ((!r || r.parent !== a.parent) && (a.parent = r ? r.parent : null, a.base = r ? r.items : [], a.shown = a.base, a.sig = "", !r))
    return;
  const o = r.items, s = t ? `${t.col}:${t.dir}` : "";
  if (s === a.sig && Ar(o, a.shown)) return;
  a.base = a.sig ? Hl(a.base, o) : o;
  let l = t ? ec(a.base, r.bodies, t.col, t.dir) : a.base;
  if (t && s === a.sig) {
    const c = new Set(a.shown), i = a.shown.filter((u) => u.parentElement === r.parent);
    let m = 0;
    l = l.map((u) => c.has(u) ? i[m++] : u);
  }
  Zl(r.parent, l, o), a.shown = l, a.sig = s;
}
const nc = "input, select, textarea, button";
function ac(e) {
  const t = e == null ? void 0 : e.tHead;
  if (!t) return [];
  const a = [];
  return t.querySelectorAll("th").forEach((r) => {
    var c;
    const o = ((c = r.textContent) != null ? c : "").replace(/\s+/g, " ").trim(), s = r.dataset.axeTitle !== void 0 && r.dataset.axeTitle === r.getAttribute("title");
    o !== "" && !r.querySelector(nc) && r.scrollWidth > r.clientWidth + 1 ? (a.push({ label: o, short: r.scrollWidth - r.clientWidth, sortMark: r.dataset.axeSort !== void 0 }), (!r.hasAttribute("title") || s) && (r.getAttribute("title") !== o && r.setAttribute("title", o), r.dataset.axeTitle !== o && (r.dataset.axeTitle = o))) : s && (r.removeAttribute("title"), delete r.dataset.axeTitle);
  }), a;
}
const Cr = Bn(null), rc = "_card_1j6er_2", oc = "_grow_1j6er_24", sc = "_head_1j6er_26", lc = "_title_1j6er_35", cc = "_trailing_1j6er_36", ic = "_scroll_1j6er_6", uc = "_foot_1j6er_54", mc = "_strip_1j6er_56", dc = "_pager_1j6er_58", fc = "_spacer_1j6er_60", pc = "_table_1j6er_62", _c = "_fixed_1j6er_63", yc = "_fz_1j6er_81", bc = "_fzEdge_1j6er_93", Ec = "_frozen_1j6er_100", hc = "_sr_1j6er_162", gc = "_statusCell_1j6er_43", vc = "_status_1j6er_43", kc = "_st_error_1j6er_244", wc = "_stIcon_1j6er_245", Nc = "_spin_1j6er_251", $c = "_axeSpin_1j6er_1", xc = "_busy_1j6er_261", Dc = "_statusRow_1j6er_263", Ac = "_busyBar_1j6er_264", Cc = "_axeBusy_1j6er_1", ce = {
  card: rc,
  grow: oc,
  head: sc,
  title: lc,
  trailing: cc,
  scroll: ic,
  foot: uc,
  strip: mc,
  pager: dc,
  spacer: fc,
  table: pc,
  fixed: _c,
  fz: yc,
  fzEdge: bc,
  frozen: Ec,
  sr: hc,
  statusCell: gc,
  status: vc,
  st_error: kc,
  stIcon: wc,
  spin: Nc,
  axeSpin: $c,
  busy: xc,
  statusRow: Dc,
  busyBar: Ac,
  axeBusy: Cc
}, Sc = 120;
function Mc(e) {
  if (!e || !e.length) return;
  let t = 0, a = 0;
  for (const r of e)
    if (r == null) a += 1;
    else if (typeof r == "number") t += r;
    else if (/^\d+(\.\d+)?px$/.test(r)) t += parseFloat(r);
    else return;
  return a > 0 ? t + a * Sc : void 0;
}
function xa({ cols: e }) {
  return !e || !e.length ? null : /* @__PURE__ */ n.createElement("colgroup", null, e.map((t, a) => /* @__PURE__ */ n.createElement("col", { key: a, style: t == null ? void 0 : { width: t } })));
}
const Ut = /* @__PURE__ */ new Set();
function ya() {
  var e;
  return typeof process != "undefined" && ((e = process.env) != null && e.NODE_ENV) ? process.env.NODE_ENV !== "production" : typeof location != "undefined" && /^(localhost|127.0.0.1|[::1])$/.test(location.hostname);
}
function qc(e) {
  if (!ya() || !e || e.getAttribute("aria-label") || e.getAttribute("aria-labelledby")) return;
  const t = Array.from(e.querySelectorAll("thead th")).slice(0, 4).map((r) => {
    var o;
    return (o = r.textContent) == null ? void 0 : o.trim();
  }).filter(Boolean), a = `unnamed|${t.join("|")}`;
  Ut.has(a) || (Ut.add(a), console.warn(`[AXErpGrid] 표 이름이 없습니다 — aria-label(예 「전표 목록」)을 주세요. 머리글: ${t.join(" · ")}`));
}
function Tc(e) {
  if (!ya()) return;
  const t = [];
  if (e.querySelectorAll("td.axe-money").forEach((r) => {
    var o, s;
    r.scrollWidth > r.clientWidth + 1 && t.push((s = (o = r.textContent) == null ? void 0 : o.trim()) != null ? s : "");
  }), !t.length) return;
  const a = t.slice(0, 5).join("|");
  Ut.has(a) || (Ut.add(a), console.warn(
    `[AXErpGrid] 금액 셀 ${t.length}개가 컬럼 폭을 넘어 말줄임됩니다 — cols 를 moneyColWidth() 로 계산하세요.`,
    t.slice(0, 5)
  ));
}
function Bc(e) {
  if (!ya() || !e.length) return;
  const t = `head|${e.map((r) => r.label).join("|")}`;
  if (Ut.has(t)) return;
  Ut.add(t);
  const a = e.some((r) => r.sortMark) ? " (정렬 표시 ↕ 약 15px 포함)" : "";
  console.warn(
    `[AXErpGrid] 머리글 ${e.length}개가 열 폭보다 길어 잘립니다 — cols 를 넓히세요${a}:`,
    e.map((r) => `${r.label} +${Math.ceil(r.short)}px`).join(", ")
  );
}
function Da(e, t, a) {
  if (!e) return;
  const r = /* @__PURE__ */ new Map();
  for (const o of Array.from(e.rows)) {
    r.forEach((l, c) => {
      l <= 1 ? r.delete(c) : r.set(c, l - 1);
    });
    let s = 0;
    for (const l of Array.from(o.cells)) {
      for (; r.has(s); ) s += 1;
      const c = l.colSpan || 1, i = t > 0 && s + c <= t;
      if (l.classList.toggle(ce.fz, i), l.classList.toggle(ce.fzEdge, i && s + c === t), l.style.left = i ? `${a[s]}px` : "", l.rowSpan > 1) for (let m = s; m < s + c; m += 1) r.set(m, l.rowSpan);
      s += c;
    }
  }
}
function Lc({
  cols: e,
  footer: t,
  pagination: a,
  title: r,
  trailing: o,
  grow: s,
  fixed: l,
  stickyCols: c = 0,
  busy: i,
  tableRole: m,
  "aria-label": u,
  sortable: f = !0,
  sort: p,
  onSort: _,
  manualSort: y,
  className: d = "",
  children: b
}) {
  const N = l || e !== void 0 && e.length > 0, $ = N ? Mc(e) : void 0, { stick: g, offsets: x } = ke(() => {
    const R = Math.max(Math.trunc(c), 0), z = [];
    if (R === 0 || !e) return { stick: 0, offsets: z };
    let G = 0, X = 0;
    for (let W = 0; W < R; W += 1) {
      const ie = e[W];
      if (typeof ie != "number") break;
      z.push(G), G += ie, X += 1;
    }
    return { stick: X, offsets: z };
  }, [e, c]), h = [ce.table, N ? ce.fixed : "", g > 0 ? ce.frozen : ""].filter(Boolean).join(" "), w = B(null), E = B(null), D = B(null), C = B(null), q = B(0), M = B(0), I = ke(() => ({
    scrollRef: w,
    colCount: e == null ? void 0 : e.length,
    registerVirtual: () => (M.current += 1, () => {
      M.current -= 1;
    })
  }), [e == null ? void 0 : e.length]), [T, F] = A(null), Y = p !== void 0 ? p : T, [H, j] = A(""), ne = B(Ql()), te = () => {
    const R = w.current, z = D.current, G = C.current;
    if (!R || !z || !G) return;
    const X = R.scrollWidth;
    G.style.width = X + "px", z.style.display = X > R.clientWidth + 1 ? "" : "none";
    const W = R.offsetWidth - R.clientWidth;
    z.style.paddingRight = W + "px", E.current && (E.current.style.paddingRight = W + "px"), Tc(R), Bc(ac(R.querySelector("table")));
  };
  U(() => {
    const R = w.current;
    if (!R) return;
    const z = new wr(R, te);
    return qc(R.querySelector("table")), () => z.detach();
  }, []), $e(() => {
    var R, z, G, X, W;
    (g > 0 || q.current > 0) && (Da((z = (R = w.current) == null ? void 0 : R.querySelector("table")) != null ? z : null, g, x), Da((X = (G = E.current) == null ? void 0 : G.querySelector("table")) != null ? X : null, g, x)), q.current = g, (W = w.current) == null || W.querySelectorAll("thead th:not([scope])").forEach((ie) => ie.setAttribute("scope", "col")), v(), te();
  });
  function v() {
    var X;
    const R = (X = w.current) == null ? void 0 : X.querySelector("table");
    if (!R) return;
    const z = f ? Yl(R) : [];
    R.querySelectorAll("thead th[data-axe-sort]").forEach((W) => {
      z.some((ie) => ie.th === W) || (W.removeAttribute("data-axe-sort"), W.removeAttribute("aria-sort"), W.removeAttribute("tabindex"));
    }), z.forEach(({ th: W, key: ie }) => {
      W.dataset.axeSort !== ie && (W.dataset.axeSort = ie);
      const Oe = $r(Y, ie);
      W.getAttribute("aria-sort") !== Oe && W.setAttribute("aria-sort", Oe), W.hasAttribute("tabindex") || W.setAttribute("tabindex", "0");
    });
    const G = Y && z.find((W) => W.key === Y.key);
    tc(R, Y && G && !y && M.current === 0 ? { col: G.col, dir: Y.dir } : null, ne.current);
  }
  const P = (R) => {
    var W;
    const z = R.dataset.axeSort;
    if (z === void 0) return;
    const G = Nr(Y, z), X = ((W = R.textContent) != null ? W : "").replace(/\s+/g, " ").trim();
    j(xr(G, () => X)), p === void 0 && F(G), _ == null || _(G);
  }, V = (R) => {
    var X, W;
    const z = R, G = (X = z.closest) == null ? void 0 : X.call(z, "thead th[data-axe-sort]");
    return !G || !((W = w.current) != null && W.contains(G)) || z !== G && z.closest('input, select, textarea, button, a[href], [role="button"]') ? null : G;
  }, Q = (R) => {
    const z = V(R.target);
    z && P(z);
  }, se = (R) => {
    if (R.key !== "Enter" && R.key !== " ") return;
    const z = V(R.target);
    !z || R.target !== z || (R.preventDefault(), P(z));
  }, L = (R) => {
    const z = R.target.scrollLeft;
    w.current && (w.current.scrollLeft = z), E.current && (E.current.scrollLeft = z);
  }, Z = (R) => {
    const z = R.target.scrollLeft;
    E.current && (E.current.scrollLeft = z), D.current && (D.current.scrollLeft = z);
  };
  return /* @__PURE__ */ n.createElement("div", { className: [ce.card, s ? ce.grow : "", i ? ce.busy : "", d].filter(Boolean).join(" ") }, i && /* @__PURE__ */ n.createElement("div", { className: ce.busyBar, "aria-hidden": "true" }), (r !== void 0 || o !== void 0) && /* @__PURE__ */ n.createElement("header", { className: ce.head }, /* @__PURE__ */ n.createElement("span", { className: ce.title }, r), o && /* @__PURE__ */ n.createElement("span", { className: ce.trailing }, o)), /* @__PURE__ */ n.createElement("div", { className: ce.scroll, ref: w, onScroll: Z }, /* @__PURE__ */ n.createElement(
    "table",
    {
      className: h,
      role: m && m !== "table" ? m : void 0,
      "aria-busy": i || void 0,
      "aria-label": u != null ? u : typeof r == "string" && r ? r : void 0,
      style: $ ? { minWidth: $ } : void 0,
      onClick: f ? Q : void 0,
      onKeyDown: f ? se : void 0
    },
    /* @__PURE__ */ n.createElement(xa, { cols: e }),
    /* @__PURE__ */ n.createElement(Cr.Provider, { value: I }, b)
  )), t && /* @__PURE__ */ n.createElement("div", { className: ce.foot, ref: E }, /* @__PURE__ */ n.createElement("table", { className: h, style: $ ? { minWidth: $ } : void 0 }, /* @__PURE__ */ n.createElement(xa, { cols: e }), /* @__PURE__ */ n.createElement("tbody", null, t))), /* @__PURE__ */ n.createElement("div", { className: ce.strip, ref: D, onScroll: L }, /* @__PURE__ */ n.createElement("div", { ref: C, className: ce.spacer })), a && /* @__PURE__ */ n.createElement("div", { className: ce.pager }, a), f && /* @__PURE__ */ n.createElement("span", { className: ce.sr, role: "status", "aria-live": "polite" }, H));
}
const jc = 600;
function Aa(e) {
  const { count: t, rowHeight: a, scrollTop: r, bodyTop: o } = e;
  if (!(t > 0) || !(a > 0)) return { start: 0, end: 0 };
  const s = e.viewport > 0 ? e.viewport : jc, l = Math.max(0, Math.trunc(e.overscan)), c = Math.min(t - 1, Math.max(0, Math.floor((r - o) / a))), i = Math.ceil(s / a) + 1;
  return {
    start: Math.max(0, c - l),
    end: Math.min(t, c + i + l)
  };
}
function Ic(e, t, a) {
  return {
    top: a.start * t,
    bottom: Math.max(0, e - a.end) * t
  };
}
function Rc(e, t) {
  return e.start === t.start && e.end === t.end;
}
const Ca = /* @__PURE__ */ new Set();
function Sa({ height: e, colSpan: t }) {
  return e <= 0 ? null : /* @__PURE__ */ n.createElement("tr", { "aria-hidden": "true", "data-sort-fixed": "", "data-virtual-spacer": "", style: { height: e } }, /* @__PURE__ */ n.createElement("td", { colSpan: t, style: { height: e, padding: 0, border: 0 } }));
}
function E0({
  rows: e,
  rowHeight: t,
  renderRow: a,
  getKey: r,
  overscan: o = 6,
  colSpan: s,
  headerRows: l = 1,
  className: c
}) {
  var h;
  const i = Tn(Cr), m = B(null), [u, f] = A(() => Aa({
    count: e.length,
    rowHeight: t,
    scrollTop: 0,
    viewport: 0,
    bodyTop: 0,
    overscan: o
  })), p = e.length, [_, y] = A(null), d = _ && _.of === t ? _.px : t;
  $e(() => i ? i.registerVirtual() : void 0, [i]), $e(() => {
    var E;
    const w = (E = m.current) == null ? void 0 : E.closest("table");
    if (w)
      return w.setAttribute("aria-rowcount", String(p + l)), () => w.removeAttribute("aria-rowcount");
  }, [p, l]), U(() => {
    const w = i == null ? void 0 : i.scrollRef.current, E = m.current;
    if (!w || !E) return;
    const D = () => {
      const q = E.getBoundingClientRect().top - w.getBoundingClientRect().top + w.scrollTop, M = Aa({ count: p, rowHeight: d, scrollTop: w.scrollTop, viewport: w.clientHeight, bodyTop: q, overscan: o });
      f((I) => Rc(I, M) ? I : M);
    };
    D(), w.addEventListener("scroll", D, { passive: !0 });
    const C = typeof ResizeObserver == "function" ? new ResizeObserver(D) : null;
    return C ? C.observe(w) : window.addEventListener("resize", D), () => {
      w.removeEventListener("scroll", D), C ? C.disconnect() : window.removeEventListener("resize", D);
    };
  }, [i, p, d, o]), $e(() => {
    var D, C, q;
    const w = (D = m.current) == null ? void 0 : D.querySelector("tr:not([data-virtual-spacer])"), E = (C = w == null ? void 0 : w.getBoundingClientRect().height) != null ? C : 0;
    !(E > 0) || Math.abs(E - d) <= 0.25 || (y({ of: t, px: E }), typeof process != "undefined" && ((q = process.env) == null ? void 0 : q.NODE_ENV) !== "production" && Math.abs(E - t) > 2 && !Ca.has(t) && (Ca.add(t), console.warn(`[AXErpVirtualBody] 실제 행 높이(${Math.round(E)}px)가 rowHeight(${t}px)와 많이 다릅니다 — 행마다 높이가 다르면 스크롤 위치가 어긋납니다. 셀 CSS 로 높이를 고정하세요.`)));
  }, [d, t, p]);
  const b = Math.min(u.end, p), N = Math.min(u.start, b), $ = Ic(p, d, { start: N, end: b }), g = (h = s != null ? s : i == null ? void 0 : i.colCount) != null ? h : 1, x = [];
  for (let w = N; w < b; w += 1) {
    const E = a(e[w], w), D = r ? r(e[w], w) : w;
    x.push(un(E) ? fa(E, { key: D, "aria-rowindex": w + 1 + l }) : E);
  }
  return /* @__PURE__ */ n.createElement("tbody", { ref: m, className: c, "data-virtual": "" }, /* @__PURE__ */ n.createElement(Sa, { height: $.top, colSpan: g }), x, /* @__PURE__ */ n.createElement(Sa, { height: $.bottom, colSpan: g }));
}
const Oc = 7.09, Pc = 3.88, zc = 4.46, Xc = 16, Fc = 2;
function Hc(e, t = {}) {
  var s;
  const a = Math.max(1, e), r = Math.floor((a - 1) / 3), o = a * Oc + r * Pc + (t.negative ? zc : 0) + Xc + Fc;
  return Math.max(Math.ceil(o), (s = t.min) != null ? s : 0);
}
function h0(e, t = {}) {
  var o, s;
  let a = 0, r = (o = t.negative) != null ? o : !1;
  for (const l of e) {
    if (l == null || l === "") continue;
    const c = typeof l == "number" ? l : Number(String(l).replace(/[^\d.-]/g, ""));
    if (!Number.isFinite(c)) continue;
    c < 0 && (r = !0);
    const i = Math.floor(Math.abs(c)).toString().length;
    i > a && (a = i);
  }
  return a === 0 ? Math.max((s = t.min) != null ? s : 96, 96) : Hc(a, { ...t, negative: r });
}
function g0(e) {
  const t = document.createElement("span");
  t.style.cssText = "position:absolute;visibility:hidden;white-space:nowrap", e.appendChild(t);
  const a = (l) => (t.textContent = l, t.getBoundingClientRect().width), r = a("000000000000"), o = a("000,000,000,000"), s = a("-000,000,000,000");
  return t.remove(), { digit: r / 12, comma: (o - r) / 3, minus: s - o };
}
const Dt = 12, Wc = 1.06, Kc = 16, Uc = 4;
function Gc(e) {
  var a;
  const t = (a = e.codePointAt(0)) != null ? a : 0;
  return t >= 4352 && (t <= 4607 || t >= 11904 && t <= 55295 || t >= 63744 && t <= 64255 || t >= 65280 && t <= 65519) ? Dt : e === " " ? Dt * 0.3 : /[0-9]/.test(e) ? Dt * 0.56 : /[A-Z]/.test(e) ? Dt * 0.68 : /[a-z]/.test(e) ? Dt * 0.56 : /[.,:;'|!]/.test(e) ? Dt * 0.3 : Dt * 0.6;
}
function Yc(e, t = !1) {
  let a = 0;
  for (const r of e) a += Gc(r);
  return t ? a * Wc : a;
}
function v0(e, t = {}) {
  var s, l, c;
  let a = 0;
  for (const i of e) {
    if (!i) continue;
    const m = Yc(i, t.bold);
    m > a && (a = m);
  }
  const r = (s = t.min) != null ? s : 64;
  if (a === 0) return r;
  const o = Math.ceil(a + Kc + ((l = t.extra) != null ? l : 0) + Uc);
  return Math.min(Math.max(o, r), (c = t.max) != null ? c : 1 / 0);
}
function Sr({
  colSpan: e,
  loading: t,
  error: a,
  count: r,
  empty: o = io(),
  idle: s = "조회조건을 정하고 조회하세요",
  loadingText: l = "조회 중…",
  className: c = ""
}) {
  const i = a != null && a !== !1 && a !== "", m = r == null || r === 0, u = a === !0 ? "조회하지 못했습니다 — 위 오류 안내를 확인한 뒤 다시 조회하세요" : a;
  let f;
  if (i) f = "error";
  else if (t && m) f = "loading";
  else if (r == null) {
    if (s === null) return null;
    f = "idle";
  } else if (r === 0) f = "empty";
  else return null;
  const p = /* @__PURE__ */ n.createElement(n.Fragment, null, f === "loading" && /* @__PURE__ */ n.createElement("span", { className: ce.spin, "aria-hidden": "true" }), f === "error" && /* @__PURE__ */ n.createElement("span", { className: ce.stIcon, "aria-hidden": "true" }, "!"), /* @__PURE__ */ n.createElement("span", null, f === "error" ? u : f === "loading" ? l : f === "idle" ? s : o)), _ = /* @__PURE__ */ n.createElement("div", { className: [ce.status, ce[`st_${f}`]].join(" "), role: "status" }, p);
  return e === void 0 ? /* @__PURE__ */ n.createElement("div", { className: c || void 0, "data-state": f }, _) : /* @__PURE__ */ n.createElement("tr", { className: [ce.statusRow, c].filter(Boolean).join(" "), "data-state": f }, /* @__PURE__ */ n.createElement("td", { colSpan: e, className: ce.statusCell }, _));
}
function k0({ colSpan: e, text: t, className: a }) {
  return /* @__PURE__ */ n.createElement(Sr, { colSpan: e, count: 0, empty: t, className: a });
}
function Vc(e, t) {
  return {
    tabIndex: 0,
    "aria-current": t ? "true" : void 0,
    onKeyDown: (a) => {
      a.target === a.currentTarget && (a.key === "Enter" || a.key === " ") && (a.preventDefault(), e());
    }
  };
}
const Qc = "_cell_n9rrj_1", Jc = "_toggle_n9rrj_2", Zc = "_spacer_n9rrj_8", ei = "_label_n9rrj_9", ti = "_dim_n9rrj_10", Zt = {
  cell: Qc,
  toggle: Jc,
  spacer: Zc,
  label: ei,
  dim: ti
};
function w0(e, { id: t, parentId: a, defaultOpen: r = !0 }) {
  const [o, s] = A(() => /* @__PURE__ */ new Set()), [l, c] = A(() => /* @__PURE__ */ new Set()), { parents: i, kids: m } = ke(() => {
    const _ = /* @__PURE__ */ new Map(), y = /* @__PURE__ */ new Set(), d = new Set(e.map((b) => String(t(b))));
    for (const b of e) {
      const N = a(b), $ = N == null || !d.has(String(N)) ? null : String(N);
      _.set(String(t(b)), $), $ && y.add($);
    }
    return { parents: _, kids: y };
  }, [e, t, a]), u = re((_) => r ? !o.has(_) : l.has(_), [r, o, l]), f = ke(() => e.filter((_) => {
    var b, N;
    let y = (b = i.get(String(t(_)))) != null ? b : null;
    const d = /* @__PURE__ */ new Set();
    for (; y && !d.has(y); ) {
      if (!u(y)) return !1;
      d.add(y), y = (N = i.get(y)) != null ? N : null;
    }
    return !0;
  }), [e, i, t, u]), p = re((_, y) => {
    const d = (b, N) => {
      const $ = new Set(b);
      return N ? $.add(_) : $.delete(_), $;
    };
    r ? s((b) => d(b, !y)) : c((b) => d(b, y));
  }, [r]);
  return {
    visible: f,
    hasChildren: (_) => m.has(String(t(_))),
    isOpen: (_) => u(String(t(_))),
    toggle: (_) => {
      const y = String(t(_));
      p(y, !u(y));
    },
    expandAll: () => {
      s(/* @__PURE__ */ new Set()), c(new Set(m));
    },
    collapseAll: () => {
      s(new Set(m)), c(/* @__PURE__ */ new Set());
    },
    expandAllTemporarily: () => {
      const _ = o, y = l;
      return s(/* @__PURE__ */ new Set()), c(new Set(m)), () => {
        s(_), c(y);
      };
    },
    reveal: (_) => {
      var b, N;
      let y = (b = i.get(String(_))) != null ? b : null;
      const d = /* @__PURE__ */ new Set();
      for (; y && !d.has(y); )
        p(y, !0), d.add(y), y = (N = i.get(y)) != null ? N : null;
    }
  };
}
function N0({ depth: e, hasChildren: t, open: a, onToggle: r, dim: o, toggleOutOfTabOrder: s, title: l, csvPath: c, children: i }) {
  const m = (f) => {
    f.stopPropagation(), r();
  }, u = l != null ? l : typeof i == "string" ? i : void 0;
  return /* @__PURE__ */ n.createElement(
    "span",
    {
      className: [Zt.cell, o ? Zt.dim : ""].filter(Boolean).join(" "),
      style: { paddingLeft: e * 16 },
      "data-tree-depth": e,
      "data-csv-path": c
    },
    t ? /* @__PURE__ */ n.createElement(
      "button",
      {
        type: "button",
        className: Zt.toggle,
        "aria-expanded": a,
        "aria-label": `${u ? `${u} ` : ""}${a ? "하위 접기" : "하위 펼치기"}`,
        onClick: m,
        tabIndex: s ? -1 : void 0,
        "data-csv-skip": ""
      },
      a ? "▾" : "▸"
    ) : /* @__PURE__ */ n.createElement("span", { className: Zt.spacer, "aria-hidden": "true" }),
    /* @__PURE__ */ n.createElement("span", { className: Zt.label, title: u }, i)
  );
}
function ni(e, t, a, r = !1) {
  const o = e[t.r];
  if (!o || t.i < 0 || t.i >= o.length) return null;
  const s = o[t.i], l = e.findIndex((i) => i.length > 0);
  let c = -1;
  for (let i = e.length - 1; i >= 0; i--) if (e[i].length > 0) {
    c = i;
    break;
  }
  switch (a) {
    case "ArrowLeft":
      return t.i > 0 ? { r: t.r, i: t.i - 1 } : null;
    case "ArrowRight":
      return t.i < o.length - 1 ? { r: t.r, i: t.i + 1 } : null;
    case "Home":
      return r ? { r: l, i: 0 } : { r: t.r, i: 0 };
    case "End":
      return r ? { r: c, i: e[c].length - 1 } : { r: t.r, i: o.length - 1 };
    case "ArrowUp":
    case "ArrowDown": {
      const i = a === "ArrowUp" ? -1 : 1;
      for (let m = t.r + i; m >= 0 && m < e.length; m += i)
        if (e[m].length > 0) return { r: m, i: ai(e[m], s) };
      return null;
    }
    default:
      return null;
  }
}
function ai(e, t) {
  let a = 0;
  for (let r = 1; r < e.length; r++)
    Math.abs(e[r] - t) < Math.abs(e[a] - t) && (a = r);
  return a;
}
function $0(e, t = {}) {
  var c;
  const a = (c = t.cellSelector) != null ? c : "[data-roving]", r = t.initialSelector, o = B(null), [s, l] = A(null);
  U(() => {
    e.current !== s && l(e.current);
  }), U(() => {
    if (!s) return;
    const i = () => Array.from(s.querySelectorAll(a)), m = () => {
      const y = i();
      if (!y.length) {
        o.current = null;
        return;
      }
      (!o.current || !y.includes(o.current)) && (o.current = r && y.find((d) => d.matches(r)) || y[0]), y.forEach((d) => {
        const b = d === o.current ? "0" : "-1";
        d.getAttribute("tabindex") !== b && d.setAttribute("tabindex", b);
      });
    }, u = () => {
      const y = i(), d = [], b = [], N = /* @__PURE__ */ new Map(), $ = [];
      return y.forEach((g) => {
        var q;
        const x = g.tagName === "TR", h = x ? null : g.closest("td, th"), w = h && s.contains(h) ? h.parentElement : null, E = x ? g : (q = w != null ? w : g.parentElement) != null ? q : s;
        let D = d.indexOf(E);
        D < 0 && (D = d.length, d.push(E), b.push([]), $.push([]));
        let C;
        if (x)
          C = 0;
        else if (h && w) {
          C = 0;
          for (const M of Array.from(w.cells)) {
            if (M === h) break;
            C += Math.max(1, M.colSpan || 1);
          }
        } else
          C = b[D].length;
        N.set(g, { r: D, i: b[D].length }), b[D].push(C), $[D].push(g);
      }), { rows: b, where: N, byPos: $ };
    }, f = (y) => {
      var w;
      const d = y.target;
      if (!d || !d.matches(a) || !s.contains(d) || y.altKey || y.metaKey || d.tagName === "TR" && (y.key === "ArrowLeft" || y.key === "ArrowRight")) return;
      const { rows: b, where: N, byPos: $ } = u(), g = N.get(d);
      if (!g) return;
      const x = ni(b, g, y.key, y.ctrlKey);
      if (x === null) {
        ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight", "Home", "End"].includes(y.key) && y.preventDefault();
        return;
      }
      y.preventDefault();
      const h = (w = $[x.r]) == null ? void 0 : w[x.i];
      h && (o.current = h, m(), h.focus());
    }, p = (y) => {
      const d = y.target;
      !d || !d.matches(a) || d === o.current || (o.current = d, m());
    };
    m(), s.addEventListener("keydown", f), s.addEventListener("focusin", p);
    const _ = typeof MutationObserver != "undefined" ? new MutationObserver(m) : null;
    return _ == null || _.observe(s, { childList: !0, subtree: !0 }), () => {
      s.removeEventListener("keydown", f), s.removeEventListener("focusin", p), _ == null || _.disconnect();
    };
  }, [s, a, r]);
}
const ri = "_btn_r1trx_1", oi = "_mark_r1trx_7", si = "_sr_r1trx_9", aa = {
  btn: ri,
  mark: oi,
  sr: si
};
function x0({ sortKey: e, sort: t, onSort: a, children: r, className: o = "", colSpan: s, style: l, title: c }) {
  const i = $r(t, e);
  return /* @__PURE__ */ n.createElement("th", { scope: "col", "aria-sort": i, colSpan: s, style: l, title: c, className: o }, /* @__PURE__ */ n.createElement("button", { type: "button", className: aa.btn, onClick: () => a(Nr(t, e)) }, /* @__PURE__ */ n.createElement("span", null, r), /* @__PURE__ */ n.createElement("span", { className: aa.mark, "aria-hidden": "true" }, i === "ascending" ? "▲" : i === "descending" ? "▼" : "↕")));
}
function D0({ sort: e, labelOf: t }) {
  return /* @__PURE__ */ n.createElement("span", { className: aa.sr, role: "status", "aria-live": "polite" }, xr(e, t));
}
const li = "_card_14vt3_1", ci = "_accent_14vt3_8", ii = "_grow_14vt3_9", ui = "_head_14vt3_11", mi = "_body_14vt3_20", di = "_title_14vt3_28", fi = "_trailing_14vt3_29", pi = "_summary_14vt3_32", _i = "_sumHead_14vt3_33", yi = "_sumTotal_14vt3_42", bi = "_tone_warn_14vt3_43", Ei = "_tone_ok_14vt3_44", hi = "_sumList_14vt3_46", gi = "_sumEm_14vt3_55", vi = "_sumFoot_14vt3_57", ki = "_sumNote_14vt3_66", Ne = {
  card: li,
  accent: ci,
  grow: ii,
  head: ui,
  body: mi,
  title: di,
  trailing: fi,
  summary: pi,
  sumHead: _i,
  sumTotal: yi,
  tone_warn: bi,
  tone_ok: Ei,
  sumList: hi,
  sumEm: gi,
  sumFoot: vi,
  sumNote: ki
};
function Mr({
  title: e,
  trailing: t,
  accent: a,
  grow: r,
  flush: o,
  className: s = "",
  children: l
}) {
  return /* @__PURE__ */ n.createElement(
    "section",
    {
      className: [Ne.card, a ? Ne.accent : "", r ? Ne.grow : "", s].filter(Boolean).join(" "),
      "data-csv-title": typeof e == "string" && e ? e : void 0
    },
    e !== void 0 && /* @__PURE__ */ n.createElement("header", { className: Ne.head }, /* @__PURE__ */ n.createElement("span", { className: Ne.title, role: "heading", "aria-level": 2 }, e), t && /* @__PURE__ */ n.createElement("span", { className: Ne.trailing }, t)),
    o ? l : /* @__PURE__ */ n.createElement("div", { className: ["axe-card-body", Ne.body].join(" ") }, l)
  );
}
function A0({
  title: e,
  total: t,
  items: a,
  footerLabel: r,
  footerValue: o,
  note: s,
  tone: l = "default",
  children: c
}) {
  return /* @__PURE__ */ n.createElement("section", { className: [Ne.card, Ne.accent, Ne.summary, Ne[`tone_${l}`]].join(" ") }, /* @__PURE__ */ n.createElement("header", { className: Ne.sumHead }, /* @__PURE__ */ n.createElement("span", null, e), t !== void 0 && /* @__PURE__ */ n.createElement("strong", { className: Ne.sumTotal }, t)), /* @__PURE__ */ n.createElement("ul", { className: Ne.sumList }, a.map((i, m) => {
    var u;
    return /* @__PURE__ */ n.createElement("li", { key: (u = i.key) != null ? u : m, className: i.em ? Ne.sumEm : "" }, /* @__PURE__ */ n.createElement("span", null, i.label), /* @__PURE__ */ n.createElement("strong", null, i.value));
  })), c, r !== void 0 && /* @__PURE__ */ n.createElement("footer", { className: Ne.sumFoot }, /* @__PURE__ */ n.createElement("span", null, r), /* @__PURE__ */ n.createElement("strong", null, o)), s && /* @__PURE__ */ n.createElement("div", { className: Ne.sumNote }, s));
}
let wi = 0;
function Qt(e = "axe") {
  const t = B(null);
  return t.current || (t.current = `${e}-${++wi}`), t.current;
}
const Ni = "_sr_1y2mv_2", $i = "_skip_1y2mv_8", xi = "_crit_1y2mv_16", Di = "_c_danger_1y2mv_21", Ai = "_c_warn_1y2mv_22", Ci = "_critI_1y2mv_23", Si = "_critBody_1y2mv_24", Mi = "_critX_1y2mv_25", qi = "_ch_1y2mv_32", Ti = "_chBtn_1y2mv_33", Bi = "_chBox_1y2mv_43", Qe = {
  sr: Ni,
  skip: $i,
  crit: xi,
  c_danger: Di,
  c_warn: Ai,
  critI: Ci,
  critBody: Si,
  critX: Mi,
  ch: qi,
  chBtn: Ti,
  chBox: Bi
};
function qr({ as: e = "span", children: t, id: a }) {
  return /* @__PURE__ */ n.createElement(e, { className: Qe.sr, id: a }, t);
}
function C0({ targets: e = [{ label: "본문 바로가기", targetId: "axe-main" }], className: t = "" }) {
  const a = (r, o) => {
    const s = document.getElementById(o);
    s && (r.preventDefault(), s.hasAttribute("tabindex") || s.setAttribute("tabindex", "-1"), s.focus(), s.scrollIntoView({ block: "start" }));
  };
  return /* @__PURE__ */ n.createElement("nav", { className: [Qe.skip, t].filter(Boolean).join(" "), "aria-label": "건너뛰기" }, e.slice(0, 3).map((r) => /* @__PURE__ */ n.createElement("a", { key: r.targetId, href: `#${r.targetId}`, onClick: (o) => a(o, r.targetId) }, r.label)));
}
function S0({ title: e, children: t, tone: a = "danger", onClose: r, className: o = "" }) {
  return /* @__PURE__ */ n.createElement("div", { className: [Qe.crit, Qe[`c_${a}`], o].filter(Boolean).join(" "), role: "alert" }, /* @__PURE__ */ n.createElement("span", { className: Qe.critI, "aria-hidden": "true" }, "▲"), /* @__PURE__ */ n.createElement("div", { className: Qe.critBody }, /* @__PURE__ */ n.createElement("b", null, e), t ? /* @__PURE__ */ n.createElement("span", null, " ", t) : null), r && /* @__PURE__ */ n.createElement("button", { type: "button", className: Qe.critX, onClick: r, "aria-label": "알림 닫기" }, "✕"));
}
function M0({ label: e, children: t, className: a = "" }) {
  const [r, o] = A(!1), s = Qt("axe-ch"), l = B(null), c = B(null);
  return U(() => {
    if (!r) return;
    const i = (u) => {
      l.current && !l.current.contains(u.target) && o(!1);
    }, m = (u) => {
      var f;
      u.key !== "Escape" || u.isComposing || (u.preventDefault(), u.stopPropagation(), o(!1), (f = c.current) == null || f.focus());
    };
    return document.addEventListener("mousedown", i), document.addEventListener("keydown", m, !0), () => {
      document.removeEventListener("mousedown", i), document.removeEventListener("keydown", m, !0);
    };
  }, [r]), /* @__PURE__ */ n.createElement("span", { className: [Qe.ch, a].filter(Boolean).join(" "), ref: l }, /* @__PURE__ */ n.createElement(
    "button",
    {
      ref: c,
      type: "button",
      className: Qe.chBtn,
      "aria-label": e,
      "aria-expanded": r,
      "aria-controls": s,
      onClick: () => o((i) => !i)
    },
    "?"
  ), r && /* @__PURE__ */ n.createElement("span", { id: s, role: "region", "aria-label": e, className: Qe.chBox }, t));
}
function ra(e, t, a = "codeName") {
  const r = (e != null ? e : "").trim();
  if (!r) return "";
  const o = (t != null ? t : "").trim();
  return !o || a === "code" ? r : a === "name" ? o : `${r}. ${o}`;
}
function Li(e, t = "전체", a = "codeName") {
  if (e.length === 0) return t;
  const r = ra(e[0].cd, e[0].nm, a);
  return e.length === 1 ? r : `${r} 외 ${e.length - 1}건`;
}
function ji(e, t, a, r) {
  const o = (e != null ? e : "").trim();
  if (!o) return null;
  if (t && t.name && t.code === o) return t.name;
  if (a && a.code === o && a.name) return a.name;
  const s = r == null ? void 0 : r.find((l) => l.code === o);
  return s && s.name ? s.name : null;
}
const Ii = "_root_g2b1p_1", Ri = "_rootNone_g2b1p_5", Oi = "_field_g2b1p_12", Pi = "_codeInput_g2b1p_13", zi = "_nameHint_g2b1p_16", Xi = "_pickBtn_g2b1p_25", Fi = "_suggest_g2b1p_42", Hi = "_suggestList_g2b1p_48", Wi = "_suggestRow_g2b1p_49", Ki = "_suggestOn_g2b1p_50", Ui = "_suggestEmpty_g2b1p_55", Gi = "_suggestMore_g2b1p_55", Yi = "_popup_g2b1p_59", Vi = "_popupHead_g2b1p_73", Qi = "_searchRow_g2b1p_83", Ji = "_list_g2b1p_87", Zi = "_current_g2b1p_96", eu = "_empty_g2b1p_100", tu = "_summaryBtn_g2b1p_108", nu = "_ov_g2b1p_129", au = "_modal_g2b1p_140", ru = "_modalWide_g2b1p_140", ou = "_head_g2b1p_152", su = "_sub_g2b1p_160", lu = "_x_g2b1p_162", cu = "_body_g2b1p_179", iu = "_chips_g2b1p_187", uu = "_chip_g2b1p_187", mu = "_chipOn_g2b1p_201", du = "_search_g2b1p_83", fu = "_tbl_g2b1p_220", pu = "_row_g2b1p_250", _u = "_rowCursor_g2b1p_252", yu = "_rowPicked_g2b1p_253", bu = "_rowCurrent_g2b1p_254", Eu = "_curTag_g2b1p_255", hu = "_busy_g2b1p_256", gu = "_count_g2b1p_257", vu = "_chk_g2b1p_259", ku = "_tdLeft_g2b1p_260", wu = "_tdCenter_g2b1p_261", Nu = "_emptyCell_g2b1p_263", $u = "_stop_g2b1p_265", xu = "_more_g2b1p_276", Du = "_pager_g2b1p_288", Au = "_note_g2b1p_301", Cu = "_foot_g2b1p_304", Su = "_ghost_g2b1p_313", Mu = "_primary_g2b1p_325", K = {
  root: Ii,
  rootNone: Ri,
  field: Oi,
  codeInput: Pi,
  nameHint: zi,
  pickBtn: Xi,
  suggest: Fi,
  suggestList: Hi,
  suggestRow: Wi,
  suggestOn: Ki,
  suggestEmpty: Ui,
  suggestMore: Gi,
  popup: Yi,
  popupHead: Vi,
  searchRow: Qi,
  list: Ji,
  current: Zi,
  empty: eu,
  summaryBtn: tu,
  ov: nu,
  modal: au,
  modalWide: ru,
  head: ou,
  sub: su,
  x: lu,
  body: cu,
  chips: iu,
  chip: uu,
  chipOn: mu,
  search: du,
  tbl: fu,
  row: pu,
  rowCursor: _u,
  rowPicked: yu,
  rowCurrent: bu,
  curTag: Eu,
  busy: hu,
  count: gu,
  chk: vu,
  tdLeft: ku,
  tdCenter: wu,
  emptyCell: Nu,
  stop: $u,
  more: xu,
  pager: Du,
  note: Au,
  foot: Cu,
  ghost: Su,
  primary: Mu
};
function qu({
  items: e,
  value: t,
  title: a,
  popupRef: r,
  anchorRef: o,
  pos: s,
  onPick: l,
  onClose: c
}) {
  const [i, m] = A(""), u = ke(() => {
    const f = i.trim().toLowerCase();
    return f ? e.filter(
      (p) => {
        var _;
        return p.code.toLowerCase().includes(f) || p.name.toLowerCase().includes(f) || ((_ = p.sub) != null ? _ : "").toLowerCase().includes(f);
      }
    ) : e;
  }, [e, i]);
  return U(() => {
    const f = (_) => {
      const y = _.target;
      r.current && !r.current.contains(y) && o.current && !o.current.contains(y) && c();
    }, p = (_) => {
      _.key === "Escape" && c();
    };
    return document.addEventListener("mousedown", f), document.addEventListener("keydown", p), () => {
      document.removeEventListener("mousedown", f), document.removeEventListener("keydown", p);
    };
  }, [r, o, c]), /* @__PURE__ */ n.createElement(Vt, null, /* @__PURE__ */ n.createElement(
    "div",
    {
      ref: r,
      className: K.popup,
      style: { left: s.left, top: s.top },
      role: "dialog",
      "aria-label": "코드 선택"
    },
    /* @__PURE__ */ n.createElement("header", { className: K.popupHead }, /* @__PURE__ */ n.createElement("strong", null, a), /* @__PURE__ */ n.createElement("button", { type: "button", "aria-label": "닫기", onClick: c }, "✕")),
    /* @__PURE__ */ n.createElement("div", { className: K.searchRow }, /* @__PURE__ */ n.createElement(
      "input",
      {
        autoFocus: !0,
        value: i,
        "aria-label": "코드·명칭 검색",
        placeholder: "코드·명칭 검색",
        onChange: (f) => m(f.target.value),
        onKeyDown: (f) => {
          f.key === "Enter" && u.length && l(u[0]), f.key === "Escape" && c();
        }
      }
    )),
    /* @__PURE__ */ n.createElement("ul", { className: K.list }, u.map((f) => /* @__PURE__ */ n.createElement("li", { key: f.code }, /* @__PURE__ */ n.createElement("button", { type: "button", onClick: () => l(f), className: f.code === t ? K.current : "" }, /* @__PURE__ */ n.createElement("code", null, f.code), /* @__PURE__ */ n.createElement("span", null, f.name), f.sub && /* @__PURE__ */ n.createElement("small", null, f.sub)))), u.length === 0 && /* @__PURE__ */ n.createElement("li", { className: K.empty }, "검색 결과가 없습니다"))
  ));
}
const Tr = 250, hn = 7;
function Ma(e, t) {
  const a = t.trim().toLowerCase();
  if (!a) return e;
  const r = e.toLowerCase().indexOf(a);
  return r < 0 ? e : /* @__PURE__ */ n.createElement(n.Fragment, null, e.slice(0, r), /* @__PURE__ */ n.createElement("b", null, e.slice(r, r + a.length)), e.slice(r + a.length));
}
function Tu(e, t) {
  const a = e.map((r) => ({ cd: r.code, nm: r.name, sub: r.sub }));
  return {
    key: "static",
    title: typeof t == "string" ? t : "코드 선택",
    nameLabel: "명칭",
    fetch: ({ q: r }) => {
      const o = r.trim().toLowerCase();
      return o ? Promise.resolve({
        rows: a.filter(
          (s) => {
            var l;
            return s.cd.toLowerCase().includes(o) || s.nm.toLowerCase().includes(o) || String((l = s.sub) != null ? l : "").toLowerCase().includes(o);
          }
        )
      }) : Promise.resolve({ rows: a });
    }
  };
}
function Bu({
  source: e,
  items: t,
  title: a,
  multiple: r,
  selected: o,
  current: s,
  searchRef: l,
  onConfirm: c,
  onClose: i
}) {
  var se;
  const m = ke(() => Tu(t != null ? t : [], a), [t, a]), u = e != null ? e : m, [f, p] = A(""), [_, y] = A((se = e == null ? void 0 : e.defaultFilter) != null ? se : null), [d, b] = A(0), [N, $] = A([]), [g, x] = A(!1), [h, w] = A(!1), [E, D] = A(null), [C, q] = A(0), [M, I] = A(/* @__PURE__ */ new Map()), T = B(u);
  T.current = u, U(() => {
    var Z;
    p(""), y((Z = T.current.defaultFilter) != null ? Z : null), b(0), q(0), D(null), I(new Map((o != null ? o : []).map((R) => [R.cd, R])));
    const L = window.setTimeout(() => {
      l.current && l.current.focus();
    }, 30);
    return () => window.clearTimeout(L);
  }, [u.key]), U(() => {
    let L = !0;
    w(!0);
    const Z = () => {
      T.current.fetch({ q: f.trim(), ty: _, page: d }).then((z) => {
        var X, W;
        if (!L) return;
        $((X = z.rows) != null ? X : []), x(!!z.hasMore), D(null);
        const G = s ? ((W = z.rows) != null ? W : []).findIndex((ie) => ie.cd === s) : -1;
        q(G > 0 ? G : 0);
      }).catch((z) => {
        L && ($([]), x(!1), D("코드를 불러오지 못했습니다. 잠시 후 다시 조회하세요."));
      }).finally(() => {
        L && w(!1);
      });
    }, R = window.setTimeout(Z, f.trim() ? Tr : 0);
    return () => {
      L = !1, window.clearTimeout(R);
    };
  }, [u.key, f, _, d]);
  const F = B(null);
  U(() => {
    const L = F.current && F.current.children[C];
    L && "scrollIntoView" in L && L.scrollIntoView({ block: "nearest" });
  }, [C, N]);
  const Y = ke(() => {
    var Z, R;
    const L = [
      { key: "cd", label: "코드", width: (Z = u.codeWidth) != null ? Z : "96px", align: "center" },
      {
        key: "nm",
        label: u.nameLabel,
        align: "left",
        render: (z) => /* @__PURE__ */ n.createElement(n.Fragment, null, z.nm, z.useYn === !1 && /* @__PURE__ */ n.createElement("span", { className: K.stop }, "사용중단"))
      }
    ];
    return u.typeLabel && L.push({
      key: "__ty",
      label: "구분",
      width: "110px",
      align: "center",
      render: (z) => u.typeLabel ? u.typeLabel(z) : ""
    }), L.concat((R = u.extraColumns) != null ? R : []);
  }, [u]), H = re((L) => {
    I((Z) => {
      const R = new Map(Z);
      return R.has(L.cd) ? R.delete(L.cd) : R.set(L.cd, L), R;
    });
  }, []), j = re((L) => c([L]), [c]), ne = re(() => c(Array.from(M.values())), [M, c]), te = N.length > 0 && N.every((L) => M.has(L.cd)), v = () => {
    I((L) => {
      const Z = new Map(L);
      return te ? N.forEach((R) => Z.delete(R.cd)) : N.forEach((R) => Z.set(R.cd, R)), Z;
    });
  }, P = B(null);
  U(() => {
    const L = document.activeElement;
    return () => {
      window.setTimeout(() => {
        L && L.isConnected && typeof L.focus == "function" && (!document.activeElement || document.activeElement === document.body) && L.focus();
      }, 0);
    };
  }, []);
  const V = B(i);
  V.current = i, U(() => {
    const L = (Z) => {
      Z.key !== "Escape" || Z.isComposing || (Z.stopPropagation(), Z.preventDefault(), V.current());
    };
    return document.addEventListener("keydown", L, !0), () => document.removeEventListener("keydown", L, !0);
  }, []);
  const Q = (L) => {
    var z;
    if (L.nativeEvent.isComposing || L.keyCode === 229) return;
    if (L.key === "Tab" && P.current) {
      const G = Array.from(P.current.querySelectorAll("input:not([disabled]), button:not([disabled])"));
      if (G.length) {
        const X = G[0], W = G[G.length - 1], ie = document.activeElement;
        L.shiftKey && ie === X ? (L.preventDefault(), W.focus()) : !L.shiftKey && ie === W && (L.preventDefault(), X.focus());
      }
      return;
    }
    if (L.key === "Escape") {
      L.stopPropagation(), i();
      return;
    }
    const Z = L.target, R = Z === l.current;
    if (!(!R && Z !== P.current)) {
      if (L.key === "ArrowDown" || L.key === "ArrowUp") {
        L.preventDefault(), q((G) => Math.max(0, Math.min(N.length - 1, G + (L.key === "ArrowDown" ? 1 : -1))));
        return;
      }
      if (L.key === " " && r && N[C] && !(R && ((z = l.current) != null && z.value))) {
        L.preventDefault(), H(N[C]);
        return;
      }
      if (L.key === "Enter") {
        if (L.preventDefault(), h) return;
        r ? ne() : N[C] && j(N[C]);
      }
    }
  };
  return /* @__PURE__ */ n.createElement(Vt, null, /* @__PURE__ */ n.createElement("div", { className: K.ov, onClick: i }, /* @__PURE__ */ n.createElement(
    "div",
    {
      className: u.wide ? `${K.modal} ${K.modalWide}` : K.modal,
      role: "dialog",
      "aria-modal": "true",
      "aria-label": u.title,
      ref: P,
      onClick: (L) => L.stopPropagation(),
      onKeyDown: Q
    },
    /* @__PURE__ */ n.createElement("div", { className: K.head }, /* @__PURE__ */ n.createElement("h2", null, u.title), r && /* @__PURE__ */ n.createElement("span", { className: K.sub }, "복수 선택 가능"), /* @__PURE__ */ n.createElement("button", { type: "button", className: K.x, onClick: i, "aria-label": "닫기" }, "×")),
    /* @__PURE__ */ n.createElement("div", { className: K.body }, u.filters && u.filters.length > 0 && /* @__PURE__ */ n.createElement("div", { className: K.chips }, /* @__PURE__ */ n.createElement(
      "button",
      {
        type: "button",
        className: _ === null ? `${K.chip} ${K.chipOn}` : K.chip,
        onClick: () => {
          y(null), b(0);
        }
      },
      "전체"
    ), u.filters.map((L) => /* @__PURE__ */ n.createElement(
      "button",
      {
        key: L.value,
        type: "button",
        className: _ === L.value ? `${K.chip} ${K.chipOn}` : K.chip,
        onClick: () => {
          y(L.value), b(0);
        }
      },
      L.label
    ))), /* @__PURE__ */ n.createElement(
      "input",
      {
        ref: l,
        className: K.search,
        value: f,
        placeholder: "코드, 명칭 검색",
        autoComplete: "off",
        "aria-label": "코드·명칭 검색",
        onChange: (L) => {
          p(L.target.value), b(0);
        }
      }
    ), /* @__PURE__ */ n.createElement("div", { className: K.tbl }, /* @__PURE__ */ n.createElement("table", null, /* @__PURE__ */ n.createElement("thead", null, /* @__PURE__ */ n.createElement("tr", null, r && /* @__PURE__ */ n.createElement("th", { className: K.chk }, /* @__PURE__ */ n.createElement(
      "input",
      {
        type: "checkbox",
        checked: te,
        onChange: v,
        "aria-label": "표시된 행 전체 선택"
      }
    )), Y.map((L) => /* @__PURE__ */ n.createElement("th", { key: L.key, style: L.width ? { width: L.width } : void 0 }, L.label)))), /* @__PURE__ */ n.createElement("tbody", { ref: F, className: h && N.length > 0 ? K.busy : void 0, "aria-busy": h }, N.length === 0 ? /* @__PURE__ */ n.createElement("tr", null, /* @__PURE__ */ n.createElement("td", { className: K.emptyCell, colSpan: Y.length + (r ? 1 : 0) }, h ? "검색 중…" : E || u.emptyText || "검색 결과가 없습니다")) : N.map((L, Z) => /* @__PURE__ */ n.createElement(
      "tr",
      {
        key: L.cd,
        className: [
          K.row,
          Z === C ? K.rowCursor : "",
          M.has(L.cd) ? K.rowPicked : "",
          !r && s && L.cd === s ? K.rowCurrent : ""
        ].filter(Boolean).join(" "),
        "aria-selected": Z === C,
        onClick: () => {
          q(Z), r ? H(L) : j(L);
        }
      },
      r && /* @__PURE__ */ n.createElement("td", { className: K.chk }, /* @__PURE__ */ n.createElement(
        "input",
        {
          type: "checkbox",
          checked: M.has(L.cd),
          onChange: () => H(L),
          onClick: (R) => R.stopPropagation(),
          "aria-label": `${L.cd} 선택`
        }
      )),
      Y.map((R) => {
        var z, G;
        return /* @__PURE__ */ n.createElement(
          "td",
          {
            key: R.key,
            className: R.align === "left" ? K.tdLeft : K.tdCenter,
            title: R.render ? void 0 : String((z = L[R.key]) != null ? z : "")
          },
          R.render ? R.render(L) : String((G = L[R.key]) != null ? G : ""),
          R.key === "cd" && !r && s && L.cd === s && /* @__PURE__ */ n.createElement("em", { className: K.curTag }, "현재")
        );
      })
    ))))), /* @__PURE__ */ n.createElement("p", { className: K.count, role: "status", "aria-live": "polite" }, h ? "검색 중…" : E ? "" : `${N.length}건`, !r && !h && !E && N.length > 0 && " — ↑↓ 로 고르고 Enter, 또는 행을 누르세요"), (g || d > 0) && /* @__PURE__ */ n.createElement("div", { className: K.more }, /* @__PURE__ */ n.createElement("span", null, g ? "표시 상한까지만 보여 주고 있습니다 — 검색어를 좁히거나 다음 쪽으로 넘기세요" : "마지막 쪽입니다"), /* @__PURE__ */ n.createElement("span", { className: K.pager }, /* @__PURE__ */ n.createElement("button", { type: "button", disabled: d === 0, onClick: () => b((L) => Math.max(0, L - 1)) }, "이전"), /* @__PURE__ */ n.createElement("b", null, d + 1), g && /* @__PURE__ */ n.createElement("button", { type: "button", onClick: () => b((L) => L + 1) }, "다음"))), r && /* @__PURE__ */ n.createElement("p", { className: K.note }, "선택 ", /* @__PURE__ */ n.createElement("b", null, M.size), "건 — 선택이 없으면 ", /* @__PURE__ */ n.createElement("b", null, "전체"), "로 조회됩니다")),
    /* @__PURE__ */ n.createElement("div", { className: K.foot }, r && /* @__PURE__ */ n.createElement("button", { type: "button", className: K.ghost, onClick: () => I(/* @__PURE__ */ new Map()) }, "초기화"), /* @__PURE__ */ n.createElement("button", { type: "button", className: K.ghost, onClick: i }, "취소"), r && /* @__PURE__ */ n.createElement("button", { type: "button", className: K.primary, onClick: ne }, "확인"))
  )));
}
let Lu = 0;
function ju({ source: e, items: t, anchorRef: a }) {
  const [r, o] = A(null), [s, l] = A(-1), [c, i] = A(null), m = B(null), u = B(0), f = B(`axe-cp-${++Lu}`), p = B(e);
  p.current = e;
  const _ = B(t);
  _.current = t;
  const y = re(() => {
    m.current != null && (window.clearTimeout(m.current), m.current = null), u.current += 1, o(null), l(-1);
  }, []);
  U(() => y, [y]);
  const d = (b) => {
    m.current != null && window.clearTimeout(m.current), u.current += 1;
    const N = u.current;
    if (!b.trim()) {
      o(null), l(-1);
      return;
    }
    m.current = window.setTimeout(async () => {
      var x;
      let $ = [], g = !1;
      try {
        const h = p.current;
        if (h) {
          const w = await h.fetch({ q: b, ty: null, page: 0 });
          $ = w.rows, g = !!w.hasMore || $.length > hn;
        } else {
          const w = b.trim().toLowerCase();
          $ = ((x = _.current) != null ? x : []).filter((E) => {
            var D;
            return E.code.toLowerCase().includes(w) || E.name.toLowerCase().includes(w) || ((D = E.sub) != null ? D : "").toLowerCase().includes(w);
          }).map((E) => ({ cd: E.code, nm: E.name, sub: E.sub })), g = $.length > hn;
        }
      } catch {
        return;
      }
      N === u.current && (o({ rows: $.slice(0, hn), more: g, q: b }), l(-1));
    }, Tr);
  };
  return U(() => {
    if (!r) {
      i(null);
      return;
    }
    const b = () => {
      const N = a.current;
      if (!N) return;
      const $ = N.getBoundingClientRect(), g = Math.min(r.rows.length, hn) * 28 + 34, x = $.bottom + g > window.innerHeight - 8 && $.top - g - 2 > 8 ? $.top - g - 2 : $.bottom + 2, h = Math.max($.width, 260);
      i({ left: Math.max(8, Math.min($.left, window.innerWidth - h - 8)), top: x, width: h });
    };
    return b(), window.addEventListener("resize", b), window.addEventListener("scroll", b, !0), () => {
      window.removeEventListener("resize", b), window.removeEventListener("scroll", b, !0);
    };
  }, [r, a]), { sugg: r, active: s, setActive: l, suggPos: c, suggId: f, runSuggest: d, cancelSuggest: y };
}
function q0({
  value: e = "",
  name: t,
  show: a = "codeName",
  onChange: r,
  items: o,
  source: s,
  multiple: l = !1,
  selected: c,
  onConfirm: i,
  current: m,
  trigger: u,
  emptyLabel: f = "전체",
  open: p,
  onOpenChange: _,
  placeholder: y,
  title: d = "코드 선택",
  variant: b,
  disabled: N,
  className: $ = "",
  maxLength: g,
  numeric: x = !1,
  ariaLabel: h,
  autoFocus: w,
  onEnter: E,
  openOnEmptyEnter: D,
  onEscape: C,
  onBlur: q,
  invalid: M,
  selectOnFocus: I = !1
}) {
  const T = s ? "source" : "static", F = h != null ? h : (s == null ? void 0 : s.title) || (typeof d == "string" && d !== "코드 선택" ? d : "") || "코드", Y = b != null ? b : T === "source" ? "modal" : "anchor", H = u != null ? u : l ? "summary" : "input", [j, ne] = A(!1), te = p != null ? p : j, v = re(
    (k) => {
      p === void 0 && ne(k), _ && _(k);
    },
    [p, _]
  ), P = B(null), V = B(!1), Q = B(null), se = B(null), [L, Z] = A(null), R = () => {
    if (!N) {
      if (Y === "anchor") {
        const k = P.current;
        if (!k) return;
        const O = k.getBoundingClientRect(), J = 320, oe = O.bottom + J > window.innerHeight ? Math.max(8, O.top - J - 4) : O.bottom + 4;
        Z({ left: Math.min(O.left, window.innerWidth - 320), top: oe });
      }
      v(!0);
    }
  }, z = re(() => v(!1), [v]), [G, X] = A(!1), [W, ie] = A(null), Oe = B(null);
  (!Oe.current || Oe.current.name !== t) && (Oe.current = { name: t, code: e });
  const xe = ji(e, Oe.current, W, o), Fe = ra(e, xe, a), dt = ra(e, xe), Rt = G && xe && a !== "code" ? xe : "", Nt = (k) => {
    !l && k[0] && ie({ code: k[0].cd, name: k[0].nm }), i ? i(k) : k[0] && r && r(k[0].cd, { code: k[0].cd, name: k[0].nm });
  }, { sugg: _e, active: nt, setActive: Ue, suggPos: Ot, suggId: ft, runSuggest: Pt, cancelSuggest: $t } = ju({ source: s, items: o, anchorRef: P }), yn = (k) => {
    $t(), Nt([k]);
  };
  return /* @__PURE__ */ n.createElement("span", { ref: P, className: [H === "none" ? K.rootNone : K.root, $].filter(Boolean).join(" ") }, H === "input" && /* @__PURE__ */ n.createElement("span", { className: K.field }, /* @__PURE__ */ n.createElement(
    "input",
    {
      className: K.codeInput,
      style: { paddingRight: Rt ? "calc(24px + 45%)" : 24 },
      value: G ? e : Fe,
      placeholder: y,
      disabled: N,
      maxLength: g,
      inputMode: x ? "numeric" : void 0,
      autoComplete: "off",
      autoFocus: w,
      "aria-label": F,
      "aria-invalid": M ? !0 : void 0,
      onChange: (k) => {
        const O = k.target.value.trim(), J = x ? O.replace(/[^0-9]/g, "") : O, oe = g ? J.slice(0, g) : J;
        r && r(oe), !N && (s || o) && Pt(oe);
      },
      onKeyDown: (k) => {
        if (k.key === "F2") {
          k.preventDefault(), $t(), R();
          return;
        }
        if (!_e) {
          if (k.key === "Enter" && D && !e.trim() && !k.nativeEvent.isComposing) {
            k.preventDefault(), R();
            return;
          }
          k.key === "Enter" && E && !k.nativeEvent.isComposing ? (k.preventDefault(), E()) : k.key === "Escape" && C && (k.preventDefault(), C());
          return;
        }
        const O = _e.rows.length;
        k.key === "ArrowDown" && O ? (k.preventDefault(), Ue((J) => (J + 1) % O)) : k.key === "ArrowUp" && O ? (k.preventDefault(), Ue((J) => (J <= 0 ? O : J) - 1)) : k.key === "Enter" && nt >= 0 && _e.rows[nt] ? (k.preventDefault(), yn(_e.rows[nt])) : k.key === "Enter" && E && !k.nativeEvent.isComposing ? (k.preventDefault(), $t(), E()) : k.key === "Escape" && (k.preventDefault(), k.stopPropagation(), k.nativeEvent.stopImmediatePropagation(), $t());
      },
      onFocus: (k) => {
        if (X(!0), !I) return;
        const O = k.currentTarget;
        window.requestAnimationFrame(() => O.select());
      },
      onMouseDown: (k) => {
        I && document.activeElement !== k.currentTarget && (V.current = !0);
      },
      onMouseUp: (k) => {
        V.current && (k.preventDefault(), V.current = !1);
      },
      onBlur: () => {
        X(!1), $t(), q && q();
      },
      title: typeof M == "string" && M ? M : dt && dt !== e ? `${dt} (F2: 코드 선택)` : "F2: 코드 선택",
      role: "combobox",
      "aria-autocomplete": "list",
      "aria-expanded": !!_e,
      "aria-controls": _e ? ft.current : void 0,
      "aria-activedescendant": _e && nt >= 0 ? `${ft.current}-${nt}` : void 0,
      "aria-describedby": typeof M == "string" && M ? `${ft.current}-inv` : void 0
    }
  ), Rt && /* @__PURE__ */ n.createElement("span", { className: K.nameHint, "aria-hidden": "true" }, Rt), typeof M == "string" && M && /* @__PURE__ */ n.createElement(qr, { id: `${ft.current}-inv` }, M), /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      className: K.pickBtn,
      "aria-label": "코드 선택 열기",
      disabled: N,
      onClick: R,
      onMouseDown: (k) => k.preventDefault(),
      tabIndex: -1
    },
    /* @__PURE__ */ n.createElement(mn, { name: "search", size: 13 })
  )), H === "summary" && /* @__PURE__ */ n.createElement("button", { type: "button", className: K.summaryBtn, disabled: N, onClick: R }, /* @__PURE__ */ n.createElement("span", null, Li(c != null ? c : [], f, a)), /* @__PURE__ */ n.createElement("i", { "aria-hidden": "true" }, /* @__PURE__ */ n.createElement(mn, { name: "search", size: 13 }))), _e && Ot && H === "input" && !te && /* @__PURE__ */ n.createElement(Vt, null, /* @__PURE__ */ n.createElement(
    "div",
    {
      className: K.suggest,
      style: { left: Ot.left, top: Ot.top, width: Ot.width },
      onMouseDown: (k) => k.preventDefault()
    },
    _e.rows.length === 0 ? /* @__PURE__ */ n.createElement("div", { className: K.suggestEmpty }, "일치하는 코드가 없습니다 · F2 로 전체 검색") : /* @__PURE__ */ n.createElement("ul", { id: ft.current, role: "listbox", className: K.suggestList }, _e.rows.map((k, O) => /* @__PURE__ */ n.createElement(
      "li",
      {
        key: k.cd,
        id: `${ft.current}-${O}`,
        role: "option",
        "aria-selected": O === nt,
        className: [K.suggestRow, O === nt ? K.suggestOn : ""].filter(Boolean).join(" "),
        onMouseEnter: () => Ue(O),
        onClick: () => yn(k)
      },
      /* @__PURE__ */ n.createElement("code", null, Ma(k.cd, _e.q)),
      /* @__PURE__ */ n.createElement("span", null, Ma(k.nm, _e.q)),
      k.useYn === !1 && /* @__PURE__ */ n.createElement("em", null, "사용중단")
    ))),
    _e.more && /* @__PURE__ */ n.createElement("div", { className: K.suggestMore }, "더 있습니다 · F2 로 전체 보기")
  )), te && T === "static" && Y === "anchor" && L && /* @__PURE__ */ n.createElement(
    qu,
    {
      items: o != null ? o : [],
      value: e,
      title: d,
      popupRef: Q,
      anchorRef: P,
      pos: L,
      onPick: (k) => {
        ie({ code: k.code, name: k.name }), r && r(k.code, k), z();
      },
      onClose: z
    }
  ), te && (T === "source" || Y === "modal") && /* @__PURE__ */ n.createElement(
    Bu,
    {
      source: s,
      items: o,
      title: d,
      multiple: l,
      selected: c,
      current: m,
      searchRef: se,
      onConfirm: (k) => {
        Nt(k), z();
      },
      onClose: z
    }
  ));
}
const ba = 864e5;
function Iu(e) {
  return e % 4 === 0 && e % 100 !== 0 || e % 400 === 0;
}
function Le(e, t) {
  return t === 2 ? Iu(e) ? 29 : 28 : t === 4 || t === 6 || t === 9 || t === 11 ? 30 : 31;
}
function vt(e) {
  return Math.round(Date.UTC(+e.slice(0, 4), +e.slice(5, 7) - 1, +e.slice(8, 10)) / ba);
}
function Ru(e) {
  const t = new Date(e * ba);
  return `${t.getUTCFullYear()}-${String(t.getUTCMonth() + 1).padStart(2, "0")}-${String(t.getUTCDate()).padStart(2, "0")}`;
}
function Ln(e, t) {
  return Ru(vt(e) + t);
}
function Ea(e) {
  return new Date(vt(e) * ba).getUTCDay();
}
const qa = "1900-01-01", Ta = "2099-12-31", Fn = ["일", "월", "화", "수", "목", "금", "토"], Dn = (e) => String(e).padStart(2, "0");
function tt(e, t, a) {
  return `${String(e).padStart(4, "0")}-${Dn(t)}-${Dn(a)}`;
}
function de(e) {
  const t = /^(\d{4})-(\d{2})-(\d{2})$/.exec(e != null ? e : "");
  if (!t) return null;
  const a = +t[1], r = +t[2], o = +t[3];
  return r < 1 || r > 12 || o < 1 || o > Le(a, r) ? null : { y: a, m: r, d: o };
}
function Ou(e) {
  const t = /^(\d{4})-(\d{2})$/.exec(e != null ? e : "");
  if (!t) return null;
  const a = +t[1], r = +t[2];
  return r < 1 || r > 12 ? null : { y: a, m: r, d: 1 };
}
function en(e, t) {
  return t === "month" ? Ou(e) : de(e);
}
function Be(e, t) {
  return t === "month" ? `${String(e.y).padStart(4, "0")}-${Dn(e.m)}` : tt(e.y, e.m, e.d);
}
function Ie(e) {
  return new Date(Date.UTC(e.y, e.m - 1, e.d)).getUTCDay();
}
function dn(e, t) {
  const a = new Date(Date.UTC(e.y, e.m - 1, e.d + t));
  return { y: a.getUTCFullYear(), m: a.getUTCMonth() + 1, d: a.getUTCDate() };
}
function wt(e, t) {
  const a = e.y * 12 + (e.m - 1) + t, r = Math.floor(a / 12), o = (a % 12 + 12) % 12 + 1;
  return { y: r, m: o, d: Math.min(e.d, Le(r, o)) };
}
function Pu(e, t, a) {
  return e >= t && e <= a;
}
function Xt(e, t) {
  return e.replace(/\D/g, "").slice(0, t === "month" ? 6 : 8);
}
function Hn(e, t) {
  const a = e.slice(0, 4), r = e.slice(4, 6), o = e.slice(6, 8);
  let s = a;
  return e.length > 4 && (s += "-" + r), t === "date" && e.length > 6 && (s += "-" + o), s;
}
function Ba(e, t) {
  if (t <= 0) return 0;
  let a = 0;
  for (let r = 0; r < e.length; r++)
    if (/\d/.test(e[r]) && (a++, a === t))
      return r + 1;
  return e.length;
}
function $n(e, t, a) {
  let r, o, s = 1;
  if (t === "month")
    if (e.length === 6)
      r = +e.slice(0, 4), o = +e.slice(4, 6);
    else if (e.length === 4)
      r = 2e3 + +e.slice(0, 2), o = +e.slice(2, 4);
    else return null;
  else if (e.length === 8)
    r = +e.slice(0, 4), o = +e.slice(4, 6), s = +e.slice(6, 8);
  else if (e.length === 6)
    r = 2e3 + +e.slice(0, 2), o = +e.slice(2, 4), s = +e.slice(4, 6);
  else if (e.length === 4)
    r = a.y, o = +e.slice(0, 2), s = +e.slice(2, 4);
  else return null;
  return o < 1 || o > 12 || s < 1 || s > Le(r, o) ? null : { y: r, m: o, d: s };
}
function zu(e, t, a) {
  const r = e.trim(), o = t === "month" ? /^(\d{4})\D+(\d{1,2})$/.exec(r) : /^(\d{4})\D+(\d{1,2})\D+(\d{1,2})$/.exec(r);
  if (o) {
    const s = { y: +o[1], m: +o[2], d: t === "month" ? 1 : +o[3] };
    return s.m >= 1 && s.m <= 12 && s.d >= 1 && s.d <= Le(s.y, s.m) ? s : null;
  }
  return $n(r.replace(/\D/g, ""), t, a);
}
function Xu(e, t) {
  const a = { y: e, m: t, d: 1 }, r = dn(a, -Ie(a));
  return Array.from({ length: 42 }, (o, s) => dn(r, s));
}
function Fu(e, t) {
  const a = e.y, r = [], o = (m, u) => `${String(m).padStart(4, "0")}-${Dn(u)}`, s = (m, u, f) => tt(m, u, f);
  if (t === "month") {
    r.push({ label: "이번 달", from: o(a, e.m), to: o(a, e.m) });
    const m = wt(e, -1);
    r.push({ label: "지난달", from: o(m.y, m.m), to: o(m.y, m.m) }), r.push({ label: "올해", from: o(a, 1), to: o(a, 12) }), r.push({ label: "올해 누계", from: o(a, 1), to: o(a, e.m) }), r.push({ label: "전년도", from: o(a - 1, 1), to: o(a - 1, 12) });
    for (let u = 1; u <= 4; u++) r.push({ label: `${u}분기`, from: o(a, u * 3 - 2), to: o(a, u * 3) });
    return r.push({ label: "상반기", from: o(a, 1), to: o(a, 6) }), r.push({ label: "하반기", from: o(a, 7), to: o(a, 12) }), r;
  }
  const l = tt(e.y, e.m, e.d);
  r.push({ label: "오늘", from: l, to: l });
  const c = dn(e, -Ie(e));
  r.push({ label: "이번 주", from: Be(c, "date"), to: Be(dn(c, 6), "date") }), r.push({ label: "이번 달", from: s(a, e.m, 1), to: s(a, e.m, Le(a, e.m)) });
  const i = wt({ ...e, d: 1 }, -1);
  r.push({ label: "지난달", from: s(i.y, i.m, 1), to: s(i.y, i.m, Le(i.y, i.m)) }), r.push({ label: "올해", from: s(a, 1, 1), to: s(a, 12, 31) }), r.push({ label: "올해 오늘까지", from: s(a, 1, 1), to: l }), r.push({ label: "전년도", from: s(a - 1, 1, 1), to: s(a - 1, 12, 31) });
  for (let m = 1; m <= 4; m++)
    r.push({ label: `${m}분기`, from: s(a, m * 3 - 2, 1), to: s(a, m * 3, Le(a, m * 3)) });
  return r;
}
const Hu = "_wrap_uxy72_1", Wu = "_disabled_uxy72_18", Ku = "_input_uxy72_22", Uu = "_month_uxy72_36", Gu = "_weekday_uxy72_39", Yu = "_sun_uxy72_40", Vu = "_sat_uxy72_41", Qu = "_icon_uxy72_43", Ju = "_readOnly_uxy72_57", Zu = "_required_uxy72_62", em = "_invalid_uxy72_63", tm = "_pop_uxy72_66", nm = "_calHead_uxy72_79", am = "_calTitleStatic_uxy72_80", rm = "_calTitle_uxy72_80", om = "_grid_uxy72_90", sm = "_wd_uxy72_91", lm = "_day_uxy72_95", cm = "_mon_uxy72_36", im = "_out_uxy72_104", um = "_sel_uxy72_105", mm = "_today_uxy72_108", dm = "_months_uxy72_111", fm = "_foot_uxy72_114", pm = "_clear_uxy72_127", _m = "_range_uxy72_130", ym = "_tilde_uxy72_131", bm = "_rangeErr_uxy72_132", ae = {
  wrap: Hu,
  disabled: Wu,
  input: Ku,
  month: Uu,
  weekday: Gu,
  sun: Yu,
  sat: Vu,
  icon: Qu,
  readOnly: Ju,
  required: Zu,
  invalid: em,
  pop: tm,
  calHead: nm,
  calTitleStatic: am,
  calTitle: rm,
  grid: om,
  wd: sm,
  day: lm,
  mon: cm,
  out: im,
  sel: um,
  today: mm,
  months: dm,
  foot: fm,
  clear: pm,
  range: _m,
  tilde: ym,
  rangeErr: bm
}, yt = () => {
  const e = /* @__PURE__ */ new Date();
  return { y: e.getFullYear(), m: e.getMonth() + 1, d: e.getDate() };
};
function La({
  value: e,
  onChange: t,
  mode: a = "date",
  min: r,
  max: o,
  disabled: s,
  readOnly: l,
  required: c,
  invalid: i,
  showWeekday: m,
  onReject: u,
  placeholder: f,
  id: p,
  name: _,
  onBlur: y,
  "aria-label": d,
  "aria-describedby": b,
  className: N = "",
  style: $
}) {
  const g = a === "month", x = Qt("axe-dp"), h = r || (g ? qa.slice(0, 7) : qa), w = o || (g ? Ta.slice(0, 7) : Ta), E = (k) => Pu(k, h, w), D = !!s || !!l, [C, q] = A(e || ""), [M, I] = A(!1), [T, F] = A(!1), [Y, H] = A(g ? "month" : "day"), [j, ne] = A(() => {
    var O;
    const k = (O = en(e, a)) != null ? O : yt();
    return { y: k.y, m: k.m };
  }), [te, v] = A({ top: 0, left: 0 }), P = B(null), V = B(null), Q = B(null), se = B(null);
  U(() => {
    q(e || ""), I(!1);
  }, [e]), U(() => {
    const k = en(e, a);
    k && ne({ y: k.y, m: k.m });
  }, [e, a]), $e(() => {
    const k = V.current;
    se.current != null && k && document.activeElement === k && k.setSelectionRange(se.current, se.current), se.current = null;
  }, [C]), $e(() => {
    if (!T) return;
    const k = () => {
      const O = P.current, J = Q.current;
      if (!O || !J) return;
      const oe = O.getBoundingClientRect(), ue = J.offsetHeight, Ee = J.offsetWidth;
      let De = oe.bottom + 4;
      De + ue > window.innerHeight - 8 && oe.top - ue - 4 > 8 && (De = oe.top - ue - 4);
      const Jt = Math.max(8, Math.min(oe.left, window.innerWidth - Ee - 8));
      v((zn) => zn.top === De && zn.left === Jt ? zn : { top: De, left: Jt });
    };
    return k(), window.addEventListener("resize", k), window.addEventListener("scroll", k, !0), () => {
      window.removeEventListener("resize", k), window.removeEventListener("scroll", k, !0);
    };
  }, [T, Y, j.y, j.m]), U(() => {
    if (!T) return;
    const k = (O) => {
      var oe, ue;
      const J = O.target;
      (oe = P.current) != null && oe.contains(J) || (ue = Q.current) != null && ue.contains(J) || F(!1);
    };
    return document.addEventListener("mousedown", k), () => document.removeEventListener("mousedown", k);
  }, [T]);
  const L = (k) => {
    k !== (e || "") && t(k);
  }, Z = (k) => {
    q(k), I(!1), L(k);
  }, R = () => {
    const k = Xt(C, a);
    if (!k) return;
    const O = $n(k, a, yt()), J = O ? Be(O, a) : null;
    if (J && E(J)) {
      Z(J);
      return;
    }
    u == null || u(C, J ? "range" : "format"), q(e || ""), I(!1);
  }, z = (k, O) => {
    const J = Xt(k.slice(0, O), a).length, oe = Xt(k, a), ue = Hn(oe, a);
    if (se.current = Ba(ue, Math.min(J, oe.length)), q(ue), !oe) {
      I(!1), L("");
      return;
    }
    if (oe.length === (g ? 6 : 8)) {
      const Ee = $n(oe, a, yt()), De = Ee ? Be(Ee, a) : null;
      De && E(De) ? (I(!1), L(De)) : I(!0);
    } else I(!1);
  }, G = (k, O) => {
    var Jt;
    const J = yt(), oe = Xt(C, a), ue = (Jt = $n(oe, a, J)) != null ? Jt : en(e, a);
    let Ee;
    ue ? g ? Ee = wt(ue, k === "year" ? 12 * O : O) : k === "day" ? Ee = dn(ue, O) : Ee = wt(ue, k === "month" ? O : 12 * O) : Ee = J;
    const De = Be(Ee, a);
    E(De) && Z(De);
  }, X = (k) => {
    var O;
    Z(k), F(!1), (O = V.current) == null || O.focus();
  }, W = () => {
    var O;
    if (D) return;
    const k = (O = en(e, a)) != null ? O : yt();
    ne({ y: k.y, m: k.m }), H(g ? "month" : "day"), F(!0);
  }, ie = (k) => {
    var J, oe;
    if (D) return;
    const O = k.currentTarget;
    switch (k.key) {
      case "Escape":
        T ? (F(!1), k.preventDefault(), k.stopPropagation(), k.nativeEvent.stopImmediatePropagation()) : C !== (e || "") && (q(e || ""), I(!1), k.preventDefault(), k.stopPropagation(), k.nativeEvent.stopImmediatePropagation(), requestAnimationFrame(() => O.select()));
        break;
      case "ArrowDown":
        k.preventDefault(), k.altKey ? T ? F(!1) : W() : G("day", 1);
        break;
      case "ArrowUp":
        k.preventDefault(), G("day", -1);
        break;
      case "PageDown":
        k.preventDefault(), G("month", 1);
        break;
      case "PageUp":
        k.preventDefault(), G("month", -1);
        break;
      case "F2":
      case "F4":
        k.preventDefault(), T ? F(!1) : W();
        break;
      case "Enter":
        R(), T && F(!1);
        break;
      case "t":
      case "T":
        if (k.ctrlKey || k.metaKey || k.altKey) break;
        k.preventDefault(), Z(Be(yt(), a));
        break;
      case "Backspace": {
        const ue = (J = O.selectionStart) != null ? J : 0;
        if (ue === ((oe = O.selectionEnd) != null ? oe : 0) && ue > 0 && C[ue - 1] === "-") {
          k.preventDefault();
          const Ee = Xt(C.slice(0, ue), a).length, De = Xt(C, a);
          z(Hn(De.slice(0, Ee - 1) + De.slice(Ee), a), 0), se.current = Ba(Hn(De.slice(0, Ee - 1) + De.slice(Ee), a), Ee - 1);
        }
        break;
      }
    }
  }, Oe = (k) => {
    if (D) return;
    k.preventDefault();
    const O = zu(k.clipboardData.getData("text"), a, yt()), J = O ? Be(O, a) : null;
    J && E(J) ? Z(J) : I(!0);
  }, xe = (k) => {
    var J, oe;
    const O = k.relatedTarget;
    O && ((J = P.current) != null && J.contains(O) || (oe = Q.current) != null && oe.contains(O)) || (R(), F(!1), y && y());
  }, Fe = en(e, a), dt = yt(), Rt = M || !!i, Nt = m && !g && Fe ? Ie(Fe) : null, _e = (k) => Be(k, a), nt = (k, O) => {
    const J = Be({ y: k, m: O, d: 1 }, "date"), oe = Be({ y: k, m: O, d: Le(k, O) }, "date"), ue = g ? h + "-01" : h, Ee = g ? w + "-31" : w;
    return oe >= ue && J <= Ee;
  }, Ue = (k) => {
    const O = wt({ y: j.y, m: j.m, d: 1 }, k);
    ne({ y: O.y, m: O.m });
  }, Ot = () => /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("div", { className: ae.calHead }, /* @__PURE__ */ n.createElement("button", { type: "button", tabIndex: -1, "aria-label": "이전 해", onClick: () => Ue(-12) }, "«"), /* @__PURE__ */ n.createElement("button", { type: "button", tabIndex: -1, "aria-label": "이전 달", onClick: () => Ue(-1) }, "‹"), /* @__PURE__ */ n.createElement("button", { type: "button", tabIndex: -1, className: ae.calTitle, "aria-label": "연·월 선택", onClick: () => H("month") }, j.y, "년 ", j.m, "월"), /* @__PURE__ */ n.createElement("button", { type: "button", tabIndex: -1, "aria-label": "다음 달", onClick: () => Ue(1) }, "›"), /* @__PURE__ */ n.createElement("button", { type: "button", tabIndex: -1, "aria-label": "다음 해", onClick: () => Ue(12) }, "»")), /* @__PURE__ */ n.createElement("div", { className: ae.grid }, Fn.map((k, O) => /* @__PURE__ */ n.createElement("span", { key: k, className: [ae.wd, O === 0 ? ae.sun : "", O === 6 ? ae.sat : ""].join(" ") }, k)), Xu(j.y, j.m).map((k) => {
    const O = Be(k, "date"), J = Ie(k), oe = [
      ae.day,
      k.m !== j.m ? ae.out : "",
      J === 0 ? ae.sun : "",
      J === 6 ? ae.sat : "",
      O === Be(dt, "date") ? ae.today : "",
      Fe && O === Be(Fe, "date") ? ae.sel : ""
    ].join(" "), ue = !E(O);
    return /* @__PURE__ */ n.createElement(
      "button",
      {
        key: O,
        type: "button",
        tabIndex: -1,
        className: oe,
        disabled: ue,
        "aria-label": `${k.y}년 ${k.m}월 ${k.d}일 ${Fn[J]}요일`,
        "aria-pressed": !!Fe && O === Be(Fe, "date"),
        onClick: () => X(O)
      },
      k.d
    );
  }))), ft = () => /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("div", { className: ae.calHead }, /* @__PURE__ */ n.createElement("button", { type: "button", tabIndex: -1, "aria-label": "이전 해", onClick: () => Ue(-12) }, "«"), /* @__PURE__ */ n.createElement("span", { className: ae.calTitleStatic }, j.y, "년"), /* @__PURE__ */ n.createElement("button", { type: "button", tabIndex: -1, "aria-label": "다음 해", onClick: () => Ue(12) }, "»")), /* @__PURE__ */ n.createElement("div", { className: ae.months }, Array.from({ length: 12 }, (k, O) => O + 1).map((k) => {
    const O = !!Fe && Fe.y === j.y && Fe.m === k, J = [ae.mon, O ? ae.sel : "", dt.y === j.y && dt.m === k ? ae.today : ""].join(" ");
    return /* @__PURE__ */ n.createElement(
      "button",
      {
        key: k,
        type: "button",
        tabIndex: -1,
        className: J,
        disabled: !nt(j.y, k),
        "aria-pressed": O,
        onClick: () => {
          g ? X(_e({ y: j.y, m: k, d: 1 })) : (ne({ y: j.y, m: k }), H("day"));
        }
      },
      k,
      "월"
    );
  }))), Pt = Be(dt, a), $t = g ? /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("button", { type: "button", tabIndex: -1, disabled: !E(Pt), onClick: () => X(Pt) }, "이번 달")) : /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("button", { type: "button", tabIndex: -1, disabled: !E(Pt), onClick: () => X(Pt) }, "오늘"), /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      tabIndex: -1,
      disabled: !E(_e({ y: j.y, m: j.m, d: 1 })),
      onClick: () => X(_e({ y: j.y, m: j.m, d: 1 }))
    },
    "월초"
  ), /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      tabIndex: -1,
      disabled: !E(_e({ y: j.y, m: j.m, d: Le(j.y, j.m) })),
      onClick: () => X(_e({ y: j.y, m: j.m, d: Le(j.y, j.m) }))
    },
    "월말"
  )), yn = [
    ae.wrap,
    s ? ae.disabled : "",
    l ? ae.readOnly : "",
    c && !e && !C ? ae.required : "",
    Rt ? ae.invalid : "",
    g ? ae.month : "",
    N
  ].filter(Boolean).join(" ");
  return /* @__PURE__ */ n.createElement("span", { ref: P, className: yn, style: $, onBlur: xe }, /* @__PURE__ */ n.createElement(
    "input",
    {
      ref: V,
      id: p,
      name: _,
      className: ae.input,
      inputMode: "numeric",
      autoComplete: "off",
      spellCheck: !1,
      value: C,
      placeholder: f != null ? f : g ? "YYYY-MM" : "YYYY-MM-DD",
      disabled: s,
      readOnly: l,
      role: "combobox",
      "aria-haspopup": "dialog",
      "aria-expanded": T,
      "aria-controls": x,
      "aria-label": d,
      "aria-describedby": b,
      "aria-invalid": Rt || void 0,
      "aria-required": c || void 0,
      onChange: (k) => {
        var O;
        return z(k.target.value, (O = k.target.selectionStart) != null ? O : k.target.value.length);
      },
      onKeyDown: ie,
      onPaste: Oe
    }
  ), Nt != null && /* @__PURE__ */ n.createElement("span", { className: [ae.weekday, Nt === 0 ? ae.sun : "", Nt === 6 ? ae.sat : ""].join(" "), "aria-hidden": "true" }, "(", Fn[Nt], ")"), /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      tabIndex: -1,
      className: ae.icon,
      disabled: D,
      "aria-label": g ? "월 선택 열기" : "달력 열기",
      onMouseDown: (k) => k.preventDefault(),
      onClick: () => {
        var k;
        (k = V.current) == null || k.focus(), T ? F(!1) : W();
      }
    },
    /* @__PURE__ */ n.createElement(mn, { name: "calendar", size: 15 })
  ), T && /* @__PURE__ */ n.createElement(Vt, null, /* @__PURE__ */ n.createElement(
    "div",
    {
      ref: Q,
      id: x,
      className: ae.pop,
      style: { top: te.top, left: te.left },
      role: "dialog",
      "aria-label": g ? "월 선택" : "날짜 선택",
      onMouseDown: (k) => k.preventDefault()
    },
    Y === "day" && !g ? Ot() : ft(),
    /* @__PURE__ */ n.createElement("div", { className: ae.foot }, $t, !c && /* @__PURE__ */ n.createElement("button", { type: "button", tabIndex: -1, className: ae.clear, onClick: () => X("") }, "비우기"))
  )));
}
const qt = (e) => String(e).padStart(2, "0");
function Br() {
  const e = /* @__PURE__ */ new Date();
  return `${e.getFullYear()}-${qt(e.getMonth() + 1)}-${qt(e.getDate())}`;
}
function T0(e) {
  if (!e) return "";
  const t = new Date(e);
  return Number.isNaN(t.getTime()) ? String(e) : `${t.getFullYear()}-${qt(t.getMonth() + 1)}-${qt(t.getDate())} ${qt(t.getHours())}:${qt(t.getMinutes())}:${qt(t.getSeconds())}`;
}
function B0(e, t) {
  return !!e && !!t && e <= t;
}
function L0({
  from: e,
  to: t,
  onChange: a,
  mode: r = "date",
  min: o,
  max: s,
  disabled: l,
  label: c = "기간",
  presets: i = !0,
  showWeekday: m,
  onReject: u
}) {
  const f = !!e && !!t && e > t, p = /* @__PURE__ */ new Date(), _ = i === !1 ? [] : Array.isArray(i) ? i : Fu({ y: p.getFullYear(), m: p.getMonth() + 1, d: p.getDate() }, r), y = (d) => (!o || d.from >= o) && (!s || d.to <= s);
  return /* @__PURE__ */ n.createElement("span", { className: ae.range }, /* @__PURE__ */ n.createElement(
    La,
    {
      value: e,
      mode: r,
      min: o,
      max: s,
      disabled: l,
      showWeekday: m,
      "aria-label": `${c} 시작일`,
      onChange: (d) => a(d, t),
      onReject: u && ((d, b) => u(d, b, "from"))
    }
  ), /* @__PURE__ */ n.createElement("span", { className: ae.tilde, "aria-hidden": "true" }, "~"), /* @__PURE__ */ n.createElement(
    La,
    {
      value: t,
      mode: r,
      min: o,
      max: s,
      disabled: l,
      showWeekday: m,
      "aria-label": `${c} 종료일`,
      onChange: (d) => a(e, d),
      onReject: u && ((d, b) => u(d, b, "to"))
    }
  ), _.length > 0 && /* @__PURE__ */ n.createElement(
    us,
    {
      label: "기간",
      title: `${c} 빠른 선택`,
      disabled: l,
      entries: _.map((d) => is(
        d.label,
        d.label,
        () => a(d.from, d.to),
        y(d) ? {} : { disabled: !0, reason: "허용 범위 밖" }
      ))
    }
  ), f && /* @__PURE__ */ n.createElement("span", { className: ae.rangeErr, role: "alert" }, "시작일이 종료일보다 늦습니다"));
}
const Lr = [
  { name: "明治", short: "M", start: "1868-09-08" },
  { name: "大正", short: "T", start: "1912-07-30" },
  { name: "昭和", short: "S", start: "1926-12-25" },
  { name: "平成", short: "H", start: "1989-01-08" },
  { name: "令和", short: "R", start: "2019-05-01" }
];
function jr(e, t = Lr) {
  const a = /^(\d{4})-\d{2}-\d{2}/.exec(e != null ? e : "");
  if (!a) return null;
  let r = null;
  for (const o of t) o.start <= e.slice(0, 10) && (!r || o.start > r.start) && (r = o);
  return r ? { era: r, year: +a[1] - +r.start.slice(0, 4) + 1 } : null;
}
function Em(e, t = {}) {
  const a = jr(e, t.eras);
  return a ? `${a.era.name}${a.year === 1 && t.gannen !== !1 ? "元" : a.year}年` : null;
}
function j0(e, t) {
  const a = jr(e, t);
  return a ? `${a.era.short}${a.year}.${e.slice(5, 7)}.${e.slice(8, 10)}` : null;
}
const Se = 1440, An = (e) => String(e).padStart(2, "0");
function pe(e) {
  const t = /^(\d{4})-(\d{2})-(\d{2})(?:[T ](\d{2}):(\d{2}))?/.exec(e != null ? e : "");
  return t ? Date.UTC(+t[1], +t[2] - 1, +t[3], t[4] ? +t[4] : 0, t[5] ? +t[5] : 0) / 6e4 : NaN;
}
function Bt(e) {
  const t = new Date(e * 6e4);
  return tt(t.getUTCFullYear(), t.getUTCMonth() + 1, t.getUTCDate());
}
function on(e) {
  const t = new Date(e * 6e4);
  return `${Bt(e)}T${An(t.getUTCHours())}:${An(t.getUTCMinutes())}`;
}
function Je(e) {
  const t = (e % Se + Se) % Se;
  return `${An(Math.floor(t / 60))}:${An(t % 60)}`;
}
function ve(e, t) {
  return de(e) ? Ln(e, t) : e;
}
function Gt(e, t) {
  return Math.round((pe(t) - pe(e)) / Se);
}
function fn(e) {
  if (!de(e)) return !1;
  const t = Ea(e);
  return t === 0 || t === 6;
}
function hm(e) {
  var o;
  const t = pe(e.start);
  if (Number.isNaN(t)) return null;
  const a = (o = e.allDay) != null ? o : !/[T ]\d{2}:\d{2}/.test(e.start);
  if (a) {
    const s = Bt(t), l = e.end ? Bt(pe(e.end)) : s, c = l < s ? s : l;
    return { ev: e, s: pe(s), e: pe(c) + Se, allDay: a, sDay: s, eDay: c };
  }
  let r = e.end ? pe(e.end) : t + 60;
  return (Number.isNaN(r) || r <= t) && (r = t + 30), { ev: e, s: t, e: r, allDay: a, sDay: Bt(t), eDay: Bt(r - 1) };
}
function jn(e, t, a, r) {
  const o = [];
  for (const s of e) {
    const l = r && s.id === r.id ? { ...s, start: r.start, end: r.end } : s, c = hm(l);
    c && c.eDay >= t && c.sDay <= a && o.push(c);
  }
  return o.sort(gm);
}
function gm(e, t) {
  if (e.sDay !== t.sDay) return e.sDay < t.sDay ? -1 : 1;
  const a = Gt(t.sDay, t.eDay) - Gt(e.sDay, e.eDay);
  return a || (e.allDay !== t.allDay ? e.allDay ? -1 : 1 : e.s !== t.s ? e.s - t.s : e.ev.title.localeCompare(t.ev.title));
}
function vm(e) {
  return e.allDay || e.sDay !== e.eDay;
}
function Ir(e) {
  return e.allDay || e.e - e.s >= Se;
}
function Cn(e, t) {
  const a = de(e);
  if (!a) return e;
  const r = (Ie(a) - t + 7) % 7;
  return ve(e, -r);
}
function In(e, t) {
  const a = Gt(e, t);
  return Array.from({ length: Math.max(0, a + 1) }, (r, o) => ve(e, o));
}
function Rr(e, t) {
  const a = de(e), r = tt(a.y, a.m, 1), o = tt(a.y, a.m, Le(a.y, a.m)), s = Cn(r, t), l = ve(Cn(o, t), 6), c = In(s, l), i = [];
  for (let m = 0; m < c.length; m += 7) i.push(c.slice(m, m + 7));
  return i;
}
function ha(e, t, a) {
  if (e === "month") {
    const r = Rr(t, a);
    return { from: r[0][0], to: r[r.length - 1][6] };
  }
  if (e === "agenda") {
    const r = de(t);
    return { from: tt(r.y, r.m, 1), to: tt(r.y, r.m, Le(r.y, r.m)) };
  }
  if (e === "week") {
    const r = Cn(t, a);
    return { from: r, to: ve(r, 6) };
  }
  return { from: t, to: t };
}
function km(e, t, a, r = !1) {
  const o = de(t);
  if (!o) return t;
  if (e === "month" || e === "agenda") {
    const l = wt(o, a);
    return tt(l.y, l.m, l.d);
  }
  if (e === "week") return ve(t, 7 * a);
  let s = ve(t, a);
  for (; r && fn(s); ) s = ve(s, a);
  return s;
}
function wm(e, t, a, r) {
  if (!de(t)) return "";
  if (e === "month" || e === "agenda") return r.ym(`${t.slice(0, 7)}-01`);
  if (e === "day") return r.dayTitle(t);
  const { from: o, to: s } = ha("week", t, a);
  return r.year(o) !== r.year(s) ? `${r.ymd(o)} – ${r.ymd(s)}` : o.slice(5, 7) !== s.slice(5, 7) ? `${r.ymd(o)} – ${r.md(s)}` : `${r.ymd(o)} – ${r.d(s)}`;
}
function Or(e, t) {
  const a = [], r = [];
  for (const o of e) {
    let s = -1, l = -1;
    for (let i = 0; i < t.length; i++)
      t[i] >= o.sDay && t[i] <= o.eDay && (s < 0 && (s = i), l = i);
    if (s < 0) continue;
    let c = r.findIndex((i) => i < s);
    c < 0 ? (c = r.length, r.push(l)) : r[c] = l, a.push({ item: o, col: s, span: l - s + 1, lane: c, contL: o.sDay < t[s], contR: o.eDay > t[l] });
  }
  return a;
}
function Nm(e, t, a) {
  const r = new Array(t).fill(0);
  for (const c of e) for (let i = c.col; i < c.col + c.span; i++) r[i]++;
  const o = Math.max(1, a), s = e.filter((c) => {
    if (c.lane < o - 1) return !0;
    if (c.lane > o - 1) return !1;
    for (let i = c.col; i < c.col + c.span; i++) if (r[i] > o) return !1;
    return !0;
  }), l = new Array(t).fill(0);
  for (const c of s) for (let i = c.col; i < c.col + c.span; i++) l[i]++;
  return { shown: s, more: r.map((c, i) => c - l[i]) };
}
const $m = 20;
function xm(e, t) {
  const a = pe(t), r = a + Se, o = e.filter((m) => !Ir(m) && m.s < r && m.e > a).map((m) => ({
    item: m,
    top: Math.max(m.s, a) - a,
    bottom: Math.min(m.e, r) - a,
    col: 0,
    cols: 1,
    contTop: m.s < a,
    contBottom: m.e > r
  })).sort((m, u) => m.top - u.top || u.bottom - m.bottom);
  let s = [], l = [], c = -1;
  const i = () => {
    for (const m of s) m.cols = l.length;
    s = [], l = [];
  };
  for (const m of o) {
    m.top >= c && i();
    const u = Math.max(m.bottom, m.top + $m);
    let f = l.findIndex((p) => p <= m.top);
    f < 0 ? (f = l.length, l.push(u)) : l[f] = u, m.col = f, s.push(m), c = Math.max(c, u);
  }
  return i(), o;
}
function ja(e, t) {
  return Math.round(e / t) * t;
}
function oa(e, t) {
  if (e.allDay) {
    const a = Math.round(t / Se);
    return { start: ve(e.sDay, a), end: ve(e.eDay, a) };
  }
  return { start: on(e.s + t), end: on(e.e + t) };
}
function ga(e, t = "종일") {
  if (e.allDay) {
    if (e.sDay === e.eDay) return t;
    const l = de(e.sDay), c = de(e.eDay);
    return `${l.m}/${l.d} – ${c.m}/${c.d}`;
  }
  const a = pe(e.sDay), r = Je(e.s - a);
  if (e.sDay === e.eDay) return `${r} – ${e.e - a === Se ? "24:00" : Je(e.e - a)}`;
  const o = de(e.sDay), s = de(Bt(e.e));
  return `${o.m}/${o.d} ${r} – ${s.m}/${s.d} ${Je(e.e - pe(Bt(e.e)))}`;
}
const Ae = (e) => {
  const t = de(e);
  return { ...t, w: Ie(t) };
};
function Ia(e, t, a, r, o) {
  const s = `${+e.slice(0, 4)}${a}`;
  if (t === "gregorian") return s;
  const l = Em(e, { eras: r, gannen: o });
  return l ? t === "era" ? l : `${s}(${l})` : s;
}
function Dm(e = "ko", t = {}) {
  var i, m;
  const a = (i = t.year) != null ? i : e === "ja" ? "era" : "gregorian", r = (m = t.eras) != null ? m : Lr, o = t.gannen !== !1;
  if (e === "ja") {
    const u = ["日", "月", "火", "水", "木", "金", "土"], f = (_) => Ia(_, a, "年", r, o), p = { month: "月", week: "週", day: "日", agenda: "月" };
    return {
      weekdays: u,
      views: { month: "月", week: "週", day: "日", agenda: "一覧" },
      today: "今日",
      prev: (_) => `前の${p[_]} (P)`,
      next: (_) => `次の${p[_]} (N)`,
      hideWeekends: "週末を隠す",
      prevMonth: "前月",
      nextMonth: "翌月",
      prevYear: "前年",
      nextYear: "翌年",
      pickMonth: "月を選択",
      viewTabs: "表示",
      region: "スケジュール",
      loading: "読み込み中",
      close: "閉じる",
      allDay: "終日",
      empty: "この期間の予定はありません。",
      more: (_) => `他${_}件`,
      eventCount: (_) => `予定${_}件`,
      dayOfSpan: (_, y) => `${_}/${y}日目`,
      openDay: (_) => {
        const y = Ae(_);
        return `${y.m}月${y.d}日を日表示`;
      },
      year: f,
      ym: (_) => `${f(_)}${Ae(_).m}月`,
      ymd: (_) => {
        const y = Ae(_);
        return `${f(_)}${y.m}月${y.d}日`;
      },
      md: (_) => {
        const y = Ae(_);
        return `${y.m}月${y.d}日`;
      },
      d: (_) => `${Ae(_).d}日`,
      m: (_) => `${Ae(_).m}月`,
      dayTitle: (_) => {
        const y = Ae(_);
        return `${f(_)}${y.m}月${y.d}日(${u[y.w]})`;
      },
      dayAria: (_) => {
        const y = Ae(_);
        return `${y.m}月${y.d}日 ${u[y.w]}曜日`;
      }
    };
  }
  const s = ["일", "월", "화", "수", "목", "금", "토"], l = (u) => Ia(u, a, "년", r, o), c = { month: "달", week: "주", day: "날", agenda: "달" };
  return {
    weekdays: s,
    views: { month: "월", week: "주", day: "일", agenda: "목록" },
    today: "오늘",
    prev: (u) => `이전 ${c[u]} (P)`,
    next: (u) => `다음 ${c[u]} (N)`,
    hideWeekends: "주말 숨김",
    prevMonth: "이전 달",
    nextMonth: "다음 달",
    prevYear: "이전 해",
    nextYear: "다음 해",
    pickMonth: "월 선택",
    viewTabs: "보기",
    region: "일정 달력",
    loading: "일정 불러오는 중",
    close: "닫기",
    allDay: "종일",
    empty: "이 기간에 일정이 없습니다.",
    more: (u) => `+${u}개`,
    eventCount: (u) => `일정 ${u}건`,
    dayOfSpan: (u, f) => `${u}/${f}일째`,
    openDay: (u) => {
      const f = Ae(u);
      return `${f.m}월 ${f.d}일 일 보기`;
    },
    year: l,
    ym: (u) => `${l(u)} ${Ae(u).m}월`,
    ymd: (u) => {
      const f = Ae(u);
      return `${l(u)} ${f.m}월 ${f.d}일`;
    },
    md: (u) => {
      const f = Ae(u);
      return `${f.m}월 ${f.d}일`;
    },
    d: (u) => `${Ae(u).d}일`,
    m: (u) => `${Ae(u).m}월`,
    dayTitle: (u) => {
      const f = Ae(u);
      return `${l(u)} ${f.m}월 ${f.d}일 (${s[f.w]})`;
    },
    dayAria: (u) => {
      const f = Ae(u);
      return `${f.m}월 ${f.d}일 ${s[f.w]}요일`;
    }
  };
}
const Pr = Dm("ko"), Am = "_cal_38qtm_2", Cm = "_toolbar_38qtm_20", Sm = "_navBtns_38qtm_28", Mm = "_title_38qtm_29", qm = "_toolRight_38qtm_36", Tm = "_toggle_38qtm_37", Bm = "_body_38qtm_58", Lm = "_busy_38qtm_59", jm = "_sun_38qtm_71", Im = "_sat_38qtm_72", Rm = "_tAccent_38qtm_75", Om = "_tOk_38qtm_76", Pm = "_tWarn_38qtm_77", zm = "_tDanger_38qtm_78", Xm = "_tViolet_38qtm_79", Fm = "_tGray_38qtm_80", Hm = "_month_38qtm_83", Wm = "_mHead_38qtm_84", Km = "_wdName_38qtm_85", Um = "_mBody_38qtm_91", Gm = "_mWeek_38qtm_92", Ym = "_mCells_38qtm_94", Vm = "_cell_38qtm_96", Qm = "_out_38qtm_104", Jm = "_dayNum_38qtm_105", Zm = "_creatable_38qtm_106", ed = "_selDay_38qtm_109", td = "_cellHead_38qtm_111", nd = "_isToday_38qtm_124", ad = "_holiday_38qtm_125", rd = "_addHint_38qtm_130", od = "_barLayer_38qtm_138", sd = "_chip_38qtm_139", ld = "_more_38qtm_139", cd = "_tEv_38qtm_155", id = "_aRow_38qtm_155", ud = "_popItem_38qtm_155", md = "_bar_38qtm_138", dd = "_contL_38qtm_165", fd = "_contR_38qtm_166", pd = "_dotChip_38qtm_167", _d = "_dot_38qtm_167", yd = "_chipTime_38qtm_170", bd = "_chipTitle_38qtm_171", Ed = "_movable_38qtm_173", hd = "_ghost_38qtm_176", gd = "_time_38qtm_189", vd = "_tHead_38qtm_190", kd = "_tAllDay_38qtm_190", wd = "_gutter_38qtm_193", Nd = "_tHeadDays_38qtm_197", $d = "_tAllDayCells_38qtm_197", xd = "_tDay_38qtm_198", Dd = "_tDayBtn_38qtm_202", Ad = "_tWd_38qtm_206", Cd = "_tDayNum_38qtm_208", Sd = "_tAllDayRow_38qtm_216", Md = "_allDayCell_38qtm_218", qd = "_tBody_38qtm_222", Td = "_tGrid_38qtm_223", Bd = "_tGutter_38qtm_224", Ld = "_tCols_38qtm_230", jd = "_tCol_38qtm_230", Id = "_tSel_38qtm_238", Rd = "_tEvTitle_38qtm_258", Od = "_tEvTime_38qtm_259", Pd = "_tEvShort_38qtm_261", zd = "_contTop_38qtm_263", Xd = "_contBottom_38qtm_264", Fd = "_resize_38qtm_265", Hd = "_now_38qtm_268", Wd = "_agenda_38qtm_272", Kd = "_aDay_38qtm_273", Ud = "_aDate_38qtm_275", Gd = "_aDateBtn_38qtm_276", Yd = "_aDayNum_38qtm_280", Vd = "_aDayWd_38qtm_286", Qd = "_aList_38qtm_288", Jd = "_aTime_38qtm_295", Zd = "_aTitle_38qtm_296", ef = "_aSpan_38qtm_297", tf = "_aLoc_38qtm_298", nf = "_empty_38qtm_303", af = "_pop_38qtm_155", rf = "_popHead_38qtm_321", of = "_popDay_38qtm_322", sf = "_popClose_38qtm_329", lf = "_popList_38qtm_334", cf = "_tAllDayOnly_38qtm_348", S = {
  cal: Am,
  toolbar: Cm,
  navBtns: Sm,
  title: Mm,
  toolRight: qm,
  toggle: Tm,
  body: Bm,
  busy: Lm,
  sun: jm,
  sat: Im,
  tAccent: Rm,
  tOk: Om,
  tWarn: Pm,
  tDanger: zm,
  tViolet: Xm,
  tGray: Fm,
  month: Hm,
  mHead: Wm,
  wdName: Km,
  mBody: Um,
  mWeek: Gm,
  mCells: Ym,
  cell: Vm,
  out: Qm,
  dayNum: Jm,
  creatable: Zm,
  selDay: ed,
  cellHead: td,
  isToday: nd,
  holiday: ad,
  addHint: rd,
  barLayer: od,
  chip: sd,
  more: ld,
  tEv: cd,
  aRow: id,
  popItem: ud,
  bar: md,
  contL: dd,
  contR: fd,
  dotChip: pd,
  dot: _d,
  chipTime: yd,
  chipTitle: bd,
  movable: Ed,
  ghost: hd,
  time: gd,
  tHead: vd,
  tAllDay: kd,
  gutter: wd,
  tHeadDays: Nd,
  tAllDayCells: $d,
  tDay: xd,
  tDayBtn: Dd,
  tWd: Ad,
  tDayNum: Cd,
  tAllDayRow: Sd,
  allDayCell: Md,
  tBody: qd,
  tGrid: Td,
  tGutter: Bd,
  tCols: Ld,
  tCol: jd,
  tSel: Id,
  tEvTitle: Rd,
  tEvTime: Od,
  tEvShort: Pd,
  contTop: zd,
  contBottom: Xd,
  resize: Fd,
  now: Hd,
  agenda: Wd,
  aDay: Kd,
  aDate: Ud,
  aDateBtn: Gd,
  aDayNum: Yd,
  aDayWd: Vd,
  aList: Qd,
  aTime: Jd,
  aTitle: Zd,
  aSpan: ef,
  aLoc: tf,
  empty: nf,
  pop: af,
  popHead: rf,
  popDay: of,
  popClose: sf,
  popList: lf,
  tAllDayOnly: cf
}, pn = 22, uf = {
  accent: S.tAccent,
  ok: S.tOk,
  warn: S.tWarn,
  danger: S.tDanger,
  violet: S.tViolet,
  gray: S.tGray
};
function Rn(e) {
  var t;
  return e.color ? "" : uf[(t = e.tone) != null ? t : "accent"];
}
function On(e) {
  if (e.color)
    return { "--ev": e.color };
}
function zr(e, t) {
  return [e.ev.title, ga(e, t.allDay), e.ev.location].filter(Boolean).join(", ");
}
const sn = (e, t) => !!e.onEventChange && !t.locked;
function xn(e, t, a) {
  var r;
  for (const o of document.elementsFromPoint(e, t)) {
    const s = (r = o.closest) == null ? void 0 : r.call(o, `[${a}]`);
    if (s) return s;
  }
  return null;
}
function Sn(e, t) {
  const a = e.clientX, r = e.clientY;
  let o = !1;
  const s = (u) => {
    !o && Math.hypot(u.clientX - a, u.clientY - r) < 4 || (o = !0, t.move(u));
  }, l = () => {
    window.removeEventListener("pointermove", s), window.removeEventListener("pointerup", c), window.removeEventListener("pointercancel", i), window.removeEventListener("keydown", m, !0);
  }, c = (u) => {
    l(), t.end(u, o);
  }, i = () => {
    l(), t.cancel();
  }, m = (u) => {
    u.key === "Escape" && (u.preventDefault(), u.stopPropagation(), i());
  };
  window.addEventListener("pointermove", s), window.addEventListener("pointerup", c), window.addEventListener("pointercancel", i), window.addEventListener("keydown", m, !0);
}
function Xr(e) {
  const [t, a] = A(null), [r, o] = A(null), s = B(!1);
  return { preview: t, items: (f, p) => jn(e.events, f, p, t), onItemDown: (f, p) => {
    var d;
    if (f.button !== 0 || !sn(e, p.ev)) return;
    const _ = (d = xn(f.clientX, f.clientY, "data-cal-day")) == null ? void 0 : d.dataset.calDay;
    if (!_) return;
    s.current = !1;
    let y = 0;
    Sn(f, {
      move: (b) => {
        var $;
        s.current = !0;
        const N = ($ = xn(b.clientX, b.clientY, "data-cal-day")) == null ? void 0 : $.dataset.calDay;
        N && (y = Gt(_, N), a({ id: p.ev.id, ...oa(p, y * Se) }));
      },
      end: (b, N) => {
        var $;
        a(null), N && y && (($ = e.onEventChange) == null || $.call(e, p.ev, oa(p, y * Se)));
      },
      cancel: () => a(null)
    });
  }, onCellDown: (f, p) => {
    if (f.button !== 0 || !e.onCreate) return;
    f.preventDefault();
    let _ = p;
    o({ a: p, b: p }), Sn(f, {
      move: (y) => {
        var b;
        const d = (b = xn(y.clientX, y.clientY, "data-cal-day")) == null ? void 0 : b.dataset.calDay;
        d && (_ = d, o({ a: p, b: d }));
      },
      end: () => {
        var b;
        o(null);
        const [y, d] = p <= _ ? [p, _] : [_, p];
        (b = e.onCreate) == null || b.call(e, { start: y, end: d, allDay: !0 });
      },
      cancel: () => o(null)
    });
  }, clickItem: (f, p) => {
    var _;
    if (s.current) {
      s.current = !1;
      return;
    }
    (_ = e.onEventClick) == null || _.call(e, p, f);
  }, inSel: (f) => !!r && f >= (r.a < r.b ? r.a : r.b) && f <= (r.a < r.b ? r.b : r.a) };
}
function Fr({
  segs: e,
  cols: t,
  top: a,
  ctx: r,
  drag: o
}) {
  return /* @__PURE__ */ n.createElement("div", { className: S.barLayer }, e.map((s) => {
    var f;
    const l = s.item, c = l.ev, i = vm(l), m = Je(l.s - pe(l.sDay)), u = [
      S.chip,
      i ? S.bar : S.dotChip,
      Rn(c),
      s.contL ? S.contL : "",
      s.contR ? S.contR : "",
      ((f = o.preview) == null ? void 0 : f.id) === c.id ? S.ghost : "",
      sn(r, c) ? S.movable : ""
    ].filter(Boolean).join(" ");
    return /* @__PURE__ */ n.createElement(
      "button",
      {
        key: `${c.id}:${s.col}`,
        type: "button",
        className: u,
        style: {
          left: `calc(${s.col / t * 100}% + 2px)`,
          width: `calc(${s.span / t * 100}% - 4px)`,
          top: a + s.lane * pn,
          ...On(c)
        },
        "aria-label": zr(l, r.L),
        onPointerDown: (p) => o.onItemDown(p, l),
        onClick: (p) => o.clickItem(p.currentTarget, c)
      },
      i ? /* @__PURE__ */ n.createElement("span", { className: S.chipTitle }, !l.allDay && !s.contL && /* @__PURE__ */ n.createElement("span", { className: S.chipTime }, m), c.title) : /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("i", { className: S.dot, "aria-hidden": !0 }), /* @__PURE__ */ n.createElement("span", { className: S.chipTime }, m), /* @__PURE__ */ n.createElement("span", { className: S.chipTitle }, c.title))
    );
  }));
}
const Wn = 26;
function mf({ ctx: e }) {
  const { L: t, cursor: a, today: r, weekStartsOn: o, showWeekends: s, holidays: l } = e, c = a.slice(0, 7), i = ke(
    () => Rr(a, o).map((x) => s ? x : x.filter((h) => !fn(h))),
    [a, o, s]
  ), m = i[0].length, u = Xr(e), f = u.items(i[0][0], i[i.length - 1][m - 1]), p = B(null), [_, y] = A(0);
  $e(() => {
    const x = p.current;
    if (!x) return;
    const h = () => y(x.clientHeight / i.length);
    if (h(), typeof ResizeObserver == "undefined") return;
    const w = new ResizeObserver(h);
    return w.observe(x), () => w.disconnect();
  }, [i.length]);
  const d = _ ? Math.max(1, Math.floor((_ - Wn - 4) / pn)) : 3, b = B(!1), N = B(null);
  U(() => {
    var x, h;
    b.current && (b.current = !1, (h = (x = N.current) == null ? void 0 : x.querySelector(`[data-cal-day="${a}"]`)) == null || h.focus());
  }, [a, c]);
  const $ = (x, h) => {
    let w = ve(x, h);
    for (; !s && fn(w); ) w = ve(w, h > 0 ? 1 : -1);
    return w;
  }, g = (x, h, w) => {
    let E = null;
    if (x.key === "ArrowLeft") E = $(h, -1);
    else if (x.key === "ArrowRight") E = $(h, 1);
    else if (x.key === "ArrowUp") E = $(h, -7);
    else if (x.key === "ArrowDown") E = $(h, 7);
    else if (x.key === "Home") E = w[0];
    else if (x.key === "End") E = w[w.length - 1];
    else if (x.key === "Enter" || x.key === " ") {
      x.preventDefault(), e.goto("day", h);
      return;
    }
    E && (x.preventDefault(), b.current = !0, e.setCursor(E));
  };
  return /* @__PURE__ */ n.createElement("div", { className: S.month, role: "grid", "aria-label": t.ym(`${c}-01`), ref: N }, /* @__PURE__ */ n.createElement("div", { className: S.mHead, role: "row" }, i[0].map((x) => {
    const h = Ie(de(x));
    return /* @__PURE__ */ n.createElement("div", { key: x, role: "columnheader", className: [S.wdName, h === 0 ? S.sun : "", h === 6 ? S.sat : ""].join(" ") }, t.weekdays[h]);
  })), /* @__PURE__ */ n.createElement("div", { className: S.mBody, ref: p }, i.map((x) => {
    const { shown: h, more: w } = Nm(Or(f, x), m, d);
    return /* @__PURE__ */ n.createElement("div", { key: x[0], className: S.mWeek, role: "row" }, /* @__PURE__ */ n.createElement("div", { className: S.mCells, style: { gridTemplateColumns: `repeat(${m}, minmax(0, 1fr))` } }, x.map((E) => {
      const D = de(E), C = Ie(D), q = l[E], M = f.filter((T) => T.sDay <= E && T.eDay >= E).length, I = [
        S.cell,
        E.slice(0, 7) !== c ? S.out : "",
        C === 0 || q ? S.sun : C === 6 ? S.sat : "",
        E === r ? S.isToday : "",
        u.inSel(E) ? S.selDay : "",
        e.onCreate ? S.creatable : ""
      ].filter(Boolean).join(" ");
      return /* @__PURE__ */ n.createElement(
        "div",
        {
          key: E,
          role: "gridcell",
          "data-cal-day": E,
          tabIndex: E === a ? 0 : -1,
          "aria-selected": E === a,
          "aria-current": E === r ? "date" : void 0,
          "aria-label": `${t.dayAria(E)}${q ? ` ${q}` : ""}, ${t.eventCount(M)}`,
          className: I,
          onPointerDown: (T) => u.onCellDown(T, E),
          onKeyDown: (T) => g(T, E, x)
        },
        /* @__PURE__ */ n.createElement("div", { className: S.cellHead }, /* @__PURE__ */ n.createElement(
          "button",
          {
            type: "button",
            tabIndex: -1,
            className: S.dayNum,
            "aria-label": t.openDay(E),
            onPointerDown: (T) => T.stopPropagation(),
            onClick: () => e.goto("day", E)
          },
          D.d === 1 ? t.md(E) : D.d
        ), q && /* @__PURE__ */ n.createElement("span", { className: S.holiday, title: q }, q), e.onCreate && /* @__PURE__ */ n.createElement("span", { className: S.addHint, "aria-hidden": !0 }, "+"))
      );
    })), /* @__PURE__ */ n.createElement(Fr, { segs: h, cols: m, top: Wn, ctx: e, drag: u }), w.map((E, D) => E > 0 ? /* @__PURE__ */ n.createElement(
      "button",
      {
        key: x[D],
        type: "button",
        className: S.more,
        style: {
          left: `calc(${D / m * 100}% + 2px)`,
          width: `calc(${100 / m}% - 4px)`,
          top: Wn + (d - 1) * pn
        },
        onClick: (C) => e.openMore(x[D], C.currentTarget)
      },
      t.more(E)
    ) : null));
  })));
}
const Ye = 44, df = Array.from({ length: 23 }, (e, t) => t + 1);
function Ra() {
  const e = /* @__PURE__ */ new Date();
  return Date.UTC(e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes()) / 6e4;
}
function Kn(e, t) {
  const a = t.getBoundingClientRect();
  return Math.max(0, Math.min(Se, (e - a.top) / Ye * 60));
}
function Oa({ ctx: e, days: t }) {
  const a = t.length, r = e.slotMinutes, o = Xr(e), [s, l] = A(null), [c, i] = A(null), m = B(!1), u = jn(e.events, t[0], t[a - 1], s != null ? s : o.preview), f = Or(e.timeGrid ? u.filter(Ir) : u, t), p = f.reduce((h, w) => Math.max(h, w.lane + 1), 0), _ = { gridTemplateColumns: `repeat(${a}, minmax(0, 1fr))` }, [y, d] = A(Ra);
  U(() => {
    const h = window.setInterval(() => d(Ra()), 6e4);
    return () => window.clearInterval(h);
  }, []);
  const b = B(null), N = t.includes(e.today);
  $e(() => {
    const h = b.current;
    if (!h) return;
    const w = N ? Math.max(0, Math.floor((y - pe(e.today)) / 60) - 1) : e.scrollToHour;
    h.scrollTop = w * Ye;
  }, [t[0], a]);
  const $ = (h, w) => {
    if (h.button !== 0 || !e.onCreate) return;
    h.preventDefault();
    const E = h.currentTarget, D = Math.min(Se - r, Math.floor(Kn(h.clientY, E) / r) * r);
    let C = D;
    i({ day: w, a: D, b: D + r }), Sn(h, {
      move: (q) => {
        C = Math.min(Se - r, Math.floor(Kn(q.clientY, E) / r) * r), i({ day: w, a: Math.min(D, C), b: Math.max(D, C) + r });
      },
      end: (q, M) => {
        var Y;
        i(null);
        const I = pe(w), T = M ? Math.min(D, C) : D, F = M ? Math.max(D, C) + r : Math.min(D + 60, Se);
        (Y = e.onCreate) == null || Y.call(e, { start: on(I + T), end: on(I + F), allDay: !1 });
      },
      cancel: () => i(null)
    });
  }, g = (h, w, E) => {
    if (h.stopPropagation(), h.button !== 0 || !sn(e, w.ev)) return;
    const D = (M, I) => {
      const T = xn(M, I, "data-cal-col");
      return T ? pe(T.dataset.calCol) + Kn(I, T) : null;
    }, C = D(h.clientX, h.clientY);
    if (C == null) return;
    m.current = !1;
    let q = null;
    Sn(h, {
      move: (M) => {
        m.current = !0;
        const I = D(M.clientX, M.clientY);
        if (I != null) {
          if (E === "move") {
            const T = ja(I - C, r);
            q = T ? oa(w, T) : null;
          } else {
            const T = Math.max(w.s + r, ja(I, r));
            q = T !== w.e ? { start: w.ev.start, end: on(T) } : null;
          }
          l(q ? { id: w.ev.id, ...q } : null);
        }
      },
      end: (M, I) => {
        var T;
        l(null), I && q && ((T = e.onEventChange) == null || T.call(e, w.ev, q));
      },
      cancel: () => l(null)
    });
  }, x = (h, w) => {
    var E;
    if (m.current) {
      m.current = !1;
      return;
    }
    (E = e.onEventClick) == null || E.call(e, w, h);
  };
  return /* @__PURE__ */ n.createElement("div", { className: S.time }, /* @__PURE__ */ n.createElement("div", { className: S.tHead }, /* @__PURE__ */ n.createElement("div", { className: S.gutter }), /* @__PURE__ */ n.createElement("div", { className: S.tHeadDays, style: _ }, t.map((h) => {
    const w = de(h), E = Ie(w), D = e.holidays[h];
    return /* @__PURE__ */ n.createElement(
      "div",
      {
        key: h,
        className: [S.tDay, h === e.today ? S.isToday : "", E === 0 || D ? S.sun : E === 6 ? S.sat : ""].join(" ")
      },
      /* @__PURE__ */ n.createElement("button", { type: "button", className: S.tDayBtn, onClick: () => e.goto("day", h), "aria-label": e.L.openDay(h) }, /* @__PURE__ */ n.createElement("span", { className: S.tWd }, e.L.weekdays[E]), /* @__PURE__ */ n.createElement("span", { className: S.tDayNum }, w.d)),
      D && /* @__PURE__ */ n.createElement("span", { className: S.holiday, title: D }, D)
    );
  }))), /* @__PURE__ */ n.createElement("div", { className: [S.tAllDay, e.timeGrid ? "" : S.tAllDayOnly].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("div", { className: S.gutter }, e.timeGrid ? e.L.allDay : ""), /* @__PURE__ */ n.createElement(
    "div",
    {
      className: S.tAllDayRow,
      style: e.timeGrid ? { height: Math.max(1, p) * pn + 6 } : { minHeight: Math.max(1, p) * pn + 6 }
    },
    /* @__PURE__ */ n.createElement("div", { className: S.tAllDayCells, style: _ }, t.map((h) => /* @__PURE__ */ n.createElement(
      "div",
      {
        key: h,
        "data-cal-day": h,
        className: [S.allDayCell, o.inSel(h) ? S.selDay : "", e.onCreate ? S.creatable : ""].join(" "),
        onPointerDown: (w) => o.onCellDown(w, h)
      }
    ))),
    /* @__PURE__ */ n.createElement(Fr, { segs: f, cols: a, top: 3, ctx: e, drag: o })
  )), e.timeGrid && /* @__PURE__ */ n.createElement("div", { className: S.tBody, ref: b }, /* @__PURE__ */ n.createElement("div", { className: S.tGrid, style: { height: 24 * Ye } }, /* @__PURE__ */ n.createElement("div", { className: S.tGutter, "aria-hidden": !0 }, df.map((h) => /* @__PURE__ */ n.createElement("span", { key: h, style: { top: h * Ye } }, Je(h * 60)))), /* @__PURE__ */ n.createElement("div", { className: S.tCols, style: { ..._, backgroundSize: `100% ${Ye}px` } }, t.map((h) => {
    const w = xm(u, h);
    return /* @__PURE__ */ n.createElement(
      "div",
      {
        key: h,
        "data-cal-col": h,
        className: [S.tCol, h === e.today ? S.isToday : "", e.onCreate ? S.creatable : ""].join(" "),
        onPointerDown: (E) => $(E, h)
      },
      (c == null ? void 0 : c.day) === h && /* @__PURE__ */ n.createElement("div", { className: S.tSel, style: { top: c.a / 60 * Ye, height: (c.b - c.a) / 60 * Ye } }, Je(c.a), " – ", c.b === Se ? "24:00" : Je(c.b)),
      w.map((E) => {
        const D = E.item.ev, C = (E.bottom - E.top) / 60 * Ye, q = [
          S.tEv,
          Rn(D),
          C < 34 ? S.tEvShort : "",
          E.contTop ? S.contTop : "",
          E.contBottom ? S.contBottom : "",
          (s == null ? void 0 : s.id) === D.id ? S.ghost : "",
          sn(e, D) ? S.movable : ""
        ].filter(Boolean).join(" ");
        return /* @__PURE__ */ n.createElement(
          "button",
          {
            key: D.id,
            type: "button",
            className: q,
            style: {
              top: E.top / 60 * Ye,
              height: Math.max(18, C - 1),
              left: `calc(${E.col / E.cols * 100}% + 1px)`,
              width: `calc(${100 / E.cols}% - 4px)`,
              ...On(D)
            },
            "aria-label": zr(E.item, e.L),
            onPointerDown: (M) => g(M, E.item, "move"),
            onClick: (M) => x(M.currentTarget, D)
          },
          /* @__PURE__ */ n.createElement("span", { className: S.tEvTitle }, D.title),
          /* @__PURE__ */ n.createElement("span", { className: S.tEvTime }, ga(E.item, e.L.allDay)),
          sn(e, D) && !E.contBottom && /* @__PURE__ */ n.createElement("span", { className: S.resize, "aria-hidden": !0, onPointerDown: (M) => g(M, E.item, "resize") })
        );
      }),
      h === e.today && /* @__PURE__ */ n.createElement("div", { className: S.now, style: { top: (y - pe(h)) / 60 * Ye }, "aria-hidden": !0 })
    );
  })))));
}
function Pa(e, t, a) {
  return e.sDay === e.eDay ? ga(e, a) : e.allDay ? a : t === e.sDay ? `${Je(e.s - pe(t))} ~` : t === e.eDay ? `~ ${Je(e.e - pe(t))}` : a;
}
function ff({ ctx: e }) {
  const { L: t } = e, { from: a, to: r } = ha("agenda", e.cursor, e.weekStartsOn), o = jn(e.events, a, r), s = In(a, r).filter((l) => e.showWeekends || !fn(l)).map((l) => {
    const c = pe(l), i = (u) => Pa(u, l, "") === "" ? -1 : Math.max(u.s, c), m = o.filter((u) => u.sDay <= l && u.eDay >= l);
    return { day: l, list: m.sort((u, f) => i(u) - i(f)) };
  }).filter((l) => l.list.length > 0);
  return s.length ? /* @__PURE__ */ n.createElement("div", { className: S.agenda }, s.map(({ day: l, list: c }) => {
    const i = de(l), m = e.holidays[l], u = Ie(i), f = t.weekdays[u];
    return /* @__PURE__ */ n.createElement("section", { key: l, className: [S.aDay, l === e.today ? S.isToday : ""].join(" "), "aria-label": t.dayAria(l) }, /* @__PURE__ */ n.createElement("div", { className: [S.aDate, u === 0 || m ? S.sun : u === 6 ? S.sat : ""].join(" ") }, /* @__PURE__ */ n.createElement("button", { type: "button", className: S.aDateBtn, onClick: () => e.goto("day", l) }, /* @__PURE__ */ n.createElement("span", { className: S.aDayNum }, i.d), /* @__PURE__ */ n.createElement("span", { className: S.aDayWd }, t.m(l), " · ", f)), m && /* @__PURE__ */ n.createElement("span", { className: S.holiday }, m)), /* @__PURE__ */ n.createElement("ul", { className: S.aList }, c.map((p) => {
      const _ = p.ev, y = Gt(p.sDay, p.eDay) + 1;
      return /* @__PURE__ */ n.createElement("li", { key: _.id }, /* @__PURE__ */ n.createElement(
        "button",
        {
          type: "button",
          className: [S.aRow, Rn(_)].join(" "),
          style: On(_),
          onClick: (d) => {
            var b;
            return (b = e.onEventClick) == null ? void 0 : b.call(e, _, d.currentTarget);
          }
        },
        /* @__PURE__ */ n.createElement("i", { className: S.dot, "aria-hidden": !0 }),
        /* @__PURE__ */ n.createElement("span", { className: S.aTime }, Pa(p, l, t.allDay)),
        /* @__PURE__ */ n.createElement("span", { className: S.aTitle }, _.title, y > 1 && /* @__PURE__ */ n.createElement("em", { className: S.aSpan }, t.dayOfSpan(Gt(p.sDay, l) + 1, y))),
        _.location && /* @__PURE__ */ n.createElement("span", { className: S.aLoc }, _.location)
      ));
    })));
  })) : /* @__PURE__ */ n.createElement("div", { className: S.empty }, t.empty);
}
const Un = { KeyM: "month", KeyW: "week", KeyD: "day", KeyA: "agenda" };
function za(e, t, a) {
  const [r, o] = A(t), s = e !== void 0 ? e : r;
  return [s, (c) => {
    e === void 0 && o(c), c !== s && (a == null || a(c));
  }];
}
const Xa = ({ dir: e }) => /* @__PURE__ */ n.createElement("svg", { width: "15", height: "15", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", "aria-hidden": !0 }, /* @__PURE__ */ n.createElement("path", { d: e === "l" ? "M15 5l-7 7 7 7" : "M9 5l7 7-7 7" }));
function I0({
  events: e,
  view: t,
  defaultView: a,
  onViewChange: r,
  date: o,
  defaultDate: s,
  onDateChange: l,
  views: c = ["month", "week", "day", "agenda"],
  weekStartsOn: i = 0,
  defaultShowWeekends: m = !0,
  weekendToggle: u = !0,
  holidays: f,
  slotMinutes: p = 30,
  scrollToHour: _ = 8,
  timeGrid: y = !0,
  onRangeChange: d,
  onEventClick: b,
  onCreate: N,
  onEventChange: $,
  locale: g = Pr,
  loading: x,
  headerExtra: h,
  className: w = "",
  style: E,
  "aria-label": D
}) {
  var G;
  const C = Br(), [q, M] = za(t, (G = a != null ? a : c[0]) != null ? G : "month", r), [I, T] = za(o, s != null ? s : C, l), F = de(I) ? I : C, [Y, H] = A(m), [j, ne] = A(null), te = B(null), v = B(!1);
  U(() => {
    var W;
    if (!v.current) return;
    v.current = !1;
    const X = te.current;
    !X || X.contains(document.activeElement) || ((W = X.querySelector('[data-cal-day][tabindex="0"]')) != null ? W : X).focus();
  });
  const { from: P, to: V } = ha(q, F, i), Q = B(d);
  Q.current = d, U(() => {
    var X;
    (X = Q.current) == null || X.call(Q, { from: P, to: V, view: q });
  }, [P, V, q]);
  const se = (X, W) => {
    T(W), c.includes(X) && M(X);
  }, L = {
    events: e,
    L: g,
    cursor: F,
    today: C,
    weekStartsOn: i,
    showWeekends: Y,
    holidays: f != null ? f : {},
    slotMinutes: p,
    scrollToHour: _,
    timeGrid: y,
    setCursor: T,
    goto: se,
    openMore: (X, W) => ne({ day: X, anchor: W }),
    onEventClick: b,
    onCreate: N,
    onEventChange: $
  }, Z = (X) => T(km(q, F, X, q === "day" && !Y)), R = (X) => {
    if (X.defaultPrevented || X.ctrlKey || X.metaKey || X.altKey || X.target.closest('input, textarea, select, [contenteditable="true"]')) return;
    const W = X.nativeEvent.code;
    if (W === "KeyT") T(C);
    else if (W === "KeyN" || W === "KeyJ" || X.key === "PageDown") Z(1);
    else if (W === "KeyP" || W === "KeyK" || X.key === "PageUp") Z(-1);
    else if (Un[W] && c.includes(Un[W])) M(Un[W]);
    else if (W === "KeyC" && N)
      N(q === "month" || q === "agenda" ? { start: F, end: F, allDay: !0 } : { start: `${F}T09:00`, end: `${F}T10:00`, allDay: !1 });
    else return;
    X.preventDefault(), v.current = !0;
  }, z = ke(
    () => In(P, V).filter((X) => Y || !fn(X)),
    [P, V, Y]
  );
  return /* @__PURE__ */ n.createElement(
    "div",
    {
      className: [S.cal, w].filter(Boolean).join(" "),
      style: E,
      role: "region",
      "aria-label": D != null ? D : g.region,
      "aria-busy": x || void 0,
      "aria-keyshortcuts": "T N P M W D A C",
      onKeyDown: R,
      ref: te,
      tabIndex: -1
    },
    /* @__PURE__ */ n.createElement("div", { className: S.toolbar }, /* @__PURE__ */ n.createElement(et, { onClick: () => T(C), title: `${g.today} (T)` }, g.today), /* @__PURE__ */ n.createElement("span", { className: S.navBtns }, /* @__PURE__ */ n.createElement(na, { label: g.prev(q), onClick: () => Z(-1) }, /* @__PURE__ */ n.createElement(Xa, { dir: "l" })), /* @__PURE__ */ n.createElement(na, { label: g.next(q), onClick: () => Z(1) }, /* @__PURE__ */ n.createElement(Xa, { dir: "r" }))), /* @__PURE__ */ n.createElement("h2", { className: S.title, "aria-live": "polite" }, wm(q, F, i, g)), /* @__PURE__ */ n.createElement("span", { className: S.toolRight }, h, u && q !== "day" && /* @__PURE__ */ n.createElement(
      "button",
      {
        type: "button",
        className: S.toggle,
        "aria-pressed": !Y,
        onClick: () => H((X) => !X)
      },
      g.hideWeekends
    ), c.length > 1 && /* @__PURE__ */ n.createElement(
      kr,
      {
        variant: "segmented",
        "aria-label": g.viewTabs,
        items: c.map((X) => ({ key: X, label: g.views[X] })),
        value: q,
        onChange: (X) => M(X)
      }
    ))),
    /* @__PURE__ */ n.createElement("div", { className: S.body }, x && /* @__PURE__ */ n.createElement("div", { className: S.busy, role: "progressbar", "aria-label": g.loading }), q === "month" && /* @__PURE__ */ n.createElement(mf, { ctx: L }), q === "week" && /* @__PURE__ */ n.createElement(Oa, { ctx: L, days: z }), q === "day" && /* @__PURE__ */ n.createElement(Oa, { ctx: L, days: [F] }), q === "agenda" && /* @__PURE__ */ n.createElement(ff, { ctx: L })),
    j && /* @__PURE__ */ n.createElement(pf, { ctx: L, day: j.day, anchor: j.anchor, onClose: () => ne(null) })
  );
}
function pf({ ctx: e, day: t, anchor: a, onClose: r }) {
  const o = B(null), [s, l] = A({ top: -9999, left: -9999 }), c = de(t), i = jn(e.events, t, t);
  return $e(() => {
    var _;
    const m = o.current;
    if (!m) return;
    const u = a.getBoundingClientRect(), f = m.offsetWidth, p = m.offsetHeight;
    l({
      left: Math.max(8, Math.min(u.left + u.width / 2 - f / 2, window.innerWidth - f - 8)),
      top: Math.max(8, Math.min(u.top - 60, window.innerHeight - p - 8))
    }), (_ = m.querySelector("[data-cal-pop-item]")) == null || _.focus();
  }, [a]), U(() => {
    const m = () => {
      r(), a.isConnected && a.focus();
    }, u = (p) => {
      var _;
      (_ = o.current) != null && _.contains(p.target) || r();
    }, f = (p) => {
      p.key !== "Escape" || p.isComposing || (p.preventDefault(), p.stopPropagation(), m());
    };
    return document.addEventListener("mousedown", u), document.addEventListener("keydown", f, !0), () => {
      document.removeEventListener("mousedown", u), document.removeEventListener("keydown", f, !0);
    };
  }, [a, r]), /* @__PURE__ */ n.createElement(Vt, null, /* @__PURE__ */ n.createElement("div", { ref: o, className: S.pop, style: s, role: "dialog", "aria-label": `${e.L.md(t)} ${e.L.eventCount(i.length)}` }, /* @__PURE__ */ n.createElement("div", { className: S.popHead }, /* @__PURE__ */ n.createElement("button", { type: "button", className: S.popDay, onClick: () => {
    r(), e.goto("day", t);
  } }, /* @__PURE__ */ n.createElement("span", null, e.L.weekdays[Ie(c)]), /* @__PURE__ */ n.createElement("b", null, c.d)), /* @__PURE__ */ n.createElement("button", { type: "button", className: S.popClose, "aria-label": e.L.close, onClick: r }, "✕")), /* @__PURE__ */ n.createElement("ul", { className: S.popList }, i.map((m) => {
    const u = m.ev, f = m.allDay || m.sDay !== m.eDay;
    return /* @__PURE__ */ n.createElement("li", { key: u.id }, /* @__PURE__ */ n.createElement(
      "button",
      {
        type: "button",
        "data-cal-pop-item": !0,
        className: [S.popItem, f ? S.bar : S.dotChip, Rn(u)].join(" "),
        style: On(u),
        onClick: () => {
          var p;
          r(), (p = e.onEventClick) == null || p.call(e, u, a);
        }
      },
      !f && /* @__PURE__ */ n.createElement("i", { className: S.dot, "aria-hidden": !0 }),
      !m.allDay && /* @__PURE__ */ n.createElement("span", { className: S.chipTime }, Je(Math.max(m.s, pe(t)) - pe(t))),
      /* @__PURE__ */ n.createElement("span", { className: S.chipTitle }, u.title)
    ));
  }))));
}
const _f = "_mini_q7p5n_3", yf = "_nav_q7p5n_5", bf = "_navBtn_q7p5n_6", Ef = "_todayBtn_q7p5n_6", hf = "_title_q7p5n_6", gf = "_day_q7p5n_25", vf = "_mon_q7p5n_25", kf = "_grid_q7p5n_29", wf = "_wdRow_q7p5n_30", Nf = "_row_q7p5n_30", $f = "_sun_q7p5n_35", xf = "_sat_q7p5n_36", Df = "_num_q7p5n_45", Af = "_sel_q7p5n_46", Cf = "_out_q7p5n_50", Sf = "_isToday_q7p5n_52", Mf = "_dots_q7p5n_55", qf = "_months_q7p5n_59", le = {
  mini: _f,
  nav: yf,
  navBtn: bf,
  todayBtn: Ef,
  title: hf,
  day: gf,
  mon: vf,
  grid: kf,
  wdRow: wf,
  row: Nf,
  sun: $f,
  sat: xf,
  num: Df,
  sel: Af,
  out: Cf,
  isToday: Sf,
  dots: Mf,
  months: qf
}, Fa = (e, t) => `${String(e).padStart(4, "0")}-${String(t).padStart(2, "0")}`;
function R0({
  month: e,
  onMonthChange: t,
  value: a,
  onPick: r,
  marks: o = {},
  markLabel: s,
  holidays: l = {},
  weekStartsOn: c = 0,
  locale: i = Pr,
  today: m,
  children: u,
  className: f = "",
  "aria-label": p
}) {
  const _ = m != null ? m : Br(), y = /^\d{4}-\d{2}$/.test(e) ? `${e}-01` : `${_.slice(0, 7)}-01`, d = de(y), b = Cn(y, c), N = In(b, ve(b, 41)), $ = s != null ? s : i.eventCount, [g, x] = A("day"), [h, w] = A(d.y), E = (H) => !!H && H.slice(0, 7) === y.slice(0, 7), [D, C] = A(() => E(a) ? a : E(_) ? _ : y);
  U(() => {
    E(D) || C(E(a) ? a : E(_) ? _ : y);
  }, [y]);
  const q = B(!1), M = B(null);
  U(() => {
    var H, j;
    q.current && (q.current = !1, (j = (H = M.current) == null ? void 0 : H.querySelector(`[data-day="${D}"]`)) == null || j.focus());
  }, [D, y]);
  const I = (H) => {
    q.current = !0, C(H), E(H) || t(H.slice(0, 7));
  }, T = (H) => {
    const j = wt(d, H);
    t(Fa(j.y, j.m));
  }, F = (H, j) => {
    const ne = de(j), te = (Ie(ne) - c + 7) % 7;
    let v = null;
    if (H.key === "ArrowLeft") v = ve(j, -1);
    else if (H.key === "ArrowRight") v = ve(j, 1);
    else if (H.key === "ArrowUp") v = ve(j, -7);
    else if (H.key === "ArrowDown") v = ve(j, 7);
    else if (H.key === "Home") v = ve(j, -te);
    else if (H.key === "End") v = ve(j, 6 - te);
    else if (H.key === "PageUp" || H.key === "PageDown") {
      const P = wt(ne, H.key === "PageUp" ? -1 : 1);
      v = tt(P.y, P.m, P.d);
    }
    v && (H.preventDefault(), I(v));
  }, Y = () => {
    w(d.y), x("month");
  };
  return /* @__PURE__ */ n.createElement("div", { className: [le.mini, f].filter(Boolean).join(" "), role: p ? "group" : void 0, "aria-label": p }, g === "day" ? /* @__PURE__ */ n.createElement("div", { className: le.nav }, /* @__PURE__ */ n.createElement("button", { type: "button", className: le.navBtn, "aria-label": i.prevMonth, onClick: () => T(-1) }, "‹"), /* @__PURE__ */ n.createElement("button", { type: "button", className: le.title, "aria-label": `${i.ym(y)}, ${i.pickMonth}`, "aria-live": "polite", onClick: Y }, i.ym(y)), /* @__PURE__ */ n.createElement("button", { type: "button", className: le.navBtn, "aria-label": i.nextMonth, onClick: () => T(1) }, "›"), /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      className: le.todayBtn,
      disabled: E(_),
      onClick: () => {
        t(_.slice(0, 7)), I(_);
      }
    },
    i.today
  )) : /* @__PURE__ */ n.createElement("div", { className: le.nav }, /* @__PURE__ */ n.createElement("button", { type: "button", className: le.navBtn, "aria-label": i.prevYear, onClick: () => w((H) => H - 1) }, "‹"), /* @__PURE__ */ n.createElement("span", { className: le.title, "aria-live": "polite" }, i.year(`${h}-12-31`)), /* @__PURE__ */ n.createElement("button", { type: "button", className: le.navBtn, "aria-label": i.nextYear, onClick: () => w((H) => H + 1) }, "›"), /* @__PURE__ */ n.createElement("button", { type: "button", className: le.todayBtn, onClick: () => x("day"), "aria-label": i.close }, "✕")), g === "month" ? /* @__PURE__ */ n.createElement("div", { className: le.months, onKeyDown: (H) => {
    H.key === "Escape" && (H.preventDefault(), x("day"));
  } }, Array.from({ length: 12 }, (H, j) => {
    const ne = Fa(h, j + 1), te = ne === y.slice(0, 7);
    return /* @__PURE__ */ n.createElement(
      "button",
      {
        key: ne,
        type: "button",
        className: [le.mon, te ? le.sel : "", ne === _.slice(0, 7) ? le.isToday : ""].filter(Boolean).join(" "),
        "aria-pressed": te,
        autoFocus: te,
        onClick: () => {
          t(ne), x("day");
        }
      },
      i.m(`${ne}-01`)
    );
  })) : /* @__PURE__ */ n.createElement("div", { className: le.grid, role: "grid", "aria-label": i.ym(y), ref: M }, /* @__PURE__ */ n.createElement("div", { className: le.wdRow, role: "row" }, N.slice(0, 7).map((H) => {
    const j = Ie(de(H));
    return /* @__PURE__ */ n.createElement("span", { key: H, role: "columnheader", className: j === 0 ? le.sun : j === 6 ? le.sat : "" }, i.weekdays[j]);
  })), [0, 1, 2, 3, 4, 5].map((H) => /* @__PURE__ */ n.createElement("div", { key: H, className: le.row, role: "row" }, N.slice(H * 7, H * 7 + 7).map((j) => {
    var V;
    const ne = Ie(de(j)), te = l[j], v = (V = o[j]) != null ? V : 0, P = [
      le.day,
      E(j) ? "" : le.out,
      ne === 0 || te ? le.sun : ne === 6 ? le.sat : "",
      j === _ ? le.isToday : "",
      j === a ? le.sel : ""
    ].filter(Boolean).join(" ");
    return /* @__PURE__ */ n.createElement(
      "button",
      {
        key: j,
        type: "button",
        role: "gridcell",
        "data-day": j,
        className: P,
        tabIndex: j === D ? 0 : -1,
        "aria-selected": j === a,
        "aria-current": j === _ ? "date" : void 0,
        "aria-label": [i.dayAria(j), te, v ? $(v) : ""].filter(Boolean).join(", "),
        onKeyDown: (Q) => F(Q, j),
        onFocus: () => C(j),
        onClick: () => r(j)
      },
      /* @__PURE__ */ n.createElement("span", { className: le.num }, +j.slice(8)),
      /* @__PURE__ */ n.createElement("span", { className: le.dots, "aria-hidden": !0 }, Array.from({ length: Math.min(v, 3) }, (Q, se) => /* @__PURE__ */ n.createElement("i", { key: se })))
    );
  })))), u);
}
function Tf(e) {
  const t = e.match(/\d/g);
  return t ? t.length : 0;
}
function O0({
  value: e,
  onChangeAm: t,
  allowNegative: a = !0,
  onReject: r,
  unit: o,
  className: s,
  ...l
}) {
  const c = B(null), i = B(null), [m, u] = A(!1), f = e == null || e === "";
  $e(() => {
    const _ = c.current, y = i.current;
    if (i.current = null, !_ || y === null) return;
    let d = 0, b = 0;
    for (; d < _.value.length && b < y; )
      /\d/.test(_.value[d]) && (b += 1), d += 1;
    d === 0 && _.value[0] === "-" && (d = 1), _.setSelectionRange(d, d);
  });
  const p = /* @__PURE__ */ n.createElement(
    "input",
    {
      ...l,
      ref: c,
      type: "text",
      inputMode: "numeric",
      className: s,
      value: m && f ? "-" : fo(e),
      onChange: (_) => {
        var b;
        const y = _.target;
        i.current = Tf(y.value.slice(0, (b = y.selectionStart) != null ? b : y.value.length));
        const d = uo(y.value, a);
        if (r) {
          const N = Er(y.value);
          !a && /^\s*-/.test(N) ? r("sign") : (/\.\d/.test(N.replace(/^\s*-/, "")) || /\.$/.test(N)) && r("decimal");
        }
        u(d === "-"), t({ text: d, num: mo(d) });
      }
    }
  );
  return o ? /* @__PURE__ */ n.createElement(n.Fragment, null, p, /* @__PURE__ */ n.createElement("span", { className: "axe-money-unit", style: { marginLeft: 6, fontSize: 12, color: "#334155", whiteSpace: "nowrap" } }, o)) : p;
}
function sa(e) {
  const t = Er(e).replace(/,/g, "").trim();
  if (t === "") return null;
  const a = Number(t);
  return Number.isFinite(a) ? a : null;
}
function Ha(e, t) {
  const a = sa(e), r = sa(t);
  return a == null || r == null ? null : Math.round(a * r);
}
function P0(e, t) {
  var s, l;
  const a = Ha(e.qty, e.unitAm), r = Ha((s = t.qty) != null ? s : e.qty, (l = t.unitAm) != null ? l : e.unitAm);
  if (r == null) return t;
  const o = sa(e.lineAm);
  return o == null || o === a ? { ...t, lineAm: String(r) } : t;
}
const Bf = "_box_qzg36_3", Lf = "_banner_qzg36_9", jf = "_verify_qzg36_10", If = "_t_info_qzg36_15", Rf = "_t_warn_qzg36_16", Of = "_t_danger_qzg36_17", Pf = "_error_qzg36_22", zf = "_note_qzg36_30", Xf = "_noteI_qzg36_42", Ff = "_noteBody_qzg36_43", Hf = "_badge_qzg36_49", Wf = "_b_muted_qzg36_53", Kf = "_b_ok_qzg36_54", Uf = "_b_warn_qzg36_55", Gf = "_b_info_qzg36_56", Yf = "_b_off_qzg36_57", Xe = {
  box: Bf,
  banner: Lf,
  verify: jf,
  t_info: If,
  t_warn: Rf,
  t_danger: Of,
  error: Pf,
  note: zf,
  noteI: Xf,
  noteBody: Ff,
  badge: Hf,
  b_muted: Wf,
  b_ok: Kf,
  b_warn: Uf,
  b_info: Gf,
  b_off: Yf
};
function Vf({ tone: e = "warn", className: t = "", children: a }) {
  return /* @__PURE__ */ n.createElement("div", { className: [Xe.box, Xe.banner, Xe[`t_${e}`], t].filter(Boolean).join(" ") }, a);
}
function z0({ tone: e = "ok", className: t = "", children: a }) {
  const r = e === "ok" ? "info" : e === "bad" ? "danger" : "warn";
  return /* @__PURE__ */ n.createElement("div", { className: [Xe.box, Xe.verify, Xe[`t_${r}`], t].filter(Boolean).join(" ") }, a);
}
function Hr({ className: e = "", children: t }) {
  return t == null || t === !1 || t === "" ? null : /* @__PURE__ */ n.createElement("p", { className: [Xe.error, e].filter(Boolean).join(" "), role: "alert" }, typeof t == "string" ? /* @__PURE__ */ n.createElement(Qf, { text: t }) : t);
}
function X0({ label: e = "안내", className: t = "", children: a }) {
  return /* @__PURE__ */ n.createElement("details", { className: [Xe.note, t].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("summary", null, /* @__PURE__ */ n.createElement("span", { className: Xe.noteI, "aria-hidden": "true" }, "ⓘ"), e), /* @__PURE__ */ n.createElement("div", { className: Xe.noteBody }, a));
}
function Wa({ tone: e = "muted", className: t = "", children: a }) {
  return /* @__PURE__ */ n.createElement("span", { className: ["axe-badge", Xe.badge, Xe[`b_${e}`], t].filter(Boolean).join(" ") }, a);
}
function Qf({ text: e }) {
  return e ? /* @__PURE__ */ n.createElement(n.Fragment, null, e.split(/\*\*(.+?)\*\*/g).map((t, a) => a % 2 ? /* @__PURE__ */ n.createElement("b", { key: a }, t) : /* @__PURE__ */ n.createElement(lo, { key: a }, t))) : null;
}
const Jf = "저장하지 않은 변경이 있습니다. 버리고 이동할까요?";
function Zf(e, t = Jf) {
  const a = B(e);
  return a.current = e, U(() => {
    if (!e) return;
    const r = (o) => {
      o.preventDefault(), o.returnValue = "";
    };
    return window.addEventListener("beforeunload", r), () => window.removeEventListener("beforeunload", r);
  }, [e]), re(() => !a.current || window.confirm(t), [t]);
}
const ep = "_overlay_1s8aj_2", tp = "_modal_1s8aj_8", np = "_wide_1s8aj_15", ap = "_head_1s8aj_16", rp = "_title_1s8aj_20", op = "_close_1s8aj_21", sp = "_body_1s8aj_25", lp = "_flush_1s8aj_26", cp = "_error_1s8aj_27", ip = "_foot_1s8aj_29", up = "_overlayTop_1s8aj_35", Pe = {
  overlay: ep,
  modal: tp,
  wide: np,
  head: ap,
  title: rp,
  close: op,
  body: sp,
  flush: lp,
  error: cp,
  foot: ip,
  overlayTop: up
}, Tt = [];
function Ka(e) {
  const t = Tt[Tt.length - 1];
  if (e.key !== "Escape" || e.defaultPrevented || e.isComposing || !t || !t.esc) return;
  const a = document.activeElement;
  a instanceof HTMLSelectElement || a != null && a.closest('[aria-expanded="true"]') || (e.preventDefault(), t.close());
}
const mp = 'a[href],button:not(:disabled),input:not(:disabled):not([type=hidden]),select:not(:disabled),textarea:not(:disabled),[tabindex]:not([tabindex="-1"])';
function Ua(e) {
  return Array.from(e.querySelectorAll(mp)).filter((t) => t.getClientRects().length > 0 && getComputedStyle(t).visibility !== "hidden");
}
let Ga = 0, Ya = "";
function Pn({
  title: e,
  onClose: t,
  children: a,
  wide: r,
  footer: o,
  headerExtra: s,
  flush: l,
  closeOnBackdrop: c = !0,
  closeOnEsc: i = !0,
  error: m,
  confirmDiscard: u = !0,
  layer: f
}) {
  const [p, _] = A(!1), y = u ? () => {
    p || _(!0);
  } : void 0, d = Zf(u && p, "입력한 내용을 저장하지 않고 닫을까요?"), b = () => {
    d() && t();
  }, N = B(b);
  N.current = b;
  const $ = B({ close: () => N.current(), esc: i });
  $.current.esc = i, U(() => {
    const E = $.current;
    return Tt.push(E), Tt.length === 1 && window.addEventListener("keydown", Ka), () => {
      const D = Tt.lastIndexOf(E);
      D >= 0 && Tt.splice(D, 1), Tt.length === 0 && window.removeEventListener("keydown", Ka);
    };
  }, []);
  const g = B(null), x = B(null), h = B(void 0);
  h.current === void 0 && (h.current = typeof document == "undefined" ? null : document.activeElement), U(() => {
    var C;
    const E = g.current, D = (C = h.current) != null ? C : null;
    return E && !E.contains(document.activeElement) && (x.current && Ua(x.current)[0] || null || E).focus(), Ga++ === 0 && (Ya = document.body.style.overflow, document.body.style.overflow = "hidden"), () => {
      --Ga === 0 && (document.body.style.overflow = Ya), D && D.isConnected && typeof D.focus == "function" && D.focus();
    };
  }, []);
  const w = (E) => {
    const D = g.current;
    if (E.key !== "Tab" || !D || !D.contains(E.target)) return;
    const C = Ua(D);
    if (C.length === 0) {
      E.preventDefault(), D.focus();
      return;
    }
    const q = C[0], M = C[C.length - 1], I = document.activeElement;
    E.shiftKey && (I === q || I === D) ? (E.preventDefault(), M.focus()) : !E.shiftKey && I === M && (E.preventDefault(), q.focus());
  };
  return /* @__PURE__ */ n.createElement("div", { className: f === "top" ? `${Pe.overlay} ${Pe.overlayTop}` : Pe.overlay, onClick: c ? b : void 0 }, /* @__PURE__ */ n.createElement(
    "div",
    {
      ref: g,
      tabIndex: -1,
      className: [Pe.modal, r ? Pe.wide : ""].filter(Boolean).join(" "),
      role: "dialog",
      "aria-modal": "true",
      "aria-label": e,
      onClick: (E) => E.stopPropagation(),
      onKeyDown: w
    },
    /* @__PURE__ */ n.createElement("header", { className: Pe.head }, /* @__PURE__ */ n.createElement("strong", { className: Pe.title }, e), s, /* @__PURE__ */ n.createElement("button", { type: "button", className: Pe.close, onClick: b, "aria-label": "닫기" }, "✕")),
    /* @__PURE__ */ n.createElement(
      "div",
      {
        ref: x,
        className: [Pe.body, l ? Pe.flush : ""].filter(Boolean).join(" "),
        onInputCapture: y,
        onChangeCapture: y
      },
      a
    ),
    m != null && m !== !1 && m !== "" && /* @__PURE__ */ n.createElement("div", { className: Pe.error }, /* @__PURE__ */ n.createElement(Hr, null, m)),
    o && /* @__PURE__ */ n.createElement("footer", { className: Pe.foot }, o)
  ));
}
function F0(e = 4e3) {
  const [t, a] = A(""), [r, o] = A(!1), s = B(void 0), l = re((m) => {
    window.clearTimeout(s.current), o(!1), a(m), s.current = window.setTimeout(() => a(""), e);
  }, [e]), c = re((m) => {
    window.clearTimeout(s.current), o(!0), a(m);
  }, []), i = re(() => {
    window.clearTimeout(s.current), o(!1), a("");
  }, []);
  return [t, l, c, r, i];
}
const dp = "_message_psco6_1", fp = "_details_psco6_2", pp = "_warn_psco6_7", _p = "_field_psco6_8", gn = {
  message: dp,
  details: fp,
  warn: pp,
  field: _p
};
function H0() {
  var _, y;
  const [e, t] = A(null), [a, r] = A(""), o = B(null), s = B(null), l = B(null), c = re((d) => new Promise((b) => {
    t({ kind: "confirm", opts: d, resolve: b });
  }), []), i = re((d) => new Promise((b) => {
    var N, $, g, x;
    r((x = (g = d.defaultValue) != null ? g : ($ = (N = d.choices) == null ? void 0 : N[0]) == null ? void 0 : $.value) != null ? x : ""), t({ kind: "prompt", opts: d, resolve: b });
  }), []);
  U(() => {
    var d, b, N;
    e && (e.kind === "prompt" ? (d = l.current) == null || d.focus() : e.opts.danger || e.opts.focusCancel ? (b = s.current) == null || b.focus() : (N = o.current) == null || N.focus());
  }, [e]);
  const m = (d) => {
    e && (e.kind === "confirm" ? e.resolve(d) : e.resolve(d ? a : null), t(null));
  }, u = e == null ? void 0 : e.opts, f = (e == null ? void 0 : e.kind) === "prompt" && !!e.opts.required && !a.trim(), p = e && u ? /* @__PURE__ */ n.createElement(
    Pn,
    {
      title: u.title,
      onClose: () => m(!1),
      closeOnBackdrop: !1,
      closeOnEsc: !0,
      confirmDiscard: !1,
      layer: "top",
      footer: /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement(et, { ref: s, onClick: () => m(!1) }, (_ = u.cancelLabel) != null ? _ : "취소"), /* @__PURE__ */ n.createElement(
        et,
        {
          ref: o,
          variant: u.danger ? "danger" : "primary",
          disabled: f,
          onClick: () => m(!0)
        },
        (y = u.confirmLabel) != null ? y : "확인"
      ))
    },
    u.message && /* @__PURE__ */ n.createElement("div", { className: gn.message }, u.message),
    u.details && u.details.length > 0 && /* @__PURE__ */ n.createElement("ul", { className: gn.details }, u.details.map((d, b) => /* @__PURE__ */ n.createElement("li", { key: b }, d))),
    u.irreversible && /* @__PURE__ */ n.createElement("p", { className: gn.warn }, "이 작업은 되돌릴 수 없습니다."),
    e.kind === "prompt" && /* @__PURE__ */ n.createElement("label", { className: gn.field }, /* @__PURE__ */ n.createElement("span", null, e.opts.label), e.opts.choices ? /* @__PURE__ */ n.createElement("select", { ref: l, value: a, onChange: (d) => r(d.target.value) }, e.opts.choices.map((d) => /* @__PURE__ */ n.createElement("option", { key: d.value, value: d.value }, d.label))) : /* @__PURE__ */ n.createElement(
      "input",
      {
        ref: l,
        value: a,
        placeholder: e.opts.placeholder,
        maxLength: e.opts.maxLength,
        onChange: (d) => r(d.target.value),
        onKeyDown: (d) => {
          d.key === "Enter" && !f && (d.preventDefault(), m(!0));
        }
      }
    ))
  ) : null;
  return { confirm: c, prompt: i, dialog: p };
}
function W0(e, t) {
  return (t ? `${t}에 실패했습니다 — ` : "") + yp(e);
}
function yp(e) {
  return e === 0 ? "일시적인 문제로 처리하지 못했습니다. 잠시 후 다시 시도하세요" : e === 400 || e === 422 ? "입력 내용을 처리할 수 없습니다. 입력값을 확인한 뒤 다시 시도하세요" : e === 401 ? "로그인이 만료되었습니다. 다시 로그인하세요" : e === 403 ? "이 작업을 할 권한이 없습니다" : e === 404 ? "대상을 찾을 수 없습니다" : e === 409 ? "다른 사용자가 먼저 수정했습니다. 다시 조회한 뒤 수정하세요" : e === 413 ? "보낸 자료가 너무 큽니다. 크기를 줄여 다시 시도하세요" : e === 429 ? "요청이 너무 많습니다. 잠시 후 다시 시도하세요" : e >= 500 ? "일시적인 문제로 처리하지 못했습니다. 잠시 후 다시 시도하세요" : "요청을 처리하지 못했습니다. 다시 시도하세요";
}
function K0() {
  const [e, t] = A(!1), a = B(!1), r = re(async (o) => {
    if (!a.current) {
      a.current = !0, t(!0);
      try {
        return await o();
      } finally {
        a.current = !1, t(!1);
      }
    }
  }, []);
  return [e, r];
}
function U0(e, t, a, r) {
  const [o, s] = A(null), [l, c] = A(a), [i, m] = A(null), [u, f] = A(!1), [p, _] = A(0), y = B(0), d = B(r);
  d.current = r;
  const b = re(() => _((N) => N + 1), []);
  return U(() => {
    if (!a) return;
    const N = ++y.current;
    return c(!0), e().then(($) => {
      N === y.current && (s($), m(null), f(!1));
    }).catch(($) => {
      var g, x, h;
      N === y.current && (m(d.current.errorText($)), f((h = (x = (g = d.current).isUnavailable) == null ? void 0 : x.call(g, $)) != null ? h : !1));
    }).finally(() => {
      N === y.current && c(!1);
    }), () => {
      y.current++;
    };
  }, [a, p, ...t]), { data: o, loading: l, error: i, unavailable: u, reload: b };
}
function G0(e) {
  const [t, a] = A(null), [r, o] = A(null), [s, l] = A(!1), [c, i] = A(1), m = B(0), u = B(e);
  u.current = e;
  const f = re(async (_, y) => {
    const d = ++m.current;
    l(!0), o(null);
    try {
      const b = await y(_);
      if (d !== m.current) return;
      a(b), i(_);
    } catch (b) {
      if (d !== m.current) return;
      a(null), o(u.current.errorText(b));
    } finally {
      d === m.current && l(!1);
    }
  }, []), p = re(() => {
    m.current++, a(null), o(null), l(!1);
  }, []);
  return { data: t, err: r, loading: s, page: c, load: f, clear: p };
}
const bp = "_section_dyrr7_3", Ep = "_row_dyrr7_10", hp = "_label_dyrr7_15", gp = "_value_dyrr7_21", vp = "_invalid_dyrr7_43", kp = "_help_dyrr7_45", wp = "_err_dyrr7_45", Np = "_req_dyrr7_49", $p = "_opt_dyrr7_50", xp = "_sr_dyrr7_51", Dp = "_ro_dyrr7_10", Ap = "_readonly_dyrr7_58", Cp = "_hint_dyrr7_65", Sp = "_toggle_dyrr7_73", Mp = "_table_dyrr7_80", qp = "_isReq_dyrr7_95", Ce = {
  section: bp,
  row: Ep,
  label: hp,
  value: gp,
  invalid: vp,
  help: kp,
  err: wp,
  req: Np,
  opt: $p,
  sr: xp,
  ro: Dp,
  readonly: Ap,
  hint: Cp,
  toggle: Sp,
  table: Mp,
  isReq: qp
};
let Tp = 0;
const Bp = /* @__PURE__ */ new Set(["input", "select", "textarea"]);
function Y0({
  label: e,
  children: t,
  hint: a,
  ro: r,
  htmlFor: o,
  required: s,
  optional: l,
  help: c,
  error: i,
  className: m = ""
}) {
  var h, w, E, D;
  const u = B(`axe-fr${++Tp}`).current, f = `${u}-lbl`, p = B(null), _ = c ? `${u}-help` : void 0, y = i ? `${u}-err` : void 0, d = [_, y].filter(Boolean).join(" ") || void 0, b = a && a.replace(/\*\*(.+?)\*\*/g, "$1");
  let N = t;
  const $ = ta.count(t) === 1 ? ta.toArray(t)[0] : null, g = un($) && typeof $.type != "string" && !!$.type.axeFormControl;
  if (un($) && (typeof $.type == "string" && Bp.has($.type) || g)) {
    const C = $, q = C.props;
    N = fa(C, {
      id: (h = q.id) != null ? h : o,
      "aria-describedby": (w = q["aria-describedby"]) != null ? w : d,
      "aria-invalid": (E = q["aria-invalid"]) != null ? E : i ? !0 : void 0,
      "aria-required": (D = q["aria-required"]) != null ? D : s ? !0 : void 0
    });
  }
  $e(() => {
    var I;
    const C = (I = p.current) == null ? void 0 : I.querySelector("input:not([type=hidden]):not([type=checkbox]):not([type=radio]), select, textarea");
    if (!C) return;
    const q = (T, F) => {
      const Y = `data-fr-${T}`;
      if (F == null) {
        C.hasAttribute(Y) && (C.removeAttribute(T), C.removeAttribute(Y));
        return;
      }
      C.hasAttribute(T) && !C.hasAttribute(Y) || (C.getAttribute(T) !== F && C.setAttribute(T, F), C.setAttribute(Y, ""));
    }, M = !!(C.id && document.querySelector(`label[for="${CSS.escape(C.id)}"]`));
    q("aria-labelledby", M ? null : f), q("aria-invalid", i ? "true" : null), q("aria-required", s ? "true" : null), q("aria-describedby", d != null ? d : null);
  });
  const x = /* @__PURE__ */ n.createElement(n.Fragment, null, e, s && /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("span", { className: Ce.req, "aria-hidden": "true" }, "*"), /* @__PURE__ */ n.createElement("span", { className: Ce.sr }, "필수")), l && /* @__PURE__ */ n.createElement("span", { className: Ce.opt }, "(선택)"));
  return /* @__PURE__ */ n.createElement("div", { className: ["axe-form-row", Ce.row, r ? Ce.ro : "", i ? Ce.invalid : "", s ? Ce.isReq : "", m].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("span", { className: `axe-form-label ${Ce.label}` }, o ? /* @__PURE__ */ n.createElement("label", { htmlFor: o, id: f }, x) : /* @__PURE__ */ n.createElement("span", { id: f }, x), a && /* @__PURE__ */ n.createElement(It, { content: b, describe: !1 }, /* @__PURE__ */ n.createElement("span", { className: `axe-form-hint ${Ce.hint}`, role: "img", "aria-label": `도움말: ${b}`, tabIndex: 0 }, "?"))), /* @__PURE__ */ n.createElement("span", { ref: p, className: `axe-form-value ${Ce.value}` }, N, c && /* @__PURE__ */ n.createElement("span", { id: _, className: Ce.help }, c), i && /* @__PURE__ */ n.createElement("span", { id: y, className: Ce.err }, i)));
}
function V0({ title: e, children: t, className: a = "", variant: r = "stack" }) {
  return /* @__PURE__ */ n.createElement("section", { className: ["axe-form-section", r === "table" ? `axe-form-table ${Ce.table}` : "", Ce.section, a].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("h3", null, e), t);
}
function Q0({ children: e }) {
  return /* @__PURE__ */ n.createElement("span", { className: Ce.readonly }, e);
}
function J0({ checked: e, onChange: t, disabled: a, label: r, className: o = "" }) {
  return /* @__PURE__ */ n.createElement("label", { className: [Ce.toggle, o].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("input", { type: "checkbox", checked: e, disabled: a, onChange: (s) => t(s.target.checked) }), /* @__PURE__ */ n.createElement("span", null, r));
}
const Lp = "_mono_6omzf_2", jp = "_invalid_6omzf_3", Ip = "_qty_6omzf_6", Rp = "_qtyInput_6omzf_7", Op = "_unit_6omzf_8", Pp = "_note_6omzf_9", zp = "_qtyErr_6omzf_10", gt = {
  mono: Lp,
  invalid: jp,
  qty: Ip,
  qtyInput: Rp,
  unit: Op,
  note: Pp,
  qtyErr: zp
};
function Xp({
  value: e,
  onChange: t,
  disabled: a,
  maxLength: r,
  placeholder: o,
  mono: s,
  invalid: l,
  multiline: c,
  rows: i = 4,
  label: m,
  id: u,
  "aria-describedby": f,
  "aria-invalid": p,
  "aria-required": _,
  className: y = ""
}) {
  const d = [s ? gt.mono : "", l ? gt.invalid : "", y].filter(Boolean).join(" ") || void 0, b = {
    id: u,
    className: d,
    value: e != null ? e : "",
    maxLength: r,
    placeholder: o,
    disabled: a,
    "aria-label": m,
    "aria-describedby": f,
    "aria-invalid": p != null ? p : l || void 0,
    "aria-required": _,
    onChange: (N) => t(N.target.value === "" ? null : N.target.value)
  };
  return c ? /* @__PURE__ */ n.createElement("textarea", { ...b, rows: i }) : /* @__PURE__ */ n.createElement("input", { type: "text", ...b });
}
Xp.axeFormControl = !0;
function Fp(e) {
  const {
    value: t,
    options: a,
    allLabel: r,
    disabled: o,
    label: s,
    id: l,
    "aria-describedby": c,
    "aria-invalid": i,
    "aria-required": m,
    className: u,
    title: f,
    style: p,
    onClick: _
  } = e, y = (b) => {
    e.codeType === "string" ? e.onChange(b === "" ? null : b) : e.onChange(b === "" ? null : Number(b));
  }, d = Array.isArray(a) ? a : Object.entries(a);
  return /* @__PURE__ */ n.createElement(
    "select",
    {
      id: l,
      className: u,
      title: f,
      style: p,
      onClick: _,
      value: t == null ? "" : String(t),
      disabled: o,
      "aria-label": s,
      "aria-describedby": c,
      "aria-invalid": i,
      "aria-required": m,
      onChange: (b) => y(b.target.value)
    },
    r != null && /* @__PURE__ */ n.createElement("option", { value: "" }, r),
    d.map(([b, N, $]) => /* @__PURE__ */ n.createElement("option", { key: b, value: String(b), disabled: $ || void 0 }, N))
  );
}
Fp.axeFormControl = !0;
function Hp(e) {
  return e.replace(/[０-９]/g, (t) => String.fromCharCode(t.charCodeAt(0) - 65248)).replace(/[．。]/g, ".").replace(/[－−ー]/g, "-").replace(/[，、]/g, ",");
}
const Wp = /^-?(\d+\.?\d*|\.\d+)$/;
function tn(e) {
  const t = Hp(e).trim().replace(/,/g, "");
  if (t === "") return { kind: "empty" };
  if (t === "-" || t === "." || t === "-.") return { kind: "partial" };
  if (!Wp.test(t)) return { kind: "bad" };
  const a = Number(t);
  return Number.isFinite(a) ? { kind: "num", value: a === 0 ? 0 : a } : { kind: "bad" };
}
function Mn(e) {
  if (!Number.isFinite(e)) return 0;
  const t = Math.abs(e).toString(), a = t.indexOf("e-");
  if (a >= 0) {
    const o = t.slice(0, a), s = o.indexOf(".");
    return (s >= 0 ? o.length - s - 1 : 0) + Number(t.slice(a + 2));
  }
  const r = t.indexOf(".");
  return r >= 0 ? t.length - r - 1 : 0;
}
function Wr(e, t) {
  if (!Number.isFinite(e)) return e;
  const a = Math.max(0, Math.floor(t));
  if (Mn(e) <= a) return e;
  const r = e < 0 ? -1 : 1, o = Math.abs(e).toFixed(Math.min(20, Mn(e))), s = Math.round(+`${o}e${a}`), l = r * +`${s}e-${a}`;
  return l === 0 ? 0 : l;
}
function Ft(e) {
  return e == null || !Number.isFinite(e) ? "" : String(Number(e.toPrecision(12)));
}
function Kp(e, t, a) {
  return t != null && e < t || a != null && e > a;
}
function Up(e, t, a, r, o, s) {
  let l = e == null ? o != null ? o : 0 : Wr(e + a * t, Math.max(r, Mn(t)));
  return o != null && l < o && (l = o), s != null && l > s && (l = s), l;
}
const Gp = 2500;
function Yp({
  value: e,
  onChange: t,
  decimals: a = 1,
  min: r,
  max: o,
  step: s,
  unit: l,
  disabled: c,
  label: i,
  id: m,
  "aria-describedby": u,
  "aria-invalid": f,
  "aria-required": p,
  width: _,
  onEnter: y,
  onInvalidChange: d,
  placeholder: b,
  className: N = ""
}) {
  const [$, g] = A(() => Ft(e)), [x, h] = A(!1), [w, E] = A(null), [D, C] = A(!1), q = B(null), M = B($);
  M.current = $, U(() => {
    const v = tn(M.current), P = v.kind === "num" ? v.value : v.kind === "empty" ? null : void 0;
    P !== void 0 && P === (e != null ? e : null) || g(Ft(e));
  }, [e]), U(() => () => {
    q.current && clearTimeout(q.current);
  }, []);
  const I = tn($), T = I.kind === "bad" || I.kind === "partial";
  U(() => {
    T || C(!1);
  }, [T]);
  const F = B(d);
  F.current = d, U(() => {
    var v;
    (v = F.current) == null || v.call(F, T);
  }, [T]), U(() => () => {
    var v;
    (v = F.current) == null || v.call(F, !1);
  }, []);
  const Y = (v) => {
    q.current && clearTimeout(q.current), E(v), q.current = setTimeout(() => E(null), Gp);
  }, H = (v) => {
    g(v);
    const P = tn(v);
    P.kind === "empty" ? t(null) : P.kind === "num" && t(P.value);
  }, j = () => {
    const v = tn($);
    if (v.kind !== "num") return;
    if (Mn(v.value) > a) {
      const V = Wr(v.value, a);
      g(Ft(V)), t(V), Y(`반올림했습니다 → ${Ft(V)}`);
      return;
    }
    const P = Ft(v.value);
    P !== $ && g(P);
  }, ne = (v) => {
    if (!v.nativeEvent.isComposing) {
      if (v.key === "Enter") {
        if (T) {
          C(!0);
          return;
        }
        j(), y == null || y();
        return;
      }
      if (s && (v.key === "ArrowUp" || v.key === "ArrowDown")) {
        v.preventDefault();
        const P = tn($), V = P.kind === "num" ? P.value : P.kind === "empty" ? null : e, Q = Up(V, s, v.key === "ArrowUp" ? 1 : -1, a, r, o);
        g(Ft(Q)), t(Q);
      }
    }
  }, te = I.kind === "bad" || I.kind === "partial" && (!x || D) || I.kind === "num" && Kp(I.value, r, o);
  return /* @__PURE__ */ n.createElement("span", { className: [gt.qty, N].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement(
    "input",
    {
      type: "text",
      inputMode: "decimal",
      id: m,
      className: [gt.qtyInput, te ? gt.invalid : ""].filter(Boolean).join(" "),
      style: _ != null ? { width: _, maxWidth: "none" } : void 0,
      value: $,
      placeholder: b,
      disabled: c,
      "aria-label": i,
      "aria-describedby": u,
      "aria-invalid": f != null ? f : te || void 0,
      "aria-required": p,
      onChange: (v) => H(v.target.value),
      onFocus: () => h(!0),
      onBlur: () => {
        h(!1), j();
      },
      onKeyDown: ne
    }
  ), l && /* @__PURE__ */ n.createElement("span", { className: gt.unit }, l), (I.kind === "bad" || I.kind === "partial" && (!x || D)) && /* @__PURE__ */ n.createElement("span", { className: gt.qtyErr, role: "alert" }, "숫자로 입력하세요"), /* @__PURE__ */ n.createElement("span", { className: gt.note, role: "status", "aria-live": "polite" }, w));
}
Yp.axeFormControl = !0;
function Vp(e, t) {
  if (e === t || e == null && t == null) return !0;
  if (e == null || t == null) return !1;
  if (typeof e == "object" && typeof t == "object")
    try {
      return JSON.stringify(e) === JSON.stringify(t);
    } catch {
      return !1;
    }
  return typeof e == "number" && typeof t == "number" && Number.isNaN(e) && Number.isNaN(t);
}
function Qp(e, t) {
  var o;
  if (e === t) return [];
  if (e === null || t === null) return e === null && t === null ? [] : Object.keys((o = e != null ? e : t) != null ? o : {});
  const a = /* @__PURE__ */ new Set([...Object.keys(e), ...Object.keys(t)]), r = [];
  return a.forEach((s) => {
    Vp(e[s], t[s]) || r.push(s);
  }), r;
}
function Jp(e, t) {
  return e === null || t === null ? e === t : Qp(e, t).length === 0;
}
function Z0() {
  const [e, t] = A(null), [a, r] = A(!1), [o, s] = A(null), l = ke(() => a || !Jp(o, e), [a, o, e]), c = re((_) => {
    t((y) => y === null ? y : { ...y, ..._ });
  }, []), i = re((_, y) => {
    t((d) => d === null ? d : { ...d, [_]: y });
  }, []), m = B(null), u = re((_) => {
    m.current = _, t(_), s(_), r(!1);
  }, []), f = re((_) => {
    m.current = _, t(_), s(_), r(!0);
  }, []), p = re(() => t(m.current), []);
  return ke(
    () => ({ draft: e, isNew: a, dirty: l, set: i, patch: c, load: u, start: f, reset: p, snapshot: o }),
    [e, a, l, i, c, u, f, p, o]
  );
}
function ek() {
  const e = B(!1), [t, a] = A(!1), r = re(async (o) => {
    if (!e.current) {
      e.current = !0, a(!0);
      try {
        await o();
      } finally {
        e.current = !1, a(!1);
      }
    }
  }, []);
  return [t, r];
}
const Zp = "_panel_1w7xx_2", e_ = "_band_1w7xx_7", t_ = "_chev_1w7xx_11", n_ = "_title_1w7xx_17", a_ = "_note_1w7xx_19", r_ = "_chip_1w7xx_21", o_ = "_other_1w7xx_32", s_ = "_reset_1w7xx_33", l_ = "_form_1w7xx_42", rt = {
  panel: Zp,
  band: e_,
  chev: t_,
  title: n_,
  note: a_,
  chip: r_,
  other: o_,
  reset: s_,
  form: l_
};
function tk({
  chips: e,
  onReset: t,
  open: a,
  onToggle: r,
  toggleLabel: o = "상세검색",
  title: s = "적용된 조건",
  note: l,
  children: c,
  hideWhenEmpty: i,
  ariaLabel: m = "상세검색",
  className: u = ""
}) {
  const f = B(null);
  if (i && !a && e.length === 0) return null;
  const p = (y, d = 0) => {
    var x, h, w;
    const b = (x = document.querySelector(`section[aria-label="${CSS.escape(m)}"]`)) != null ? x : f.current, N = b == null ? void 0 : b.querySelectorAll("button[data-chip-clear]"), $ = (w = N && ((h = N[y]) != null ? h : N[y - 1])) != null ? w : b == null ? void 0 : b.querySelector("button[aria-expanded]"), g = !document.activeElement || document.activeElement === document.body;
    $ && $ !== document.activeElement && (d === 0 || g) && $.focus(), d < 4 && setTimeout(() => p(y, d + 1), 250);
  }, _ = (y) => {
    e[y].onClear(), requestAnimationFrame(() => p(y));
  };
  return /* @__PURE__ */ n.createElement("section", { className: [rt.panel, u].filter(Boolean).join(" "), "aria-label": m }, /* @__PURE__ */ n.createElement("div", { className: rt.band, ref: f }, r && /* @__PURE__ */ n.createElement("button", { type: "button", className: rt.chev, "aria-expanded": !!a, onClick: r }, /* @__PURE__ */ n.createElement("span", { "aria-hidden": "true" }, a ? "⌃" : "⌄"), " ", o), s !== null && /* @__PURE__ */ n.createElement("span", { className: rt.title, "aria-live": "polite" }, s, " ", /* @__PURE__ */ n.createElement("b", null, e.length), "개"), e.map((y, d) => {
    var b;
    return /* @__PURE__ */ n.createElement("span", { key: y.key, className: [rt.chip, y.tone === "other" ? rt.other : ""].filter(Boolean).join(" ") }, y.text, /* @__PURE__ */ n.createElement(
      "button",
      {
        type: "button",
        "data-chip-clear": !0,
        "aria-label": `${(b = y.label) != null ? b : typeof y.text == "string" ? y.text : "조건"} 해제`,
        onClick: () => _(d)
      },
      "✕"
    ));
  }), t && e.length > 0 && /* @__PURE__ */ n.createElement("button", { type: "button", className: rt.reset, onClick: () => {
    t(), requestAnimationFrame(() => p(0));
  } }, "초기화"), l && /* @__PURE__ */ n.createElement("span", { className: rt.note }, l)), a && c && /* @__PURE__ */ n.createElement("div", { className: rt.form }, c));
}
const c_ = "_zone_1y6sp_2", i_ = "_drag_1y6sp_8", u_ = "_busy_1y6sp_9", m_ = "_attached_1y6sp_10", d_ = "_left_1y6sp_12", f_ = "_icon_1y6sp_13", p_ = "_title_1y6sp_18", __ = "_desc_1y6sp_19", y_ = "_right_1y6sp_20", b_ = "_count_1y6sp_21", E_ = "_pick_1y6sp_22", He = {
  zone: c_,
  drag: i_,
  busy: u_,
  attached: m_,
  left: d_,
  icon: f_,
  title: p_,
  desc: __,
  right: y_,
  count: b_,
  pick: E_
};
function h_({
  onFiles: e,
  title: t = "파일 업로드",
  desc: a,
  countText: r,
  accept: o,
  multiple: s = !0,
  disabled: l,
  attached: c,
  pickLabel: i = "파일 선택",
  className: m = ""
}) {
  const u = B(null), [f, p] = A(!1), _ = (y) => {
    !y || y.length === 0 || l || e(Array.from(y));
  };
  return /* @__PURE__ */ n.createElement(
    "div",
    {
      className: [He.zone, f ? He.drag : "", l ? He.busy : "", c ? He.attached : "", m].filter(Boolean).join(" "),
      onClick: () => {
        var y;
        l || (y = u.current) == null || y.click();
      },
      onDragOver: (y) => {
        y.preventDefault(), l || p(!0);
      },
      onDragLeave: () => p(!1),
      onDrop: (y) => {
        y.preventDefault(), p(!1), _(y.dataTransfer.files);
      }
    },
    /* @__PURE__ */ n.createElement("div", { className: He.left }, /* @__PURE__ */ n.createElement("div", { className: He.icon, "aria-hidden": "true" }, /* @__PURE__ */ n.createElement("svg", { width: "22", height: "22", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round" }, /* @__PURE__ */ n.createElement("polyline", { points: "16 16 12 12 8 16" }), /* @__PURE__ */ n.createElement("line", { x1: "12", y1: "12", x2: "12", y2: "21" }), /* @__PURE__ */ n.createElement("path", { d: "M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3" }))), /* @__PURE__ */ n.createElement("div", null, /* @__PURE__ */ n.createElement("div", { className: He.title }, t), a && /* @__PURE__ */ n.createElement("div", { className: He.desc }, a))),
    /* @__PURE__ */ n.createElement("div", { className: He.right }, r && /* @__PURE__ */ n.createElement("span", { className: He.count, "aria-live": "polite" }, r), /* @__PURE__ */ n.createElement(
      "button",
      {
        type: "button",
        className: He.pick,
        disabled: l,
        onClick: (y) => {
          var d;
          y.stopPropagation(), (d = u.current) == null || d.click();
        }
      },
      i
    ), /* @__PURE__ */ n.createElement(
      "input",
      {
        ref: u,
        type: "file",
        accept: o,
        multiple: s,
        hidden: !0,
        onChange: (y) => {
          _(y.target.files), y.target.value = "";
        }
      }
    ))
  );
}
function g_(e, t) {
  var s, l;
  const a = (s = e.headers.get("Content-Disposition")) != null ? s : "", r = /filename\*=UTF-8''([^;]+)/i.exec(a);
  if (r)
    try {
      return decodeURIComponent(r[1]);
    } catch {
    }
  const o = /filename="?([^";]+)"?/i.exec(a);
  return (l = o == null ? void 0 : o[1]) != null ? l : t;
}
function Kr(e, t) {
  const a = URL.createObjectURL(e), r = document.createElement("a");
  r.href = a, r.download = t, document.body.appendChild(r), r.click(), r.remove(), setTimeout(() => URL.revokeObjectURL(a), 1e3);
}
async function nk(e, t, a) {
  Kr(await e.blob(), a != null ? a : g_(e, t));
}
const v_ = /^([△▲\-−]?)\s*[\u00a5\uffe5]?\s*(\d{1,3}(?:,\d{3})+|\d+)(\.\d+)?$/, k_ = /^\(\s*[\u00a5\uffe5]?\s*(\d{1,3}(?:,\d{3})+|\d+)(\.\d+)?\s*\)$/;
function Ur(e, t = {}) {
  var o, s;
  const a = e.trim();
  if (t.parenNegative) {
    const l = k_.exec(a);
    if (l) return `-${l[1].replace(/,/g, "")}${(o = l[2]) != null ? o : ""}`;
  }
  const r = v_.exec(a);
  return r ? (r[1] ? "-" : "") + r[2].replace(/,/g, "") + ((s = r[3]) != null ? s : "") : null;
}
function Kt(e) {
  return e === "-" || e === "+" ? e : /^[=+\-@\t\r]/.test(e) ? `'${e}` : e;
}
function w_(e, t = {}) {
  const a = [];
  t.meta && t.meta.length && (t.meta.forEach((l) => a.push(l.map((c) => kn(Kt(String(c != null ? c : "")))).join(","))), a.push(""));
  const r = a.length;
  let o = null;
  const s = (l) => {
    var i;
    const c = N_(l, e);
    !c || c === o || (o = c, a.length > r && a.push(""), a.push(kn(Kt((i = c.getAttribute("data-csv-title")) != null ? i : ""))));
  };
  return e.querySelectorAll("table, [data-csv-kv]").forEach((l) => {
    var _;
    if (l.tagName !== "TABLE") {
      if ((_ = l.parentElement) != null && _.closest("table") && e.contains(l.parentElement.closest("table"))) return;
      const y = $_(l, t);
      if (!y) return;
      s(l), a.push(y.map(kn).join(","));
      return;
    }
    const c = l;
    s(c);
    const i = c.querySelector("[data-tree-depth]"), m = i ? i.closest("td, th") : null, u = m ? m.cellIndex : -1, f = u >= 0 && !!c.querySelector("[data-csv-path]"), p = [];
    Array.from(c.rows).forEach((y) => {
      if (y.hasAttribute("data-state") || y.getAttribute("aria-hidden") === "true") return;
      const d = [];
      let b = 0;
      const N = () => {
        for (; p[b] && p[b].n > 0; )
          p[b].n -= 1, p[b].skip || d.push(""), b += 1;
      };
      Array.from(y.cells).forEach(($) => {
        var E, D;
        N();
        const g = D_($), x = g ? "" : A_($, t), h = Math.max(1, $.colSpan || 1), w = Math.max(1, $.rowSpan || 1);
        for (let C = 0; C < h; C += 1)
          g || d.push(C === 0 ? x : ""), p[b] = { n: w - 1, skip: g }, b += 1;
        if (u >= 0 && $.cellIndex === u) {
          const C = $.querySelector("[data-tree-depth]");
          C ? (d.push(String(Number(C.getAttribute("data-tree-depth")) + 1)), f && d.push(Kt((E = C.getAttribute("data-csv-path")) != null ? E : ""))) : ((D = y.parentElement) == null ? void 0 : D.tagName) === "THEAD" ? (d.push("단계"), f && d.push("상위 경로")) : (d.push(""), f && d.push(""));
        }
      }), N(), d.some(($) => $ !== "") && a.push(d.map(kn).join(","));
    });
  }), a.join(`\r
`);
}
function N_(e, t) {
  let a = e.parentElement;
  for (; a; ) {
    if (a.hasAttribute("data-csv-title") && a.getAttribute("data-csv-title")) return a;
    if (a === t) return null;
    a = a.parentElement;
  }
  return null;
}
function $_(e, t) {
  var m, u;
  const a = e.querySelector("[data-csv-k]"), r = e.querySelector("[data-csv-v]"), o = e.querySelector("[data-csv-unit]"), s = o ? vn(o) : "";
  let c = ((m = e.getAttribute("data-csv-kv")) != null ? m : "") || (a ? vn(a) : "");
  if (!c) return null;
  s && (c = `${c} (${s})`);
  let i;
  if (r) {
    const f = r.cloneNode(!0);
    f.querySelectorAll("[data-csv-unit], [data-csv-skip]").forEach((p) => p.remove()), i = vn(f);
  } else {
    const f = e.cloneNode(!0);
    f.querySelectorAll("[data-csv-k], [data-csv-unit], [data-csv-skip]").forEach((p) => p.remove()), i = vn(f);
  }
  return (i === "—" || i === "-" || i === "–") && (i = ""), [Kt(c), (u = Ur(i, t)) != null ? u : Kt(i)];
}
function vn(e) {
  var t, a;
  return ((a = (t = e.innerText) != null ? t : e.textContent) != null ? a : "").replace(/\s+/g, " ").trim();
}
function x_(e, t) {
  const a = t.toLowerCase().endsWith(".csv") ? t : `${t}.csv`;
  Kr(new Blob(["\uFEFF", e], { type: "text/csv;charset=utf-8" }), a);
}
function D_(e) {
  var t;
  return ((t = e.textContent) != null ? t : "").trim() !== "" ? !1 : !!e.querySelector("input[type=checkbox], input[type=radio]");
}
function A_(e, t) {
  var o, s, l;
  let a = e;
  e.querySelector("[data-csv-skip], [data-csv-sep]") && (a = e.cloneNode(!0), a.querySelectorAll("[data-csv-skip]").forEach((c) => c.remove()), a.querySelectorAll("[data-csv-sep]").forEach((c) => c.after(" ")));
  let r = ((s = (o = a.innerText) != null ? o : a.textContent) != null ? s : "").replace(/\s+/g, " ").trim();
  if (!r && a.textContent && (r = a.textContent.replace(/\s+/g, " ").trim()), !r) {
    const c = e.querySelector("input:not([type=checkbox]):not([type=radio]), select, textarea");
    c && (r = c.value.trim());
  }
  return r === "—" || r === "-" || r === "–" ? "" : (l = Ur(r, t)) != null ? l : Kt(r);
}
function kn(e) {
  return /[",\r\n]/.test(e) ? `"${e.replace(/"/g, '""')}"` : e;
}
const C_ = () => new Promise((e) => requestAnimationFrame(() => requestAnimationFrame(() => e())));
function ak({ target: e, fileName: t, label: a = "CSV 내려받기", disabled: r, parenNegative: o, prepare: s, meta: l }) {
  return /* @__PURE__ */ n.createElement(
    na,
    {
      label: a,
      disabled: r,
      style: { width: "auto", padding: "0 9px", gap: 4, border: "1px solid var(--axe-border, #d5dde9)", fontSize: 11, fontWeight: 700 },
      onClick: async () => {
        let c;
        s && (c = await s(), await C_());
        try {
          const i = e.current;
          if (!i) return;
          x_(w_(i, { parenNegative: o, meta: l == null ? void 0 : l() }), typeof t == "function" ? t() : t);
        } finally {
          typeof c == "function" && c();
        }
      }
    },
    /* @__PURE__ */ n.createElement(mn, { name: "download", size: 14 }),
    "CSV"
  );
}
const S_ = "_root_kpw7f_1", M_ = "_guide_kpw7f_2", q_ = "_tpl_kpw7f_3", Gn = {
  root: S_,
  guide: M_,
  tpl: q_
};
function rk({
  guide: e,
  onTemplate: t,
  templateLabel: a = "빈 양식 받기",
  file: r,
  onFile: o,
  maxBytes: s,
  onTooBig: l,
  fileInfo: c,
  accept: i = ".csv,text/csv",
  label: m = "CSV 파일",
  pickLabel: u = "파일 선택",
  busyReason: f,
  className: p = ""
}) {
  const _ = (d) => {
    var N;
    const b = (N = d[0]) != null ? N : null;
    if (b && s !== void 0 && b.size > s) {
      l == null || l(b);
      return;
    }
    o(b);
  }, y = r ? `${r.name}${c != null ? c : r.size !== void 0 ? ` · ${(r.size / 1024).toFixed(1)}KB` : ""}` : void 0;
  return /* @__PURE__ */ n.createElement("div", { className: [Gn.root, p].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement(Vf, { tone: "info" }, /* @__PURE__ */ n.createElement("div", { className: Gn.guide }, e), t && /* @__PURE__ */ n.createElement("div", { className: Gn.tpl }, /* @__PURE__ */ n.createElement(et, { size: "sm", onClick: t }, a))), /* @__PURE__ */ n.createElement(
    h_,
    {
      title: m,
      desc: r ? void 0 : "선택된 파일 없음",
      countText: y,
      accept: i,
      multiple: !1,
      disabled: !!f,
      pickLabel: u,
      onFiles: _
    }
  ));
}
const T_ = { info: "info", ok: "ok", warn: "warn", danger: "off", muted: "muted", off: "off" };
function ok({ map: e, value: t, empty: a = "-" }) {
  if (t == null) return /* @__PURE__ */ n.createElement(n.Fragment, null, a);
  const r = e[t];
  return r ? /* @__PURE__ */ n.createElement(Wa, { tone: T_[r.tone] }, r.label) : /* @__PURE__ */ n.createElement(Wa, null, String(t));
}
const Va = "axerp-form-modal";
function sk({
  title: e,
  onClose: t,
  onSubmit: a,
  busy: r = !1,
  error: o,
  submitLabel: s,
  submitBlocked: l,
  wide: c,
  labels: i,
  formClassName: m,
  children: u
}) {
  var p, _, y;
  const f = (d) => {
    d.preventDefault(), !r && !l && a();
  };
  return /* @__PURE__ */ n.createElement(
    Pn,
    {
      title: e,
      onClose: t,
      wide: c,
      closeOnBackdrop: !1,
      error: o,
      footer: /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement(et, { onClick: t, disabled: r }, (p = i == null ? void 0 : i.cancel) != null ? p : "취소"), /* @__PURE__ */ n.createElement(et, { type: "submit", form: Va, variant: "primary", blockedReason: r ? (_ = i == null ? void 0 : i.saving) != null ? _ : "저장 중입니다" : l }, (y = s != null ? s : i == null ? void 0 : i.save) != null ? y : "저장"))
    },
    /* @__PURE__ */ n.createElement("form", { id: Va, className: m, onSubmit: f, noValidate: !0 }, u)
  );
}
const B_ = { left: "axe-l", center: "axe-c", right: "axe-r" };
function Qa(e) {
  const t = e.currentTarget;
  t.scrollWidth > t.clientWidth + 1 && t.textContent ? t.title = t.textContent : t.removeAttribute("title");
}
const Ja = (e) => {
  var t;
  return B_[(t = e.align) != null ? t : e.num ? "right" : "left"];
};
function lk({
  columns: e,
  rows: t,
  rowKey: a,
  loading: r = !1,
  error: o = null,
  emptyText: s = "표시할 행이 없습니다",
  selectedKey: l,
  onRowClick: c,
  rowClassName: i,
  title: m,
  grow: u = !1,
  growClassName: f,
  pagination: p,
  stickyCols: _
}) {
  const y = t != null ? t : [];
  return /* @__PURE__ */ n.createElement(Lc, { grow: u, className: u ? f : void 0, cols: e.map((d) => d.width), busy: r, title: m, pagination: p, stickyCols: _ }, /* @__PURE__ */ n.createElement("thead", null, /* @__PURE__ */ n.createElement("tr", null, e.map((d) => /* @__PURE__ */ n.createElement("th", { key: d.key, className: Ja(d) === "axe-r" ? "axe-r" : "axe-c", onMouseEnter: Qa }, d.header)))), /* @__PURE__ */ n.createElement("tbody", null, /* @__PURE__ */ n.createElement(
    Sr,
    {
      colSpan: e.length,
      loading: r,
      error: o,
      count: t ? y.length : null,
      empty: s,
      idle: null
    }
  ), y.map((d, b) => {
    var g;
    const N = a(d), $ = [c ? "axe-clickable" : "", l === N ? "axe-sel" : "", (g = i == null ? void 0 : i(d)) != null ? g : ""].filter(Boolean).join(" ");
    return /* @__PURE__ */ n.createElement(
      "tr",
      {
        key: N,
        className: $ || void 0,
        onClick: c ? () => c(d) : void 0,
        ...c ? Vc(() => c(d), l === void 0 ? void 0 : l === N) : {}
      },
      e.map((x) => /* @__PURE__ */ n.createElement("td", { key: x.key, className: Ja(x), onMouseEnter: Qa }, x.render(d, b)))
    );
  })));
}
function ck({ title: e, info: t, badge: a, notice: r, actions: o, minWidth: s, bodyClassName: l, children: c }) {
  return /* @__PURE__ */ n.createElement(Eo, { style: { height: "100%" }, minWidth: s }, /* @__PURE__ */ n.createElement(Po, { title: e, info: t, badge: a, notice: r }, o), /* @__PURE__ */ n.createElement("div", { className: l }, c));
}
const L_ = "_menu_1ow3k_1", j_ = "_heading_1ow3k_11", I_ = "_section_1ow3k_18", R_ = "_item_1ow3k_23", wn = {
  menu: L_,
  heading: j_,
  section: I_,
  item: R_
}, Nn = 8;
function ik({ x: e, y: t, entries: a, onClose: r, ariaLabel: o, heading: s }) {
  const l = B(null), c = B(r);
  c.current = r;
  const [i, m] = A({ left: e, top: t });
  $e(() => {
    const p = l.current;
    if (!p) return;
    const _ = Math.max(Nn, Math.min(e, window.innerWidth - p.offsetWidth - Nn)), y = Math.max(Nn, Math.min(t, window.innerHeight - p.offsetHeight - Nn));
    m({ left: _, top: y });
  }, [e, t]);
  const u = () => {
    var p, _;
    return Array.from((_ = (p = l.current) == null ? void 0 : p.querySelectorAll("[role=menuitem]:not(:disabled)")) != null ? _ : []);
  };
  U(() => {
    var p;
    (p = u()[0]) == null || p.focus();
  }, []), U(() => {
    const p = () => c.current(), _ = (d) => {
      l.current && !l.current.contains(d.target) && p();
    }, y = (d) => {
      d.key !== "Escape" || d.isComposing || (d.preventDefault(), d.stopPropagation(), p());
    };
    return document.addEventListener("mousedown", _), document.addEventListener("keydown", y, !0), window.addEventListener("resize", p), window.addEventListener("scroll", p, !0), () => {
      document.removeEventListener("mousedown", _), document.removeEventListener("keydown", y, !0), window.removeEventListener("resize", p), window.removeEventListener("scroll", p, !0);
    };
  }, []);
  const f = (p) => {
    const _ = u();
    if (_.length === 0) return;
    const y = _.indexOf(document.activeElement);
    let d = -1;
    if (p.key === "ArrowDown") d = (y + 1) % _.length;
    else if (p.key === "ArrowUp") d = (y - 1 + _.length) % _.length;
    else if (p.key === "Home") d = 0;
    else if (p.key === "End") d = _.length - 1;
    else if (p.key === "Tab") {
      c.current();
      return;
    }
    d >= 0 && (p.preventDefault(), _[d].focus());
  };
  return pa(
    /* @__PURE__ */ n.createElement(
      "div",
      {
        ref: l,
        className: wn.menu,
        role: "menu",
        "aria-label": o,
        style: { left: i.left, top: i.top },
        onKeyDown: f,
        onContextMenu: (p) => p.preventDefault()
      },
      s && /* @__PURE__ */ n.createElement("div", { className: wn.heading }, s),
      a.map((p) => p.kind === "section" ? /* @__PURE__ */ n.createElement("div", { key: p.key, className: wn.section }, p.label) : /* @__PURE__ */ n.createElement(
        "button",
        {
          key: p.key,
          type: "button",
          role: "menuitem",
          className: wn.item,
          disabled: p.disabled,
          onClick: () => {
            c.current(), p.onClick();
          }
        },
        p.label
      ))
    ),
    document.body
  );
}
const O_ = "_sw_xhqlf_1", P_ = "_on_xhqlf_10", Za = {
  sw: O_,
  on: P_
};
function uk({ checked: e, onChange: t, label: a, onText: r = "ON", offText: o = "OFF", disabled: s, className: l = "" }) {
  return /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      role: "switch",
      "aria-checked": e,
      "aria-label": a,
      disabled: s,
      className: [Za.sw, e ? Za.on : "", l].filter(Boolean).join(" "),
      onClick: () => t(!e)
    },
    /* @__PURE__ */ n.createElement("span", null, e ? r : o),
    /* @__PURE__ */ n.createElement("i", null)
  );
}
function z_({ accept: e, multiple: t = !0, onFiles: a }) {
  const r = B(null), o = B(a);
  return o.current = a, { open: re(() => {
    var c;
    (c = r.current) == null || c.click();
  }, []), input: /* @__PURE__ */ n.createElement(
    "input",
    {
      ref: r,
      type: "file",
      accept: e,
      multiple: t,
      hidden: !0,
      onChange: (c) => {
        var m;
        const i = Array.from((m = c.target.files) != null ? m : []);
        c.target.value = "", i.length > 0 && o.current(i);
      }
    }
  ) };
}
function mk({ accept: e, multiple: t = !0, onFiles: a, disabled: r, title: o, variant: s, size: l, children: c }) {
  const { open: i, input: m } = z_({ accept: e, multiple: t, onFiles: a });
  return /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement(et, { variant: s, size: l, onClick: i, disabled: r, title: o }, c), m);
}
const X_ = "_over_bhzlv_1", F_ = "_thumbs_bhzlv_2", H_ = "_thumb_bhzlv_2", la = {
  over: X_,
  thumbs: F_,
  thumb: H_
};
function dk({ onFiles: e, accept: t, disabled: a, className: r = "", children: o }) {
  const [s, l] = A(!1), c = (m) => !t || t.some((u) => m.startsWith(u)), i = (m) => Array.from(m).some((u) => u.kind === "file" && c(u.type));
  return /* @__PURE__ */ n.createElement(
    "div",
    {
      className: [r, s ? la.over : ""].filter(Boolean).join(" "),
      onDragOver: (m) => {
        var u;
        a || (u = m.dataTransfer) != null && u.items && !i(m.dataTransfer.items) || (m.preventDefault(), l(!0));
      },
      onDragLeave: () => l(!1),
      onDrop: (m) => {
        if (m.preventDefault(), l(!1), a) return;
        const u = Array.from(m.dataTransfer.files).filter((f) => c(f.type));
        u.length > 0 && e(u);
      }
    },
    o
  );
}
function fk({ images: e, onRemove: t, removeLabel: a, disabled: r }) {
  return /* @__PURE__ */ n.createElement("div", { className: la.thumbs }, e.map((o) => {
    var s;
    return /* @__PURE__ */ n.createElement("figure", { key: o.uid, className: la.thumb, title: (s = o.title) != null ? s : o.name }, /* @__PURE__ */ n.createElement("img", { src: o.previewUrl, alt: o.name }), /* @__PURE__ */ n.createElement("button", { type: "button", onClick: () => t(o.uid), "aria-label": a(o.name), disabled: r }, "×"), o.caption !== void 0 && /* @__PURE__ */ n.createElement("figcaption", null, o.caption));
  }));
}
const W_ = "_box_lrwei_1", K_ = "_btn_lrwei_2", U_ = "_pop_lrwei_9", Yn = {
  box: W_,
  btn: K_,
  pop: U_
};
function pk({ summary: e, items: t, onToggle: a, label: r, disabled: o, className: s = "" }) {
  const [l, c] = A(!1), i = B(null), m = B(null);
  return U(() => {
    if (!l) return;
    const u = (p) => {
      i.current && !i.current.contains(p.target) && c(!1);
    }, f = (p) => {
      var _;
      p.key !== "Escape" || p.isComposing || (p.stopPropagation(), c(!1), (_ = m.current) == null || _.focus());
    };
    return document.addEventListener("mousedown", u), document.addEventListener("keydown", f, !0), () => {
      document.removeEventListener("mousedown", u), document.removeEventListener("keydown", f, !0);
    };
  }, [l]), /* @__PURE__ */ n.createElement("div", { className: [Yn.box, s].filter(Boolean).join(" "), ref: i }, /* @__PURE__ */ n.createElement(
    "button",
    {
      ref: m,
      type: "button",
      className: Yn.btn,
      "aria-haspopup": "listbox",
      "aria-expanded": l,
      "aria-label": r,
      disabled: o,
      onClick: () => c((u) => !u)
    },
    e,
    " ▾"
  ), l && /* @__PURE__ */ n.createElement("div", { className: Yn.pop, role: "listbox", "aria-multiselectable": "true", "aria-label": r }, t.map((u) => /* @__PURE__ */ n.createElement("label", { key: u.key }, /* @__PURE__ */ n.createElement("input", { type: "checkbox", checked: u.checked, onChange: () => a(u.key) }), u.label))));
}
const G_ = "_card_krkjh_1", Y_ = "_sub_krkjh_2", V_ = "_state_krkjh_3", Q_ = "_list_krkjh_7", J_ = "_row_krkjh_8", Z_ = "_warn_krkjh_21", ey = "_danger_krkjh_22", At = {
  card: G_,
  sub: Y_,
  state: V_,
  list: Q_,
  row: J_,
  warn: Z_,
  danger: ey
};
function _k({
  title: e,
  sub: t,
  trailing: a,
  state: r = "ready",
  error: o,
  onRetry: s,
  loadingText: l = "불러오는 중…",
  rows: c,
  className: i = ""
}) {
  return /* @__PURE__ */ n.createElement(
    Mr,
    {
      flush: !0,
      className: [At.card, i].filter(Boolean).join(" "),
      title: /* @__PURE__ */ n.createElement(n.Fragment, null, e, t ? /* @__PURE__ */ n.createElement("small", { className: At.sub }, t) : null),
      trailing: a
    },
    r === "loading" && /* @__PURE__ */ n.createElement("div", { className: At.state }, l),
    r === "error" && /* @__PURE__ */ n.createElement("div", { className: At.state }, /* @__PURE__ */ n.createElement(Hr, null, o != null ? o : "불러오지 못했습니다"), s && /* @__PURE__ */ n.createElement(_a, { onClick: s }, "다시 시도")),
    r === "ready" && /* @__PURE__ */ n.createElement("div", { className: At.list }, c.map((m, u) => {
      var _, y;
      const f = [At.row, m.tone ? At[m.tone] : ""].filter(Boolean).join(" "), p = /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("span", null, m.label), /* @__PURE__ */ n.createElement("strong", null, m.value, m.unit ? /* @__PURE__ */ n.createElement("small", null, m.unit) : null));
      return m.onClick ? /* @__PURE__ */ n.createElement("button", { type: "button", key: (_ = m.key) != null ? _ : u, className: f, onClick: m.onClick }, p) : /* @__PURE__ */ n.createElement("div", { key: (y = m.key) != null ? y : u, className: f }, p);
    }))
  );
}
function ty(e, t, a, r, o) {
  const s = Math.max(0, Math.floor(e));
  if (s === 0) return 1;
  const l = Math.max(1, Math.min(s, o != null && o > 0 ? Math.floor(o) : s)), c = Math.max(1, Math.min(l, Math.floor((t + r) / (a + r)))), i = Math.ceil(s / c);
  return Math.ceil(s / i);
}
const ny = "_group_44kzq_1", ay = "_tile_44kzq_2", ry = "_click_44kzq_9", oy = "_pressed_44kzq_13", sy = "_ok_44kzq_14", ly = "_warn_44kzq_15", cy = "_danger_44kzq_16", iy = "_info_44kzq_17", uy = "_accent_44kzq_18", my = "_muted_44kzq_19", dy = "_label_44kzq_20", fy = "_value_44kzq_22", py = "_desc_44kzq_27", ht = {
  group: ny,
  tile: ay,
  click: ry,
  pressed: oy,
  ok: sy,
  warn: ly,
  danger: cy,
  info: iy,
  accent: uy,
  muted: my,
  label: dy,
  value: fy,
  desc: py
};
function yk({
  label: e,
  value: t,
  unit: a,
  desc: r,
  tone: o = "info",
  onClick: s,
  pressed: l,
  title: c,
  className: i = ""
}) {
  const m = [ht.tile, ht[o], s ? ht.click : "", s && l ? ht.pressed : "", i].filter(Boolean).join(" "), u = /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("span", { className: ht.label, "data-csv-k": "" }, /* @__PURE__ */ n.createElement("i", { "aria-hidden": "true" }), e), /* @__PURE__ */ n.createElement("span", { className: ht.value, "data-csv-v": "" }, t, a ? /* @__PURE__ */ n.createElement("small", { "data-csv-unit": "" }, a) : null), r ? /* @__PURE__ */ n.createElement("span", { className: ht.desc, title: typeof r == "string" ? r : void 0 }, r) : null);
  return s ? /* @__PURE__ */ n.createElement("button", { type: "button", className: m, onClick: s, "aria-pressed": l, title: c, "data-csv-kv": "" }, u) : /* @__PURE__ */ n.createElement("div", { className: m, title: c, "data-csv-kv": "" }, u);
}
const _y = 150, yy = 12, by = 8;
function bk({ children: e, columns: t, className: a = "" }) {
  const r = B(null), o = ta.toArray(e).filter(un).length, s = t != null || o <= by, [l, c] = A(null);
  $e(() => {
    const u = r.current;
    if (!s || !u || (c(u.clientWidth), typeof ResizeObserver == "undefined")) return;
    const f = new ResizeObserver(() => c(u.clientWidth));
    return f.observe(u), () => f.disconnect();
  }, [s]);
  const i = s ? ty(o, l != null ? l : Number.MAX_SAFE_INTEGER, _y, yy, t) : 0, m = s ? { gridTemplateColumns: `repeat(${i}, minmax(0, 1fr))` } : void 0;
  return /* @__PURE__ */ n.createElement("div", { ref: r, className: [ht.group, a].filter(Boolean).join(" "), style: m }, e);
}
const Ey = "_card_nvp4o_1", hy = "_n_nvp4o_2", gy = "_list_nvp4o_7", vy = "_item_nvp4o_8", ky = "_row_nvp4o_9", wy = "_launch_nvp4o_14", Ny = "_tabBtn_nvp4o_17", $y = "_starBtn_nvp4o_17", xy = "_on_nvp4o_21", Dy = "_name_nvp4o_23", Ay = "_empty_nvp4o_24", Cy = "_star_nvp4o_17", Sy = "_clear_nvp4o_34", je = {
  card: Ey,
  n: hy,
  list: gy,
  item: vy,
  row: ky,
  launch: wy,
  tabBtn: Ny,
  starBtn: $y,
  on: xy,
  name: Dy,
  empty: Ay,
  star: Cy,
  clear: Sy
};
function My() {
  return /* @__PURE__ */ n.createElement("svg", { width: "12", height: "12", viewBox: "0 0 12 12", "aria-hidden": "true", fill: "none", stroke: "currentColor", strokeWidth: "1.4", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ n.createElement("path", { d: "M3 1.5h4l2.5 2.5v6a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5v-8A.5.5 0 0 1 3 1.5Z" }), /* @__PURE__ */ n.createElement("path", { d: "M7 1.5V4h2.5M4.2 6.2h3.6M4.2 8.2h3.6" }));
}
function qy() {
  return /* @__PURE__ */ n.createElement("svg", { width: "13", height: "13", viewBox: "0 0 12 12", "aria-hidden": "true", fill: "none", stroke: "currentColor", strokeWidth: "1.4", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ n.createElement("path", { d: "M5 2H2.5A.5.5 0 0 0 2 2.5v7a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5V7M7.5 2H10v2.5M10 2 5.5 6.5" }));
}
function Ek({
  mine: e,
  recent: t,
  onOpen: a,
  onClearRecent: r,
  onRemoveMine: o,
  onOpenNewTab: s,
  mineHint: l = "메뉴 목록에서 ☆ 를 누르면 여기에 담깁니다",
  className: c = ""
}) {
  const [i, m] = A("mine"), u = i === "mine" ? e : t;
  return /* @__PURE__ */ n.createElement(
    Mr,
    {
      flush: !0,
      className: [je.card, c].filter(Boolean).join(" "),
      title: /* @__PURE__ */ n.createElement(
        kr,
        {
          variant: "segmented",
          "aria-label": "빠른 메뉴",
          value: i,
          onChange: (f) => m(f),
          items: [
            { key: "mine", label: /* @__PURE__ */ n.createElement(n.Fragment, null, "마이메뉴", e.length > 0 && /* @__PURE__ */ n.createElement("em", { className: je.n }, e.length)) },
            { key: "recent", label: /* @__PURE__ */ n.createElement(n.Fragment, null, "최근 사용", t.length > 0 && /* @__PURE__ */ n.createElement("em", { className: je.n }, t.length)) }
          ]
        }
      ),
      trailing: i === "recent" && t.length > 0 && r ? /* @__PURE__ */ n.createElement(_a, { className: je.clear, onClick: r }, "목록 비우기") : void 0
    },
    u.length > 0 ? /* @__PURE__ */ n.createElement("ul", { className: je.list }, u.map((f) => /* @__PURE__ */ n.createElement("li", { key: f.path, className: je.item }, /* @__PURE__ */ n.createElement("button", { type: "button", className: je.row, onClick: () => a(f) }, /* @__PURE__ */ n.createElement("span", { "aria-hidden": "true", className: je.launch }, /* @__PURE__ */ n.createElement(My, null)), /* @__PURE__ */ n.createElement("span", { className: je.name }, f.label)), /* @__PURE__ */ n.createElement(
      "button",
      {
        type: "button",
        className: je.tabBtn,
        "aria-label": `${f.label} 새 탭으로 열기`,
        title: "새 탭으로 열기",
        onClick: () => s ? s(f) : window.open(f.path, "_blank", "noopener")
      },
      /* @__PURE__ */ n.createElement(qy, null)
    ), i === "mine" && o && /* @__PURE__ */ n.createElement(
      "button",
      {
        type: "button",
        className: `${je.starBtn} ${je.on}`,
        "aria-pressed": !0,
        "aria-label": `${f.label} 마이메뉴에서 삭제`,
        title: "마이메뉴에서 삭제",
        onClick: () => o(f)
      },
      "★"
    )))) : /* @__PURE__ */ n.createElement("div", { className: je.empty }, /* @__PURE__ */ n.createElement("span", { "aria-hidden": "true", className: je.star }, "★"), /* @__PURE__ */ n.createElement("strong", null, i === "mine" ? "아직 추가한 메뉴가 없습니다" : "최근 사용한 메뉴가 없습니다"), /* @__PURE__ */ n.createElement("p", null, i === "mine" ? l : "메뉴를 실행하면 최근 사용 목록에 표시됩니다"))
  );
}
function er(e) {
  var t;
  try {
    const a = JSON.parse((t = window.localStorage.getItem(e)) != null ? t : "[]");
    return Array.isArray(a) ? a.filter((r) => r && typeof r.path == "string" && typeof r.label == "string") : [];
  } catch {
    return [];
  }
}
function Vn(e, t) {
  try {
    window.localStorage.setItem(e, JSON.stringify(t));
  } catch {
  }
}
function hk({ mineKey: e, recentKey: t, recentMax: a = 6 }) {
  const [r, o] = A(() => er(e)), [s, l] = A(() => er(t)), c = re((f) => r.some((p) => p.path === f), [r]), i = re((f) => o((p) => {
    const _ = p.some((y) => y.path === f.path) ? p.filter((y) => y.path !== f.path) : [...p, f];
    return Vn(e, _), _;
  }), [e]), m = re((f) => l((p) => {
    const _ = [f, ...p.filter((y) => y.path !== f.path)].slice(0, a);
    return Vn(t, _), _;
  }), [t, a]), u = re(() => {
    l([]), Vn(t, []);
  }, [t]);
  return { mine: r, recent: s, isMine: c, toggleMine: i, remember: m, clearRecent: u };
}
const Ty = "_banner_7tqhk_2", By = "_heading_7tqhk_7", Ly = "_sparkleBox_7tqhk_8", jy = "_eyebrow_7tqhk_12", Iy = "_headline_7tqhk_13", Ry = "_desc_7tqhk_15", Oy = "_err_7tqhk_16", Py = "_chips_7tqhk_18", zy = "_footer_7tqhk_28", Xy = "_kicker_7tqhk_35", Fy = "_list_7tqhk_36", Hy = "_row_7tqhk_37", Wy = "_icon_7tqhk_39", Ky = "_text_7tqhk_40", Uy = "_cap_7tqhk_41", Gy = "_body_7tqhk_43", Yy = "_reason_7tqhk_44", Vy = "_empty_7tqhk_45", ye = {
  banner: Ty,
  heading: By,
  sparkleBox: Ly,
  eyebrow: jy,
  headline: Iy,
  desc: Ry,
  err: Oy,
  chips: Py,
  footer: zy,
  kicker: Xy,
  list: Fy,
  row: Hy,
  icon: Wy,
  text: Ky,
  cap: Uy,
  body: Gy,
  reason: Yy,
  empty: Vy
};
function tr({ size: e = 18 }) {
  return /* @__PURE__ */ n.createElement("svg", { width: e, height: e, viewBox: "0 0 24 24", fill: "none", "aria-hidden": "true" }, /* @__PURE__ */ n.createElement("path", { d: "M12 2.8c.72 5.16 2.85 7.3 8.02 8.02-5.17.72-7.3 2.86-8.02 8.02-.72-5.16-2.85-7.3-8.02-8.02C9.15 10.1 11.28 7.96 12 2.8Z", fill: "currentColor" }));
}
function gk({
  eyebrow: e,
  headline: t,
  desc: a,
  error: r,
  groups: o,
  maxChips: s = 4,
  onOpen: l,
  note: c,
  noteError: i,
  allLabel: m = "전체 업무 제안 보기",
  allDisabled: u,
  className: f = ""
}) {
  const p = o.slice(0, s), _ = o.length - p.length;
  return /* @__PURE__ */ n.createElement("section", { className: [ye.banner, f].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("div", { className: ye.heading }, /* @__PURE__ */ n.createElement("span", { className: ye.sparkleBox }, /* @__PURE__ */ n.createElement(tr, { size: 22 })), /* @__PURE__ */ n.createElement("div", null, /* @__PURE__ */ n.createElement("div", { className: ye.eyebrow }, /* @__PURE__ */ n.createElement(tr, { size: 11 }), " ", e), /* @__PURE__ */ n.createElement("h2", { className: ye.headline }, t), a ? /* @__PURE__ */ n.createElement("p", { className: [ye.desc, r ? ye.err : ""].filter(Boolean).join(" ") }, a) : null)), o.length > 0 && /* @__PURE__ */ n.createElement("div", { className: ye.chips }, p.map((y) => /* @__PURE__ */ n.createElement("button", { type: "button", key: y.key, title: y.label, onClick: () => l(y.key) }, /* @__PURE__ */ n.createElement("i", { style: y.color ? { background: y.color } : void 0, "aria-hidden": "true" }), y.label, " ", /* @__PURE__ */ n.createElement("strong", { style: y.color ? { color: y.color } : void 0 }, y.count, "건"))), _ > 0 && /* @__PURE__ */ n.createElement("button", { type: "button", onClick: () => l(null) }, "+", _, "종류 더")), /* @__PURE__ */ n.createElement("div", { className: ye.footer }, /* @__PURE__ */ n.createElement(
    "span",
    {
      className: i ? ye.err : void 0,
      role: i ? "alert" : void 0
    },
    c
  ), /* @__PURE__ */ n.createElement(_a, { onClick: () => l(null), disabled: u }, m, " ", /* @__PURE__ */ n.createElement("span", { "aria-hidden": "true" }, "→"))));
}
function Qy({ items: e, onRun: t, onSkip: a, busy: r, emptyText: o = "남은 제안이 없습니다." }) {
  return e.length === 0 ? /* @__PURE__ */ n.createElement("div", { className: ye.empty }, o) : /* @__PURE__ */ n.createElement("ul", { className: ye.list }, e.map((s) => {
    var l, c;
    return /* @__PURE__ */ n.createElement("li", { key: s.id, className: ye.row }, /* @__PURE__ */ n.createElement("span", { className: ye.icon, "aria-hidden": "true" }, (l = s.icon) != null ? l : "💡"), /* @__PURE__ */ n.createElement("div", { className: ye.text }, /* @__PURE__ */ n.createElement("div", { className: ye.cap }, s.title, s.meta ? /* @__PURE__ */ n.createElement("small", null, " · ", s.meta) : null), /* @__PURE__ */ n.createElement("div", { className: ye.body }, s.body), s.reason ? /* @__PURE__ */ n.createElement("div", { className: ye.reason }, s.reason) : null), /* @__PURE__ */ n.createElement(et, { size: "sm", variant: "primary", disabled: r, onClick: () => t(s) }, (c = s.actionLabel) != null ? c : "실행"), /* @__PURE__ */ n.createElement(et, { size: "sm", disabled: r, onClick: () => a(s) }, "무시"));
  }));
}
function vk({ title: e, kicker: t = "ProActive AI 업무 제안", items: a, onClose: r, onRun: o, onSkip: s }) {
  const l = B(!1), [c, i] = A(!1), [m, u] = A(""), f = async (p) => {
    if (!l.current) {
      l.current = !0, i(!0), u("");
      try {
        await p();
      } catch {
        u("처리하지 못했습니다. 잠시 후 다시 시도하세요.");
      } finally {
        l.current = !1, i(!1);
      }
    }
  };
  return /* @__PURE__ */ n.createElement(
    Pn,
    {
      title: e,
      onClose: r,
      closeOnEsc: !0,
      confirmDiscard: !1,
      headerExtra: /* @__PURE__ */ n.createElement("span", { className: ye.kicker }, "✦ ", t),
      error: m,
      footer: /* @__PURE__ */ n.createElement(et, { onClick: r }, "닫기")
    },
    /* @__PURE__ */ n.createElement(Qy, { items: a, busy: c, onRun: (p) => f(() => o(p)), onSkip: (p) => f(() => s(p)) })
  );
}
const Jy = "_wrap_1wvdc_2", Zy = "_header_1wvdc_7", eb = "_iconBox_1wvdc_8", tb = "_headText_1wvdc_12", nb = "_eyebrow_1wvdc_13", ab = "_headline_1wvdc_14", rb = "_headerExtra_1wvdc_16", ob = "_grid_1wvdc_19", sb = "_card_1wvdc_20", lb = "_badge_1wvdc_29", cb = "_toneRed_1wvdc_33", ib = "_toneViolet_1wvdc_34", ub = "_toneGreen_1wvdc_35", mb = "_toneBlue_1wvdc_36", db = "_title_1wvdc_38", fb = "_summary_1wvdc_42", pb = "_action_1wvdc_46", _b = "_notice_1wvdc_53", yb = "_err_1wvdc_56", fe = {
  wrap: Jy,
  header: Zy,
  iconBox: eb,
  headText: tb,
  eyebrow: nb,
  headline: ab,
  headerExtra: rb,
  grid: ob,
  card: sb,
  badge: lb,
  toneRed: cb,
  toneViolet: ib,
  toneGreen: ub,
  toneBlue: mb,
  title: db,
  summary: fb,
  action: pb,
  notice: _b,
  err: yb
};
function nr({ size: e = 16 }) {
  return /* @__PURE__ */ n.createElement("svg", { width: e, height: e, viewBox: "0 0 24 24", fill: "none", "aria-hidden": "true" }, /* @__PURE__ */ n.createElement("path", { d: "M12 2.8c.72 5.16 2.85 7.3 8.02 8.02-5.17.72-7.3 2.86-8.02 8.02-.72-5.16-2.85-7.3-8.02-8.02C9.15 10.1 11.28 7.96 12 2.8Z", fill: "currentColor" }));
}
const bb = {
  red: fe.toneRed,
  violet: fe.toneViolet,
  green: fe.toneGreen,
  blue: fe.toneBlue
};
function kk({
  items: e,
  onOpen: t,
  eyebrow: a = "PROACTIVE AI",
  headline: r = "지금 처리할 수 있는 업무를 발견했습니다",
  error: o,
  loading: s,
  emptyText: l = "지금은 처리할 업무 제안이 없습니다.",
  headerExtra: c,
  className: i = ""
}) {
  return /* @__PURE__ */ n.createElement("section", { className: [fe.wrap, i].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("div", { className: fe.header }, /* @__PURE__ */ n.createElement("span", { className: fe.iconBox }, /* @__PURE__ */ n.createElement(nr, { size: 18 })), /* @__PURE__ */ n.createElement("div", { className: fe.headText }, /* @__PURE__ */ n.createElement("div", { className: fe.eyebrow }, a), /* @__PURE__ */ n.createElement("h2", { className: fe.headline }, r)), c ? /* @__PURE__ */ n.createElement("div", { className: fe.headerExtra }, c) : null), o ? /* @__PURE__ */ n.createElement("div", { className: fe.notice + " " + fe.err, role: "alert" }, o) : null, e.length === 0 ? o ? null : s ? /* @__PURE__ */ n.createElement("div", { className: fe.notice, role: "status" }, "업무 제안을 확인하고 있습니다.") : /* @__PURE__ */ n.createElement("div", { className: fe.notice }, l) : /* @__PURE__ */ n.createElement("div", { className: fe.grid }, e.map((m) => {
    var u, f;
    return /* @__PURE__ */ n.createElement("button", { type: "button", key: m.id, className: fe.card, onClick: () => t(m) }, /* @__PURE__ */ n.createElement("span", { className: [fe.badge, bb[(u = m.tone) != null ? u : "violet"]].join(" ") }, /* @__PURE__ */ n.createElement(nr, { size: 9 }), m.badge), /* @__PURE__ */ n.createElement("span", { className: fe.title }, m.title), m.summary ? /* @__PURE__ */ n.createElement("span", { className: fe.summary, title: typeof m.summary == "string" ? m.summary : void 0 }, m.summary) : null, /* @__PURE__ */ n.createElement("span", { className: fe.action }, (f = m.actionLabel) != null ? f : "상세 보기", " ", /* @__PURE__ */ n.createElement("span", { "aria-hidden": "true" }, "→")));
  })));
}
const Eb = "_wrapper_1j5pd_1", hb = "_searchIcon_1j5pd_17", gb = "_input_1j5pd_25", vb = "_clearButton_1j5pd_39", kb = "_hint_1j5pd_59", nn = {
  wrapper: Eb,
  searchIcon: hb,
  input: gb,
  clearButton: vb,
  hint: kb
}, wb = /* @__PURE__ */ n.createElement("svg", { width: "16", height: "16", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "1.8", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ n.createElement("circle", { cx: "11", cy: "11", r: "7" }), /* @__PURE__ */ n.createElement("path", { d: "M21 21l-4.35-4.35" }));
function Nb({
  value: e,
  onChange: t,
  placeholder: a,
  hint: r,
  onSubmit: o,
  onClear: s
}) {
  const l = (c) => {
    c.key === "Enter" && (o == null || o());
  };
  return /* @__PURE__ */ n.createElement("div", { className: `${nn.wrapper} axe-focus-box` }, /* @__PURE__ */ n.createElement("span", { className: nn.searchIcon }, wb), /* @__PURE__ */ n.createElement(
    "input",
    {
      type: "text",
      className: nn.input,
      value: e,
      placeholder: a,
      onChange: (c) => t(c.target.value),
      onKeyDown: l
    }
  ), s && e.length > 0 && /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      className: nn.clearButton,
      onClick: s,
      "aria-label": "비우기"
    },
    /* @__PURE__ */ n.createElement("svg", { width: "14", height: "14", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ n.createElement("path", { d: "M18 6L6 18" }), /* @__PURE__ */ n.createElement("path", { d: "M6 6l12 12" }))
  ), r && /* @__PURE__ */ n.createElement("span", { className: nn.hint }, r));
}
const $b = "_screen_sizmw_1", xb = "_shell_sizmw_8", Db = "_command_sizmw_10", Ab = "_body_sizmw_20", Cb = "_overview_sizmw_22", Sb = "_areaHead_sizmw_25", Mb = "_hintPart_sizmw_28", qb = "_hintIcon_sizmw_29", kt = {
  screen: $b,
  shell: xb,
  command: Db,
  body: Ab,
  overview: Cb,
  areaHead: Sb,
  hintPart: Mb,
  hintIcon: qb
};
function wk({ search: e, panel: t, children: a, className: r = "" }) {
  var o;
  return /* @__PURE__ */ n.createElement("main", { className: [kt.screen, r].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("div", { className: kt.shell }, e && /* @__PURE__ */ n.createElement("div", { className: kt.command }, /* @__PURE__ */ n.createElement(
    Nb,
    {
      value: e.value,
      onChange: e.onChange,
      onClear: e.onClear,
      onSubmit: e.onSubmit,
      placeholder: e.placeholder,
      hint: (o = e.hint) != null ? o : /* @__PURE__ */ n.createElement("kbd", null, "F10")
    }
  ), t), /* @__PURE__ */ n.createElement("div", { className: kt.body }, a)));
}
function Nk({ children: e, className: t = "" }) {
  return /* @__PURE__ */ n.createElement("div", { className: [kt.overview, t].filter(Boolean).join(" ") }, e);
}
function Tb() {
  return /* @__PURE__ */ n.createElement("svg", { className: kt.hintIcon, width: "13", height: "13", viewBox: "0 0 12 12", "aria-hidden": "true", fill: "none", stroke: "currentColor", strokeWidth: "1.4", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ n.createElement("path", { d: "M5 2H2.5A.5.5 0 0 0 2 2.5v7a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5V7M7.5 2H10v2.5M10 2 5.5 6.5" }));
}
function Bb(e) {
  return typeof e != "string" || e.indexOf("↗") < 0 ? e : e.split("↗").map((a, r) => /* @__PURE__ */ n.createElement("span", { key: r, className: kt.hintPart }, r > 0 && /* @__PURE__ */ n.createElement(Tb, null), a));
}
function $k({ title: e, hint: t }) {
  return /* @__PURE__ */ n.createElement("div", { className: kt.areaHead }, /* @__PURE__ */ n.createElement("h2", null, e), t && /* @__PURE__ */ n.createElement("span", null, Bb(t)));
}
const Lb = "_group_oodts_1", jb = "_grid_oodts_7", Ib = "_row_oodts_8", Rb = "_item_oodts_9", Ob = "_launch_oodts_14", Pb = "_name_oodts_17", zb = "_desc_oodts_18", Xb = "_badge_oodts_19", Fb = "_disabled_oodts_23", Hb = "_tab_oodts_25", Wb = "_star_oodts_25", Kb = "_on_oodts_30", Ub = "_empty_oodts_32", Re = {
  group: Lb,
  grid: jb,
  row: Ib,
  item: Rb,
  launch: Ob,
  name: Pb,
  desc: zb,
  badge: Xb,
  disabled: Fb,
  tab: Hb,
  star: Wb,
  on: Kb,
  empty: Ub
};
function Gb() {
  return /* @__PURE__ */ n.createElement("svg", { width: "12", height: "12", viewBox: "0 0 12 12", "aria-hidden": "true", fill: "none", stroke: "currentColor", strokeWidth: "1.4", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ n.createElement("path", { d: "M3 1.5h4l2.5 2.5v6a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5v-8A.5.5 0 0 1 3 1.5Z" }), /* @__PURE__ */ n.createElement("path", { d: "M7 1.5V4h2.5M4.2 6.2h3.6M4.2 8.2h3.6" }));
}
function Yb() {
  return /* @__PURE__ */ n.createElement("svg", { width: "13", height: "13", viewBox: "0 0 12 12", "aria-hidden": "true", fill: "none", stroke: "currentColor", strokeWidth: "1.4", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ n.createElement("path", { d: "M5 2H2.5A.5.5 0 0 0 2 2.5v7a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5V7M7.5 2H10v2.5M10 2 5.5 6.5" }));
}
function xk({ title: e, items: t, emptyText: a, className: r = "" }) {
  return /* @__PURE__ */ n.createElement("section", { className: [Re.group, r].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("h3", null, e), /* @__PURE__ */ n.createElement("div", { className: Re.grid }, t.map((o) => /* @__PURE__ */ n.createElement("div", { className: Re.row, key: o.key }, /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      className: [Re.item, o.disabled ? Re.disabled : ""].filter(Boolean).join(" "),
      disabled: o.disabled,
      onClick: o.onOpen
    },
    /* @__PURE__ */ n.createElement("span", { className: Re.launch }, /* @__PURE__ */ n.createElement(Gb, null)),
    /* @__PURE__ */ n.createElement("span", { className: Re.name }, o.label),
    o.desc && /* @__PURE__ */ n.createElement("span", { className: Re.desc }, o.desc),
    o.badge != null && /* @__PURE__ */ n.createElement("em", { className: Re.badge }, o.badge)
  ), o.onOpenNewTab && !o.disabled && /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      className: Re.tab,
      "aria-label": `${o.label} 새 탭으로 열기`,
      title: "새 탭으로 열기",
      onClick: o.onOpenNewTab
    },
    /* @__PURE__ */ n.createElement(Yb, null)
  ), o.onToggleStar && !o.disabled && /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      className: [Re.star, o.starred ? Re.on : ""].filter(Boolean).join(" "),
      "aria-pressed": !!o.starred,
      "aria-label": `${o.label} ${o.starred ? "마이메뉴에서 삭제" : "마이메뉴에 추가"}`,
      onClick: o.onToggleStar
    },
    o.starred ? "★" : "☆"
  ))), t.length === 0 && a != null && /* @__PURE__ */ n.createElement("p", { className: Re.empty }, a)));
}
const Vb = "_strip_8zhai_2", Qb = "_day_8zhai_9", Jb = "_total_8zhai_10", Zb = "_sel_8zhai_31", eE = "_today_8zhai_35", tE = "_md_8zhai_35", nE = "_off_8zhai_36", aE = "_head_8zhai_45", rE = "_wd_8zhai_46", oE = "_sun_8zhai_47", sE = "_sat_8zhai_48", lE = "_lock_8zhai_50", cE = "_value_8zhai_60", iE = "_mark_8zhai_66", uE = "_warn_8zhai_67", mE = "_danger_8zhai_68", dE = "_info_8zhai_69", we = {
  strip: Vb,
  day: Qb,
  total: Jb,
  sel: Zb,
  today: eE,
  md: tE,
  off: nE,
  head: aE,
  wd: rE,
  sun: oE,
  sat: sE,
  lock: lE,
  value: cE,
  mark: iE,
  warn: uE,
  danger: mE,
  info: dE
}, ar = ["일", "월", "화", "수", "목", "금", "토"];
function fE(e) {
  const [t, a, r] = e.split("-").map(Number), o = new Date(t, a - 1, r).getDay();
  return { md: `${a}/${r}`, wd: o };
}
function Dk({
  days: e,
  selected: t,
  today: a,
  onSelect: r,
  total: o,
  totalLabel: s = "합계",
  "aria-label": l,
  className: c
}) {
  const i = B([]), m = (p) => {
    var y;
    const _ = e.length;
    for (let d = 0; d < _; d++) {
      const b = (p + d + _) % _;
      if (!e[b].disabled) {
        (y = i.current[b]) == null || y.focus();
        return;
      }
    }
  }, u = (p, _) => {
    p.key === "ArrowRight" ? (p.preventDefault(), m(_ + 1)) : p.key === "ArrowLeft" ? (p.preventDefault(), m(_ - 1)) : p.key === "Home" ? (p.preventDefault(), m(0)) : p.key === "End" && (p.preventDefault(), m(e.length - 1));
  }, f = Math.max(0, e.findIndex((p) => p.date === t));
  return /* @__PURE__ */ n.createElement("div", { className: `${we.strip}${c ? ` ${c}` : ""}`, role: "group", "aria-label": l }, e.map((p, _) => {
    var $, g, x, h;
    const { md: y, wd: d } = fE(p.date), b = [
      we.day,
      p.off ? we.off : "",
      p.date === t ? we.sel : "",
      p.date === a ? we.today : "",
      d === 0 ? we.sun : d === 6 ? we.sat : ""
    ].filter(Boolean).join(" "), N = [`${y}(${ar[d]})`, p.offLabel, p.locked ? "잠김" : null, ($ = p.mark) == null ? void 0 : $.text].filter(Boolean).join(" · ");
    return /* @__PURE__ */ n.createElement(
      "button",
      {
        key: p.date,
        ref: (w) => {
          i.current[_] = w;
        },
        type: "button",
        className: b,
        disabled: p.disabled,
        tabIndex: _ === f ? 0 : -1,
        "aria-pressed": p.date === t,
        "aria-label": N,
        title: N,
        onClick: () => r == null ? void 0 : r(p.date),
        onKeyDown: (w) => u(w, _)
      },
      /* @__PURE__ */ n.createElement("span", { className: we.head }, /* @__PURE__ */ n.createElement("span", { className: we.wd }, ar[d]), /* @__PURE__ */ n.createElement("span", { className: we.md }, y), p.locked && /* @__PURE__ */ n.createElement("span", { className: we.lock, "aria-hidden": "true" }, "잠김")),
      /* @__PURE__ */ n.createElement("span", { className: we.value }, p.value),
      /* @__PURE__ */ n.createElement("span", { className: `${we.mark}${p.mark ? ` ${we[p.mark.tone]}` : ""}` }, (h = (g = p.mark) == null ? void 0 : g.text) != null ? h : p.off && (x = p.offLabel) != null ? x : "")
    );
  }), o !== void 0 && /* @__PURE__ */ n.createElement("div", { className: we.total }, /* @__PURE__ */ n.createElement("span", { className: we.wd }, s), /* @__PURE__ */ n.createElement("span", { className: we.value }, o)));
}
const pE = "_stepper_1wbt2_1", _E = "_nav_1wbt2_2", yE = "_today_1wbt2_3", bE = "_range_1wbt2_14", an = {
  stepper: pE,
  nav: _E,
  today: yE,
  range: bE
};
function EE(e) {
  const t = Ea(e);
  return t === 0 ? 7 : t;
}
function hE(e, t = 1) {
  const a = (EE(e) - t + 7) % 7;
  return Ln(e, -a);
}
function Qn(e, t) {
  return Ln(e, t);
}
function Ak({ value: e, onChange: t, weekStart: a = 1, today: r, disabled: o, label: s = "주" }) {
  const l = Qn(e, 6), c = hE(r, a), i = l.slice(0, 4) === e.slice(0, 4) ? l.slice(5) : l;
  return /* @__PURE__ */ n.createElement("span", { className: an.stepper, role: "group", "aria-label": s }, /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      className: an.nav,
      onClick: () => t(Qn(e, -7)),
      disabled: o,
      "aria-label": "이전 주"
    },
    "◀"
  ), /* @__PURE__ */ n.createElement("span", { className: an.range, "aria-live": "polite" }, e, " ~ ", i), /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      className: an.nav,
      onClick: () => t(Qn(e, 7)),
      disabled: o,
      "aria-label": "다음 주"
    },
    "▶"
  ), /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      className: an.today,
      onClick: () => t(c),
      disabled: o || e === c
    },
    "이번 주"
  ));
}
const gE = "_wrap_1dtpy_1", vE = "_svg_1dtpy_2", kE = "_grid_1dtpy_3", wE = "_axis_1dtpy_4", NE = "_accent_1dtpy_5", $E = "_muted_1dtpy_6", xE = "_ok_1dtpy_7", DE = "_warn_1dtpy_8", AE = "_danger_1dtpy_9", CE = "_legend_1dtpy_10", SE = "_dot_accent_1dtpy_13", ME = "_dot_muted_1dtpy_14", qE = "_dot_ok_1dtpy_15", TE = "_dot_warn_1dtpy_16", BE = "_dot_danger_1dtpy_17", bt = {
  wrap: gE,
  svg: vE,
  grid: kE,
  axis: wE,
  accent: NE,
  muted: $E,
  ok: xE,
  warn: DE,
  danger: AE,
  legend: CE,
  dot_accent: SE,
  dot_muted: ME,
  dot_ok: qE,
  dot_warn: TE,
  dot_danger: BE
}, LE = 600;
function jE(e) {
  if (e <= 0) return 1;
  const t = Math.pow(10, Math.floor(Math.log10(e))), a = e / t;
  return (a <= 1 ? 1 : a <= 2 ? 2 : a <= 5 ? 5 : 10) * t;
}
const rr = (e) => e.toLocaleString("ko-KR", { maximumFractionDigits: 1 });
function Ck({ categories: e, series: t, unit: a = "", height: r = 180, label: o, labelEvery: s }) {
  const l = B(null), [c, i] = A(LE);
  $e(() => {
    const E = l.current;
    if (!E) return;
    const D = () => {
      const q = E.clientWidth;
      q > 0 && i((M) => M === q ? M : q);
    };
    if (D(), typeof ResizeObserver == "undefined") return;
    const C = new ResizeObserver(D);
    return C.observe(E), () => C.disconnect();
  }, []);
  const m = r, u = 40, f = 22, p = 8, _ = c - u - 4, y = m - f - p, d = t.flatMap((E) => E.values.filter((D) => D != null)), b = jE(Math.max(0, ...d)), N = Math.max(e.length, 1), $ = _ / N, g = Math.min(8, $ * 0.2), x = Math.max(1, ($ - g) / Math.max(t.length, 1)), h = s != null ? s : Math.max(1, Math.ceil(N / 8)), w = [0, b / 2, b];
  return /* @__PURE__ */ n.createElement("div", { className: bt.wrap, ref: l }, /* @__PURE__ */ n.createElement(
    "svg",
    {
      className: bt.svg,
      viewBox: `0 0 ${c} ${m}`,
      role: "img",
      "aria-label": o,
      style: { height: r }
    },
    w.map((E) => {
      const D = p + y - E / b * y;
      return /* @__PURE__ */ n.createElement("g", { key: E }, /* @__PURE__ */ n.createElement("line", { className: bt.grid, x1: u, x2: c - 4, y1: D, y2: D }), /* @__PURE__ */ n.createElement("text", { className: bt.axis, x: u - 4, y: D + 3, textAnchor: "end" }, rr(E)));
    }),
    e.map((E, D) => /* @__PURE__ */ n.createElement("g", { key: E }, t.map((C, q) => {
      var T;
      const M = C.values[D];
      if (M == null || M <= 0) return null;
      const I = M / b * y;
      return /* @__PURE__ */ n.createElement(
        "rect",
        {
          key: C.key,
          className: bt[(T = C.tone) != null ? T : "accent"],
          x: u + D * $ + g / 2 + q * x,
          y: p + y - I,
          width: x,
          height: I
        },
        /* @__PURE__ */ n.createElement("title", null, `${E} · ${C.label} ${rr(M)}${a}`)
      );
    }), D % h === 0 && /* @__PURE__ */ n.createElement("text", { className: bt.axis, x: u + D * $ + $ / 2, y: m - 6, textAnchor: "middle" }, E)))
  ), /* @__PURE__ */ n.createElement("ul", { className: bt.legend }, t.map((E) => {
    var D;
    return /* @__PURE__ */ n.createElement("li", { key: E.key }, /* @__PURE__ */ n.createElement("i", { className: bt[`dot_${(D = E.tone) != null ? D : "accent"}`], "aria-hidden": "true" }), E.label, a ? ` (${a})` : "");
  })));
}
const IE = "_wrap_85lir_1", RE = "_track_85lir_2", OE = "_accent_85lir_3", PE = "_muted_85lir_3", zE = "_ok_85lir_3", XE = "_warn_85lir_3", FE = "_danger_85lir_3", HE = "_center_85lir_9", WE = "_legend_85lir_10", KE = "_name_85lir_13", UE = "_val_85lir_14", GE = "_pct_85lir_15", YE = "_dot_accent_85lir_16", VE = "_dot_muted_85lir_17", QE = "_dot_ok_85lir_18", JE = "_dot_warn_85lir_19", ZE = "_dot_danger_85lir_20", ot = {
  wrap: IE,
  track: RE,
  accent: OE,
  muted: PE,
  ok: zE,
  warn: XE,
  danger: FE,
  center: HE,
  legend: WE,
  name: KE,
  val: UE,
  pct: GE,
  dot_accent: YE,
  dot_muted: VE,
  dot_ok: QE,
  dot_warn: JE,
  dot_danger: ZE
}, ca = 40, or = 2 * Math.PI * ca;
function Sk({ items: e, center: t, size: a = 120, label: r, emptyText: o = "자료 없음", unit: s = "" }) {
  const l = e.reduce((i, m) => i + Math.max(0, m.value), 0);
  let c = 0;
  return /* @__PURE__ */ n.createElement("div", { className: ot.wrap }, /* @__PURE__ */ n.createElement("svg", { viewBox: "0 0 100 100", width: a, height: a, role: "img", "aria-label": r }, /* @__PURE__ */ n.createElement("circle", { className: ot.track, cx: "50", cy: "50", r: ca }), l > 0 && e.map((i) => {
    var f;
    const m = Math.max(0, i.value) / l * or, u = c;
    return c += m, m <= 0 ? null : /* @__PURE__ */ n.createElement(
      "circle",
      {
        key: i.key,
        className: ot[(f = i.tone) != null ? f : "accent"],
        cx: "50",
        cy: "50",
        r: ca,
        strokeDasharray: `${m} ${or - m}`,
        strokeDashoffset: -u,
        transform: "rotate(-90 50 50)"
      },
      /* @__PURE__ */ n.createElement("title", null, `${i.label} ${i.value.toLocaleString("ko-KR")}${s}`)
    );
  }), /* @__PURE__ */ n.createElement("text", { className: ot.center, x: "50", y: "54", textAnchor: "middle" }, l > 0 ? t != null ? t : l.toLocaleString("ko-KR") : o)), /* @__PURE__ */ n.createElement("ul", { className: ot.legend }, e.map((i) => {
    var m;
    return /* @__PURE__ */ n.createElement("li", { key: i.key }, /* @__PURE__ */ n.createElement("i", { className: ot[`dot_${(m = i.tone) != null ? m : "accent"}`], "aria-hidden": "true" }), /* @__PURE__ */ n.createElement("span", { className: ot.name }, i.label), /* @__PURE__ */ n.createElement("span", { className: ot.val }, i.value.toLocaleString("ko-KR"), s), /* @__PURE__ */ n.createElement("span", { className: ot.pct }, l > 0 ? `${Math.round(i.value / l * 100)}%` : "-"));
  })));
}
const e1 = "_wrap_1b8ll_1", t1 = "_track_1b8ll_2", n1 = "_compact_1b8ll_3", a1 = "_fill_1b8ll_4", r1 = "_accent_1b8ll_5", o1 = "_muted_1b8ll_6", s1 = "_ok_1b8ll_7", l1 = "_warn_1b8ll_8", c1 = "_danger_1b8ll_9", i1 = "_num_1b8ll_10", u1 = "_none_1b8ll_12", Ct = {
  wrap: e1,
  track: t1,
  compact: n1,
  fill: a1,
  accent: r1,
  muted: o1,
  ok: s1,
  warn: l1,
  danger: c1,
  num: i1,
  none: u1
};
function Mk({ value: e, label: t, tone: a = "accent", compact: r }) {
  if (e == null)
    return /* @__PURE__ */ n.createElement("span", { className: Ct.none, "aria-label": `${t} 해당 없음` }, "-");
  const o = Math.max(0, Math.min(100, e));
  return /* @__PURE__ */ n.createElement(
    "span",
    {
      className: [Ct.wrap, r ? Ct.compact : ""].filter(Boolean).join(" "),
      role: "progressbar",
      "aria-label": t,
      "aria-valuemin": 0,
      "aria-valuemax": 100,
      "aria-valuenow": o
    },
    /* @__PURE__ */ n.createElement("span", { className: Ct.track }, /* @__PURE__ */ n.createElement("span", { className: `${Ct.fill} ${Ct[a]}`, style: { width: `${o}%` } })),
    /* @__PURE__ */ n.createElement("span", { className: Ct.num }, o, "%")
  );
}
const m1 = { day: 28, week: 10, month: 3 };
function Lt(e, t) {
  return Ln(e, t);
}
function ia(e, t) {
  return vt(t) - vt(e) + 1;
}
function Gr(e) {
  return Ea(e);
}
const sr = (e) => {
  const t = Gr(e);
  return t === 0 || t === 6;
};
function Ht(e, t, a, r) {
  const o = [], s = ia(e, t);
  for (let l = 0; l < s; l++) {
    const c = Lt(e, l), i = a(c), m = o[o.length - 1];
    m && m.key === i ? m.days++ : o.push({ key: i, label: r(c), offset: l, days: 1 });
  }
  return o;
}
function d1(e, t, a) {
  const r = (s) => s.slice(0, 7), o = (s) => `${s.slice(0, 4)}.${s.slice(5, 7)}`;
  if (a === "month")
    return {
      top: Ht(e, t, (s) => s.slice(0, 4), (s) => `${s.slice(0, 4)}년`),
      bottom: Ht(e, t, r, (s) => `${Number(s.slice(5, 7))}월`)
    };
  if (a === "week") {
    const s = (l) => Lt(l, -((Gr(l) + 6) % 7));
    return {
      top: Ht(e, t, r, o),
      bottom: Ht(e, t, s, (l) => {
        const c = s(l);
        return `${Number(c.slice(5, 7))}/${Number(c.slice(8, 10))}`;
      })
    };
  }
  return {
    top: Ht(e, t, r, o),
    bottom: Ht(e, t, (s) => s, (s) => String(Number(s.slice(8, 10))))
  };
}
function Jn(e, t, a, r) {
  if (a === "move") return { start: Lt(e, r), end: Lt(t, r) };
  if (a === "start") {
    const s = Lt(e, r);
    return { start: s > t ? t : s, end: t };
  }
  const o = Lt(t, r);
  return { start: e, end: o < e ? e : o };
}
const f1 = "_gantt_1smka_3", p1 = "_scroll_1smka_15", _1 = "_canvas_1smka_21", y1 = "_head_1smka_24", b1 = "_headLabel_1smka_32", E1 = "_headTrack_1smka_43", h1 = "_band_1smka_44", g1 = "_seg_1smka_46", v1 = "_tick_1smka_59", k1 = "_tickOff_1smka_60", w1 = "_body_1smka_62", N1 = "_overlay_1smka_65", $1 = "_weekend_1smka_66", x1 = "_holiday_1smka_66", D1 = "_today_1smka_68", A1 = "_row_1smka_70", C1 = "_label_1smka_76", S1 = "_sel_1smka_77", M1 = "_track_1smka_77", q1 = "_dim_1smka_78", T1 = "_labelText_1smka_95", B1 = "_dot_1smka_96", L1 = "_warn_1smka_97", j1 = "_err_1smka_98", I1 = "_bar_1smka_113", R1 = "_can_1smka_21", O1 = "_dragging_1smka_126", P1 = "_fill_1smka_127", z1 = "_late_1smka_128", X1 = "_summary_1smka_130", F1 = "_handle_1smka_133", H1 = "_hL_1smka_134", W1 = "_hR_1smka_135", K1 = "_mark_1smka_137", U1 = "_barText_1smka_138", G1 = "_empty_1smka_147", Y1 = "_srOnly_1smka_150", ee = {
  gantt: f1,
  scroll: p1,
  canvas: _1,
  head: y1,
  headLabel: b1,
  headTrack: E1,
  band: h1,
  seg: g1,
  tick: v1,
  tickOff: k1,
  body: w1,
  overlay: N1,
  weekend: $1,
  holiday: x1,
  today: D1,
  row: A1,
  label: C1,
  sel: S1,
  track: M1,
  dim: q1,
  labelText: T1,
  dot: B1,
  warn: L1,
  err: j1,
  bar: I1,
  can: R1,
  dragging: O1,
  fill: P1,
  late: z1,
  summary: X1,
  handle: F1,
  hL: H1,
  hR: W1,
  mark: K1,
  barText: U1,
  empty: G1,
  srOnly: Y1
}, lr = 28, cr = "키보드: ←→ 옮기기 · Shift+←→ 끝 조절 · Alt+←→ 시작 조절 · Enter 열기";
let V1 = 0;
function qk({
  rows: e,
  from: t,
  to: a,
  scale: r = "day",
  holidays: o = {},
  today: s,
  scrollToToday: l = !0,
  onChange: c,
  onRowClick: i,
  selectedId: m,
  labelWidth: u = 280,
  labelHeader: f,
  lockedReason: p,
  scrollMemory: _,
  className: y = "",
  style: d,
  "aria-label": b
}) {
  const N = B("");
  N.current || (N.current = `axe-gantt-keys-${++V1}`);
  const $ = m1[r], g = Math.max(ia(t, a), 1), x = vt(t), h = g * $, w = ke(() => d1(t, a, r), [t, a, r]), E = ke(() => {
    const v = [];
    for (let P = 0; P < g; P++) {
      const V = Lt(t, P), Q = V in o;
      if (!Q && !sr(V)) continue;
      const se = v[v.length - 1];
      se && se.offset + se.days === P && se.holiday === Q ? se.days++ : v.push({ offset: P, days: 1, holiday: Q });
    }
    return v;
  }, [t, g, o]), [D, C] = A(null), q = B(null), M = (v) => !!c && !v.locked && !v.summary && !!v.start && !!v.end, I = (v, P, V) => {
    if (!M(P) || v.button !== 0) return;
    v.stopPropagation(), v.currentTarget.setPointerCapture(v.pointerId);
    const Q = { id: P.id, mode: V, x: v.clientX, delta: 0, moved: !1 };
    q.current = Q, C(Q);
  }, T = (v) => {
    const P = q.current;
    if (!P) return;
    const V = Math.round((v.clientX - P.x) / $), Q = P.moved || Math.abs(v.clientX - P.x) > 3;
    if (V !== P.delta || Q !== P.moved) {
      const se = { ...P, delta: V, moved: Q };
      q.current = se, C(se);
    }
  }, F = (v) => {
    const P = q.current;
    if (q.current = null, C(null), !!P) {
      if (!P.moved) {
        i == null || i(v);
        return;
      }
      P.delta !== 0 && v.start && v.end && (c == null || c(v, Jn(v.start, v.end, P.mode, P.delta), P.mode));
    }
  }, Y = () => {
    q.current = null, C(null);
  }, H = (v, P) => {
    if (v.key === "Escape" && q.current) {
      Y();
      return;
    }
    if (v.key === "Enter") {
      i == null || i(P);
      return;
    }
    if (!M(P) || v.key !== "ArrowLeft" && v.key !== "ArrowRight") return;
    v.preventDefault();
    const V = v.key === "ArrowLeft" ? -1 : 1, Q = v.shiftKey ? "end" : v.altKey ? "start" : "move";
    c == null || c(P, Jn(P.start, P.end, Q, V), Q);
  }, j = s ? vt(s) - x : -1, ne = B(null), te = B(null);
  return $e(() => {
    const v = ne.current;
    if (v && (_ != null && _.current) && te.current === null) {
      te.current = r, v.scrollLeft = _.current.left, v.scrollTop = _.current.top;
      return;
    }
    if (!l || !v || j < 0 || j >= g || te.current === r) return;
    te.current = r;
    const P = Math.max(v.clientWidth - u, 0);
    v.scrollLeft = Math.max(0, j * $ + $ / 2 - P / 3);
  }, [l, r, j, g, $, u]), /* @__PURE__ */ n.createElement(
    "div",
    {
      className: [ee.gantt, y].filter(Boolean).join(" "),
      style: d,
      role: "region",
      "aria-label": b != null ? b : "간트",
      onKeyDown: (v) => {
        v.key === "Escape" && q.current && Y();
      }
    },
    /* @__PURE__ */ n.createElement("span", { id: N.current, className: ee.srOnly }, cr),
    /* @__PURE__ */ n.createElement(
      "div",
      {
        ref: ne,
        className: ee.scroll,
        onScroll: _ ? (v) => {
          _.current = { left: v.currentTarget.scrollLeft, top: v.currentTarget.scrollTop };
        } : void 0
      },
      /* @__PURE__ */ n.createElement("div", { className: ee.canvas, style: { width: u + h } }, /* @__PURE__ */ n.createElement("div", { className: ee.head, style: { gridTemplateColumns: `${u}px ${h}px` } }, /* @__PURE__ */ n.createElement("div", { className: ee.headLabel }, f), /* @__PURE__ */ n.createElement("div", { className: ee.headTrack }, /* @__PURE__ */ n.createElement("div", { className: ee.band }, w.top.map((v) => /* @__PURE__ */ n.createElement("span", { key: v.key, className: ee.seg, style: { left: v.offset * $, width: v.days * $ }, title: v.label }, v.label))), /* @__PURE__ */ n.createElement("div", { className: ee.band }, w.bottom.map((v) => {
        var V;
        const P = r === "day" && (v.key in o || sr(v.key));
        return /* @__PURE__ */ n.createElement(
          "span",
          {
            key: v.key,
            className: [ee.seg, ee.tick, P ? ee.tickOff : ""].filter(Boolean).join(" "),
            style: { left: v.offset * $, width: v.days * $ },
            title: (V = o[v.key]) != null ? V : v.key
          },
          v.days * $ >= 16 ? v.label : ""
        );
      })))), /* @__PURE__ */ n.createElement("div", { className: ee.body, style: { minHeight: lr } }, /* @__PURE__ */ n.createElement("div", { className: ee.overlay, style: { left: u, width: h }, "aria-hidden": "true" }, E.map((v) => /* @__PURE__ */ n.createElement("span", { key: v.offset, className: v.holiday ? ee.holiday : ee.weekend, style: { left: v.offset * $, width: v.days * $ } })), j >= 0 && j < g && /* @__PURE__ */ n.createElement("span", { className: ee.today, style: { left: j * $ + $ / 2 }, title: "오늘" })), e.map((v) => {
        var X, W, ie, Oe;
        const P = !!v.start && !!v.end && v.start <= v.end, V = D && D.id === v.id ? D : null, Q = P && V && V.delta !== 0 ? Jn(v.start, v.end, V.mode, V.delta) : P ? { start: v.start, end: v.end } : null, se = Q ? (vt(Q.start) - x) * $ : 0, L = Q ? ia(Q.start, Q.end) * $ : 0, Z = Math.max(0, Math.min(100, (X = v.progress) != null ? X : 0)), R = m != null && m === v.id, z = M(v), G = !z && c && Q ? p == null ? void 0 : p(v) : void 0;
        return /* @__PURE__ */ n.createElement(
          "div",
          {
            key: v.id,
            className: [ee.row, R ? ee.sel : "", v.dim ? ee.dim : ""].filter(Boolean).join(" "),
            style: { height: lr }
          },
          /* @__PURE__ */ n.createElement(
            "div",
            {
              className: ee.label,
              style: { width: u },
              title: v.name,
              onClick: () => i == null ? void 0 : i(v)
            },
            /* @__PURE__ */ n.createElement("span", { className: ee.labelText }, v.label),
            v.marked && /* @__PURE__ */ n.createElement("span", { className: ee.dot, title: "저장 대기", "aria-label": "저장 대기" }),
            v.warn && /* @__PURE__ */ n.createElement("span", { className: ee.warn, title: v.warn, "aria-label": v.warn }, "⚠"),
            v.error && /* @__PURE__ */ n.createElement("span", { className: ee.err, title: v.error, "aria-label": v.error }, "!")
          ),
          /* @__PURE__ */ n.createElement("div", { className: ee.track, style: { width: h }, onClick: () => !V && (i == null ? void 0 : i(v)) }, Q ? /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement(
            "div",
            {
              className: [ee.bar, v.summary ? ee.summary : "", v.late ? ee.late : "", z ? ee.can : "", V ? ee.dragging : ""].filter(Boolean).join(" "),
              style: { left: se, width: Math.max(L, 2) },
              role: "button",
              tabIndex: 0,
              "aria-label": `${(W = v.name) != null ? W : ""} ${Q.start} ~ ${Q.end}${v.progress != null ? ` ${Z}%` : ""}${v.late ? " 지연" : ""}${G ? ` 잠김: ${G}` : ""}`,
              "aria-describedby": z ? N.current : void 0,
              title: `${Q.start} ~ ${Q.end}${v.progress != null ? ` · ${Z}%` : ""}${v.late ? " · 지연" : ""}${z ? `
끌어 옮기기·양 끝 조절
${cr}` : ""}${G ? `
잠김: ${G}` : ""}`,
              onPointerDown: (xe) => I(xe, v, "move"),
              onPointerMove: T,
              onPointerUp: () => F(v),
              onPointerCancel: Y,
              onClick: (xe) => xe.stopPropagation(),
              onKeyDown: (xe) => H(xe, v)
            },
            v.progress != null && /* @__PURE__ */ n.createElement("span", { className: ee.fill, style: { width: `${Z}%` } }),
            z && /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("span", { className: `${ee.handle} ${ee.hL}`, onPointerDown: (xe) => I(xe, v, "start") }), /* @__PURE__ */ n.createElement("span", { className: `${ee.handle} ${ee.hR}`, onPointerDown: (xe) => I(xe, v, "end") }))
          ), v.markDate && v.markDate >= t && v.markDate <= a && /* @__PURE__ */ n.createElement("span", { className: ee.mark, style: { left: (vt(v.markDate) - x + 1) * $ - 1 }, title: (ie = v.markLabel) != null ? ie : v.markDate }), v.barText && /* @__PURE__ */ n.createElement("span", { className: ee.barText, style: { left: se + Math.max(L, 2) + 4 } }, v.barText)) : /* @__PURE__ */ n.createElement("span", { className: ee.empty }, (Oe = v.emptyText) != null ? Oe : "기간 없음"))
        );
      })))
    )
  );
}
const Q1 = "_board_192fl_3", J1 = "_col_192fl_15", Z1 = "_over_192fl_23", eh = "_head_192fl_25", th = "_title_192fl_33", nh = "_count_192fl_34", ah = "_hint_192fl_43", rh = "_list_192fl_45", oh = "_empty_192fl_54", sh = "_card_192fl_56", lh = "_sel_192fl_68", ch = "_dragging_192fl_69", ih = "_hasErr_192fl_70", uh = "_dot_192fl_71", mh = "_err_192fl_72", qe = {
  board: Q1,
  col: J1,
  over: Z1,
  head: eh,
  title: th,
  count: nh,
  hint: ah,
  list: rh,
  empty: oh,
  card: sh,
  sel: lh,
  dragging: ch,
  hasErr: ih,
  dot: uh,
  err: mh
}, Zn = "application/x-axerp-kanban";
function Tk({
  columns: e,
  cards: t,
  cardKey: a,
  columnOf: r,
  renderCard: o,
  cardLabel: s,
  onMove: l,
  onCardClick: c,
  selectedKey: i,
  marked: m,
  error: u,
  lockedReason: f,
  emptyText: p = "카드가 없습니다",
  moveHint: _,
  className: y = "",
  style: d,
  "aria-label": b
}) {
  const N = Qt("axe-kb"), [$, g] = A(null), [x, h] = A(null), w = new Map(t.map((M) => [String(a(M)), M])), E = B(null), D = B(null);
  U(() => {
    var T, F;
    const M = D.current;
    if (!M) return;
    if (Date.now() > M.until) {
      D.current = null;
      return;
    }
    const I = Array.from((F = (T = E.current) == null ? void 0 : T.querySelectorAll("[data-kanban-key]")) != null ? F : []).find((Y) => Y.dataset.kanbanKey === M.key);
    I && document.activeElement !== I && I.focus(), D.current = null;
  });
  const C = (M, I) => {
    M.preventDefault(), g(null), h(null);
    const T = M.dataTransfer.getData(Zn), F = w.get(T);
    F && r(F) !== I && (l == null || l(F, I));
  }, q = (M, I) => {
    if (M.key === "Enter" || M.key === " ") {
      M.preventDefault(), c == null || c(I);
      return;
    }
    if (!l || !M.altKey || M.key !== "ArrowLeft" && M.key !== "ArrowRight" || f != null && f(I)) return;
    M.preventDefault();
    const T = e.findIndex((Y) => Y.key === r(I)), F = T + (M.key === "ArrowLeft" ? -1 : 1);
    T >= 0 && F >= 0 && F < e.length && (D.current = { key: String(a(I)), until: Date.now() + 1500 }, l(I, e[F].key));
  };
  return /* @__PURE__ */ n.createElement("div", { ref: E, className: [qe.board, y].filter(Boolean).join(" "), style: d, role: "region", "aria-label": b != null ? b : "보드" }, e.map((M) => {
    const I = t.filter((T) => r(T) === M.key);
    return /* @__PURE__ */ n.createElement(
      "section",
      {
        key: M.key,
        className: [qe.col, $ === M.key ? qe.over : ""].filter(Boolean).join(" "),
        "aria-label": typeof M.title == "string" ? M.title : void 0,
        onDragOver: l ? (T) => {
          T.dataTransfer.types.includes(Zn) && (T.preventDefault(), g(M.key));
        } : void 0,
        onDragLeave: l ? (T) => {
          T.currentTarget.contains(T.relatedTarget) || g((F) => F === M.key ? null : F);
        } : void 0,
        onDrop: l ? (T) => C(T, M.key) : void 0
      },
      /* @__PURE__ */ n.createElement("header", { className: qe.head }, /* @__PURE__ */ n.createElement("span", { className: qe.title }, M.title), /* @__PURE__ */ n.createElement("span", { className: qe.count }, I.length), M.hint && /* @__PURE__ */ n.createElement("span", { className: qe.hint }, M.hint)),
      /* @__PURE__ */ n.createElement("div", { className: qe.list }, I.length === 0 && /* @__PURE__ */ n.createElement("p", { className: qe.empty }, p), I.map((T) => {
        const F = a(T), Y = f == null ? void 0 : f(T), H = u == null ? void 0 : u(T), j = !!l && !Y, ne = Y != null ? Y : j ? _ != null ? _ : "끌어 다른 열로 옮길 수 있습니다 (Alt+←→)" : void 0;
        return /* @__PURE__ */ n.createElement(
          "article",
          {
            key: F,
            className: [qe.card, i === F ? qe.sel : "", x === F ? qe.dragging : "", H ? qe.hasErr : ""].filter(Boolean).join(" "),
            tabIndex: 0,
            "data-kanban-key": String(F),
            role: "button",
            "aria-label": s == null ? void 0 : s(T),
            "aria-keyshortcuts": j ? "Alt+ArrowLeft Alt+ArrowRight" : void 0,
            title: ne,
            "aria-describedby": ne ? `${N}-h-${String(F)}` : void 0,
            draggable: j,
            onDragStart: j ? (te) => {
              te.dataTransfer.setData(Zn, String(F)), te.dataTransfer.effectAllowed = "move", h(F);
            } : void 0,
            onDragEnd: () => {
              h(null), g(null);
            },
            onClick: () => c == null ? void 0 : c(T),
            onKeyDown: (te) => q(te, T)
          },
          ne && /* @__PURE__ */ n.createElement(qr, { id: `${N}-h-${String(F)}` }, ne),
          (m == null ? void 0 : m(T)) && /* @__PURE__ */ n.createElement("span", { className: qe.dot, title: "저장 대기", "aria-label": "저장 대기" }),
          o(T),
          H && /* @__PURE__ */ n.createElement("p", { className: qe.err, role: "alert" }, H)
        );
      }))
    );
  }));
}
const dh = "_list_1aqum_2", fh = "_empty_1aqum_3", ph = "_item_1aqum_5", _h = "_row_block_1aqum_6", yh = "_row_warn_1aqum_7", bh = "_head_1aqum_9", Eh = "_mark_1aqum_16", hh = "_msg_1aqum_17", gh = "_count_1aqum_18", vh = "_aside_1aqum_19", kh = "_caret_1aqum_20", wh = "_block_1aqum_22", Nh = "_warn_1aqum_23", $h = "_info_1aqum_24", xh = "_body_1aqum_29", Dh = "_actions_1aqum_30", Te = {
  list: dh,
  empty: fh,
  item: ph,
  row_block: _h,
  row_warn: yh,
  head: bh,
  mark: Eh,
  msg: hh,
  count: gh,
  aside: vh,
  caret: kh,
  block: wh,
  warn: Nh,
  info: $h,
  body: xh,
  actions: Dh
}, Ah = { block: "■", warn: "▲", info: "●" }, Ch = { block: "차단", warn: "경고", info: "정보" };
function Bk({ items: e, empty: t = "점검할 항목이 없습니다", openTones: a = ["block"], className: r = "" }) {
  const [o, s] = A({}), [l, c] = A(e);
  return l !== e && (c(e), s({})), e.length ? /* @__PURE__ */ n.createElement("ul", { className: `${Te.list} ${r}` }, e.map((i) => {
    var p;
    const m = !!i.detail || !!i.actions, u = m && ((p = o[i.key]) != null ? p : a.includes(i.tone)), f = /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("span", { className: `${Te.mark} ${Te[i.tone]}`, "aria-label": Ch[i.tone], role: "img" }, Ah[i.tone]), /* @__PURE__ */ n.createElement("span", { className: Te.msg }, i.message), !!i.count && /* @__PURE__ */ n.createElement("span", { className: `${Te.count} ${Te[i.tone]}` }, i.count.toLocaleString("ko-KR"), "건"), i.aside != null && /* @__PURE__ */ n.createElement("span", { className: Te.aside }, i.aside), m && /* @__PURE__ */ n.createElement("span", { className: Te.caret, "aria-hidden": "true" }, u ? "▾" : "▸"));
    return /* @__PURE__ */ n.createElement("li", { key: i.key, className: `${Te.item} ${Te[`row_${i.tone}`]}` }, m ? /* @__PURE__ */ n.createElement(
      "button",
      {
        type: "button",
        className: Te.head,
        "aria-expanded": u,
        onClick: () => s((_) => ({ ..._, [i.key]: !u }))
      },
      f
    ) : /* @__PURE__ */ n.createElement("div", { className: Te.head }, f), u && /* @__PURE__ */ n.createElement("div", { className: Te.body }, i.detail, i.actions && /* @__PURE__ */ n.createElement("div", { className: Te.actions }, i.actions)));
  })) : /* @__PURE__ */ n.createElement("p", { className: `${Te.empty} ${r}` }, t);
}
function Sh(e, t) {
  const a = Math.max(1, Math.floor(t) || 1), r = Math.min(a, Math.max(1, Math.floor(e) || 1)), o = (s, l) => Array.from({ length: l - s + 1 }, (c, i) => s + i);
  return a <= 10 ? o(1, a) : r <= 5 ? [...o(1, 7), "…", a] : r >= a - 4 ? [1, "…", ...o(a - 6, a)] : [1, "…", ...o(r - 2, r + 2), "…", a];
}
function Mh(e, t) {
  const a = parseInt(e.replace(/[^\d]/g, ""), 10);
  return Number.isFinite(a) ? Math.min(Math.max(1, t), Math.max(1, a)) : null;
}
function Lk(e) {
  return e === "page" ? "쪽 합계" : "전체 합계";
}
function jk(e, t) {
  return Math.max(1, Math.ceil(Math.max(0, e) / Math.max(1, t)));
}
const qh = "_nav_1r2z8_1", Th = "_list_1r2z8_3", Bh = "_btn_1r2z8_4", Lh = "_cur_1r2z8_13", jh = "_gap_1r2z8_15", Ih = "_total_1r2z8_16", Rh = "_jump_1r2z8_17", Oh = "_go_1r2z8_20", Ph = "_size_1r2z8_22", zh = "_more_1r2z8_24", Xh = "_moreBtn_1r2z8_25", Fh = "_moreN_1r2z8_29", he = {
  nav: qh,
  list: Th,
  btn: Bh,
  cur: Lh,
  gap: jh,
  total: Ih,
  jump: Rh,
  in: "_in_1r2z8_18",
  go: Oh,
  size: Ph,
  more: zh,
  moreBtn: Xh,
  moreN: Fh
};
function Ik({ page: e, pageCount: t, onPageChange: a, jump: r = !1, pageSizes: o, pageSize: s, onPageSizeChange: l, total: c, className: i = "" }) {
  const m = Math.max(1, t), u = Math.min(m, Math.max(1, e)), [f, p] = A(String(u));
  U(() => p(String(u)), [u]);
  const _ = (d) => {
    d !== u && d >= 1 && d <= m && a(d);
  }, y = () => {
    const d = Mh(f, m);
    if (d === null) {
      p(String(u));
      return;
    }
    p(String(d)), _(d);
  };
  return /* @__PURE__ */ n.createElement("nav", { className: [he.nav, i].filter(Boolean).join(" "), "aria-label": "쪽 이동" }, c !== void 0 && /* @__PURE__ */ n.createElement("span", { className: he.total }, "총 ", c.toLocaleString("ko-KR"), "건"), /* @__PURE__ */ n.createElement("ol", { className: he.list }, /* @__PURE__ */ n.createElement("li", null, /* @__PURE__ */ n.createElement("button", { type: "button", className: he.btn, onClick: () => _(1), disabled: u === 1, "aria-label": "첫 쪽" }, "«")), /* @__PURE__ */ n.createElement("li", null, /* @__PURE__ */ n.createElement("button", { type: "button", className: he.btn, onClick: () => _(u - 1), disabled: u === 1, "aria-label": "이전 쪽" }, "‹")), Sh(u, m).map((d, b) => d === "…" ? /* @__PURE__ */ n.createElement("li", { key: `e${b}`, className: he.gap, "aria-hidden": "true" }, "…") : /* @__PURE__ */ n.createElement("li", { key: d }, /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      className: [he.btn, d === u ? he.cur : ""].filter(Boolean).join(" "),
      onClick: () => _(d),
      "aria-current": d === u ? "page" : void 0,
      "aria-label": `${d}쪽`
    },
    d
  ))), /* @__PURE__ */ n.createElement("li", null, /* @__PURE__ */ n.createElement("button", { type: "button", className: he.btn, onClick: () => _(u + 1), disabled: u === m, "aria-label": "다음 쪽" }, "›")), /* @__PURE__ */ n.createElement("li", null, /* @__PURE__ */ n.createElement("button", { type: "button", className: he.btn, onClick: () => _(m), disabled: u === m, "aria-label": "마지막 쪽" }, "»"))), /* @__PURE__ */ n.createElement("span", { className: he.total }, "전체 ", m, "쪽"), r && /* @__PURE__ */ n.createElement("span", { className: he.jump }, /* @__PURE__ */ n.createElement(
    "input",
    {
      className: he.in,
      inputMode: "numeric",
      value: f,
      "aria-label": "이동할 쪽 번호",
      onChange: (d) => p(d.target.value.replace(/[^\d]/g, "")),
      onKeyDown: (d) => {
        d.key === "Enter" && (d.preventDefault(), y());
      }
    }
  ), /* @__PURE__ */ n.createElement("button", { type: "button", className: he.go, onClick: y }, "이동")), o && s !== void 0 && l && /* @__PURE__ */ n.createElement("label", { className: he.size }, "쪽당", /* @__PURE__ */ n.createElement("select", { value: s, onChange: (d) => l(Number(d.target.value)) }, o.map((d) => /* @__PURE__ */ n.createElement("option", { key: d, value: d }, d, "건")))));
}
function Rk({ shown: e, total: t, onMore: a, busy: r = !1, className: o = "" }) {
  return e >= t ? null : /* @__PURE__ */ n.createElement("div", { className: [he.more, o].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("button", { type: "button", className: he.moreBtn, onClick: a, disabled: r, "aria-busy": r }, "더보기 ", /* @__PURE__ */ n.createElement("span", { className: he.moreN }, "(", e.toLocaleString("ko-KR"), "/", t.toLocaleString("ko-KR"), ")")));
}
const Hh = "_ol_fbatg_1", Wh = "_li_fbatg_2", Kh = "_done_fbatg_5", Uh = "_now_fbatg_5", Gh = "_item_fbatg_6", Yh = "_dot_fbatg_12", Vh = "_label_fbatg_19", Qh = "_opt_fbatg_21", Jh = "_sr_fbatg_22", st = {
  ol: Hh,
  li: Wh,
  done: Kh,
  now: Uh,
  item: Gh,
  dot: Yh,
  label: Vh,
  opt: Qh,
  sr: Jh
};
function Ok({ steps: e, current: t, onStepClick: a, className: r = "" }) {
  return /* @__PURE__ */ n.createElement("ol", { className: [st.ol, r].filter(Boolean).join(" "), "aria-label": `${e.length}단계 중 ${Math.min(t + 1, e.length)}단계` }, e.map((o, s) => {
    const l = s < t ? "done" : s === t ? "now" : "todo", c = /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("span", { className: st.dot, "aria-hidden": "true" }, l === "done" ? "✓" : s + 1), /* @__PURE__ */ n.createElement("span", { className: st.label }, o.label, o.optional && /* @__PURE__ */ n.createElement("span", { className: st.opt }, " (선택)"), l === "done" && /* @__PURE__ */ n.createElement("span", { className: st.sr }, " 완료"))), i = !!a && s <= t;
    return /* @__PURE__ */ n.createElement("li", { key: o.key, className: [st.li, st[l]].join(" "), "aria-current": l === "now" ? "step" : void 0 }, i ? /* @__PURE__ */ n.createElement("button", { type: "button", className: st.item, onClick: () => a(s, o) }, c) : /* @__PURE__ */ n.createElement("span", { className: st.item }, c));
  }));
}
const Zh = "_root_7y5bc_5", eg = "_block_7y5bc_6", tg = "_svg_7y5bc_7", ng = "_sm_7y5bc_8", ag = "_md_7y5bc_9", rg = "_lg_7y5bc_10", og = "_track_7y5bc_11", sg = "_bar_7y5bc_12", lg = "_spin_7y5bc_13", cg = "_txt_7y5bc_15", Et = {
  root: Zh,
  "axe-sp-in": "_axe-sp-in_7y5bc_1",
  block: eg,
  svg: tg,
  sm: ng,
  md: ag,
  lg: rg,
  track: og,
  bar: sg,
  spin: lg,
  "axe-sp-rot": "_axe-sp-rot_7y5bc_1",
  txt: cg,
  "axe-sp-blink": "_axe-sp-blink_7y5bc_1"
};
function Pk({ size: e = "md", value: t, label: a = "불러오는 중", delay: r = 300, block: o = !1, className: s = "" }) {
  const l = typeof t == "number", c = l ? Math.min(100, Math.max(0, t)) : 0, i = 15.9155;
  return /* @__PURE__ */ n.createElement(
    "span",
    {
      className: [Et.root, o ? Et.block : "", s].filter(Boolean).join(" "),
      style: { "--sp-delay": `${r}ms` },
      role: "status",
      "aria-live": "polite",
      "aria-busy": "true"
    },
    /* @__PURE__ */ n.createElement("svg", { className: [Et.svg, Et[e], l ? "" : Et.spin].filter(Boolean).join(" "), viewBox: "0 0 36 36", "aria-hidden": "true", focusable: "false" }, /* @__PURE__ */ n.createElement("circle", { className: Et.track, cx: "18", cy: "18", r: i, fill: "none" }), /* @__PURE__ */ n.createElement(
      "circle",
      {
        className: Et.bar,
        cx: "18",
        cy: "18",
        r: i,
        fill: "none",
        strokeDasharray: l ? `${c} ${100 - c}` : "25 75",
        transform: "rotate(-90 18 18)"
      }
    )),
    /* @__PURE__ */ n.createElement("span", { className: Et.txt }, a, l ? ` ${Math.round(c)}%` : "")
  );
}
const ig = "_group_vdqk6_1", ug = "_legend_vdqk6_2", mg = "_req_vdqk6_3", dg = "_opts_vdqk6_4", fg = "_inline_vdqk6_5", pg = "_all_vdqk6_6", _g = "_opt_vdqk6_4", yg = "_compact_vdqk6_11", bg = "_dis_vdqk6_13", Eg = "_radio_vdqk6_14", hg = "_check_vdqk6_14", gg = "_text_vdqk6_16", vg = "_hint_vdqk6_17", kg = "_err_vdqk6_18", wg = "_srOnly_vdqk6_20", me = {
  group: ig,
  legend: ug,
  req: mg,
  opts: dg,
  inline: fg,
  all: pg,
  opt: _g,
  compact: yg,
  dis: bg,
  radio: Eg,
  check: hg,
  text: gg,
  hint: vg,
  err: kg,
  srOnly: wg
};
function Yr({ legend: e, required: t, hidden: a }) {
  return /* @__PURE__ */ n.createElement("legend", { className: [me.legend, a ? me.srOnly : ""].filter(Boolean).join(" ") }, e, t && /* @__PURE__ */ n.createElement("span", { className: me.req }, " (필수)"));
}
function zk({ name: e, legend: t, options: a, value: r, onChange: o, required: s, disabled: l, error: c, inline: i = !1, className: m = "", legendHidden: u = !1 }) {
  const f = Qt("axe-rg-err");
  return /* @__PURE__ */ n.createElement(
    "fieldset",
    {
      className: [me.group, m].filter(Boolean).join(" "),
      disabled: l,
      "aria-describedby": c ? f : void 0,
      "aria-invalid": c ? !0 : void 0
    },
    /* @__PURE__ */ n.createElement(Yr, { legend: t, required: s, hidden: u }),
    /* @__PURE__ */ n.createElement("div", { className: [me.opts, i ? me.inline : ""].filter(Boolean).join(" "), role: "radiogroup" }, a.map((p) => /* @__PURE__ */ n.createElement("label", { key: p.value, className: [me.opt, p.disabled ? me.dis : ""].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement(
      "input",
      {
        type: "radio",
        className: me.radio,
        name: e,
        value: p.value,
        checked: r === p.value,
        disabled: p.disabled,
        required: s,
        onChange: () => o(p.value)
      }
    ), /* @__PURE__ */ n.createElement("span", { className: me.text }, p.label, p.hint && /* @__PURE__ */ n.createElement("span", { className: me.hint }, p.hint))))),
    c && /* @__PURE__ */ n.createElement("p", { id: f, className: me.err }, c)
  );
}
function ir({ checked: e, indeterminate: t = !1, onChange: a, disabled: r, children: o, className: s = "", compact: l = !1, title: c }) {
  return /* @__PURE__ */ n.createElement("label", { title: c, className: [me.opt, l ? me.compact : "", r ? me.dis : "", s].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement(
    "input",
    {
      type: "checkbox",
      className: me.check,
      checked: e,
      disabled: r,
      ref: (i) => {
        i && (i.indeterminate = t && !e);
      },
      onChange: (i) => a(i.target.checked)
    }
  ), o !== void 0 && /* @__PURE__ */ n.createElement("span", { className: me.text }, o));
}
function Xk({ legend: e, options: t, value: a, onChange: r, required: o, disabled: s, error: l, inline: c = !1, selectAll: i, className: m = "" }) {
  const u = Qt("axe-cg-err"), f = t.filter((d) => !d.disabled).map((d) => d.value), p = f.length > 0 && f.every((d) => a.includes(d)), _ = f.some((d) => a.includes(d)), y = (d, b) => r(b ? [...a, d] : a.filter((N) => N !== d));
  return /* @__PURE__ */ n.createElement(
    "fieldset",
    {
      className: [me.group, m].filter(Boolean).join(" "),
      disabled: s,
      "aria-describedby": l ? u : void 0,
      "aria-invalid": l ? !0 : void 0
    },
    /* @__PURE__ */ n.createElement(Yr, { legend: e, required: o }),
    i && /* @__PURE__ */ n.createElement("div", { className: me.all }, /* @__PURE__ */ n.createElement(
      ir,
      {
        checked: p,
        indeterminate: _ && !p,
        onChange: (d) => r(d ? Array.from(/* @__PURE__ */ new Set([...a, ...f])) : a.filter((b) => !f.includes(b)))
      },
      i
    )),
    /* @__PURE__ */ n.createElement("div", { className: [me.opts, c ? me.inline : ""].filter(Boolean).join(" ") }, t.map((d) => /* @__PURE__ */ n.createElement(ir, { key: d.value, checked: a.includes(d.value), disabled: d.disabled, onChange: (b) => y(d.value, b) }, d.label, d.hint && /* @__PURE__ */ n.createElement("span", { className: me.hint }, d.hint)))),
    l && /* @__PURE__ */ n.createElement("p", { id: u, className: me.err }, l)
  );
}
const Ng = "_list_13vw7_1", $g = "_tag_13vw7_2", xg = "_main_13vw7_3", Dg = "_x_13vw7_6", Ag = "_t_muted_13vw7_10", Cg = "_t_accent_13vw7_11", Sg = "_t_ok_13vw7_12", Mg = "_t_warn_13vw7_13", qg = "_t_danger_13vw7_14", Tg = "_sel_13vw7_16", St = {
  list: Ng,
  tag: $g,
  main: xg,
  x: Dg,
  t_muted: Ag,
  t_accent: Cg,
  t_ok: Sg,
  t_warn: Mg,
  t_danger: qg,
  sel: Tg
};
function Fk({ children: e, tone: t = "muted", selected: a, onClick: r, onRemove: o, removeLabel: s, disabled: l, className: c = "" }) {
  const i = [St.tag, St[`t_${t}`], a ? St.sel : "", c].filter(Boolean).join(" "), m = s != null ? s : typeof e == "string" ? `${e} 삭제` : "태그 삭제";
  return /* @__PURE__ */ n.createElement("span", { className: i }, r ? /* @__PURE__ */ n.createElement("button", { type: "button", className: St.main, onClick: r, disabled: l, "aria-pressed": a }, a && /* @__PURE__ */ n.createElement("span", { "aria-hidden": "true" }, "✓ "), e) : /* @__PURE__ */ n.createElement("span", { className: St.main }, e), o && /* @__PURE__ */ n.createElement("button", { type: "button", className: St.x, onClick: o, disabled: l, "aria-label": m }, "✕"));
}
function Hk({ label: e, children: t, className: a = "" }) {
  return /* @__PURE__ */ n.createElement("ul", { className: [St.list, a].filter(Boolean).join(" "), "aria-label": e }, (Array.isArray(t) ? t : [t]).filter(Boolean).map((r, o) => /* @__PURE__ */ n.createElement("li", { key: o }, r)));
}
const Bg = "_acc_1lmty_1", Lg = "_item_1lmty_2", jg = "_h_1lmty_3", Ig = "_btn_1lmty_4", Rg = "_title_1lmty_8", Og = "_meta_1lmty_9", Pg = "_chev_1lmty_10", zg = "_open_1lmty_11", Xg = "_body_1lmty_12", lt = {
  acc: Bg,
  item: Lg,
  h: jg,
  btn: Ig,
  title: Rg,
  meta: Og,
  chev: Pg,
  open: zg,
  body: Xg
};
function Wk({ items: e, single: t = !1, defaultOpen: a = [], openKeys: r, onOpenChange: o, headingLevel: s = 3, className: l = "" }) {
  const [c, i] = A(a), m = r != null ? r : c, u = Qt("axe-acc"), f = `h${s}`, p = (_) => {
    const y = m.includes(_) ? m.filter((d) => d !== _) : t ? [_] : [...m, _];
    r === void 0 && i(y), o == null || o(y);
  };
  return /* @__PURE__ */ n.createElement("div", { className: [lt.acc, l].filter(Boolean).join(" ") }, e.map((_) => {
    const y = m.includes(_.key), d = `${u}-b-${_.key}`, b = `${u}-p-${_.key}`;
    return /* @__PURE__ */ n.createElement("div", { key: _.key, className: [lt.item, y ? lt.open : ""].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement(f, { className: lt.h }, /* @__PURE__ */ n.createElement(
      "button",
      {
        type: "button",
        id: d,
        className: lt.btn,
        "aria-expanded": y,
        "aria-controls": b,
        disabled: _.disabled,
        onClick: () => p(_.key)
      },
      /* @__PURE__ */ n.createElement("span", { className: lt.title }, _.title),
      _.meta && /* @__PURE__ */ n.createElement("span", { className: lt.meta }, _.meta),
      /* @__PURE__ */ n.createElement("span", { className: lt.chev, "aria-hidden": "true" }, "▾")
    )), /* @__PURE__ */ n.createElement("div", { id: b, role: "region", "aria-labelledby": d, hidden: !y, className: lt.body }, _.content));
  }));
}
const Fg = "_stack_1u83j_2", Hg = "_toast_1u83j_3", Wg = "_t_danger_1u83j_9", Kg = "_ico_1u83j_10", Ug = "_t_ok_1u83j_11", Gg = "_msg_1u83j_12", Yg = "_act_1u83j_13", Vg = "_x_1u83j_15", Mt = {
  stack: Fg,
  toast: Hg,
  "axe-toast-in": "_axe-toast-in_1u83j_1",
  t_danger: Wg,
  ico: Kg,
  t_ok: Ug,
  msg: Gg,
  act: Yg,
  x: Vg
}, Vr = Bn(null);
let Qg = 0;
function Kk() {
  const e = Tn(Vr);
  if (!e) throw new Error("useAXErpToast 는 AXErpToastProvider 안에서만 쓴다");
  return e;
}
function Jg({ item: e, onClose: t }) {
  var l, c;
  const [a, r] = A(!1), o = (l = e.duration) != null ? l : e.action ? 8e3 : 4e3;
  U(() => {
    if (a || o === 0) return;
    const i = window.setTimeout(t, o);
    return () => window.clearTimeout(i);
  }, [a, o, t, e.message]);
  const s = (c = e.tone) != null ? c : "info";
  return /* @__PURE__ */ n.createElement(
    "div",
    {
      className: [Mt.toast, Mt[`t_${s}`]].join(" "),
      role: s === "danger" ? "alert" : void 0,
      onMouseEnter: () => r(!0),
      onMouseLeave: () => r(!1),
      onFocus: () => r(!0),
      onBlur: () => r(!1)
    },
    /* @__PURE__ */ n.createElement("span", { className: Mt.ico, "aria-hidden": "true" }, s === "ok" ? "✓" : s === "danger" ? "▲" : "ⓘ"),
    /* @__PURE__ */ n.createElement("span", { className: Mt.msg }, e.message),
    e.action && /* @__PURE__ */ n.createElement("button", { type: "button", className: Mt.act, onClick: () => {
      e.action.onAction(), t();
    } }, e.action.label),
    /* @__PURE__ */ n.createElement("button", { type: "button", className: Mt.x, onClick: t, "aria-label": "알림 닫기" }, "✕")
  );
}
function Uk({ children: e }) {
  const [t, a] = A([]), r = B(t);
  r.current = t;
  const o = re((c) => a((i) => i.filter((m) => m.id !== c)), []), s = re((c) => {
    const i = typeof c == "string" ? { message: c } : c, m = r.current.find((f) => f.message === i.message);
    if (m)
      return a((f) => f.map((p) => p.id === m.id ? { ...p, ...i } : p)), m.id;
    const u = ++Qg;
    return a((f) => [...f, { ...i, id: u }].slice(-3)), u;
  }, []), l = ke(() => ({ toast: s, dismiss: o }), [s, o]);
  return /* @__PURE__ */ n.createElement(Vr.Provider, { value: l }, e, /* @__PURE__ */ n.createElement("div", { className: Mt.stack, role: "status", "aria-live": "polite", "aria-atomic": "false" }, t.map((c) => /* @__PURE__ */ n.createElement(Jg, { key: c.id, item: c, onClose: () => o(c.id) }))));
}
const Zg = [
  {
    title: "공통",
    items: [
      { keys: ["?"], text: "단축키 도움말 열기 (입력 칸 밖에서)" },
      { keys: ["Tab", "Shift+Tab"], text: "다음·이전 입력 칸 / 버튼으로 이동" },
      { keys: ["Esc"], text: "열린 달력·메뉴·대화상자 닫기, 입력 중이던 값 취소" },
      { keys: ["Ctrl+Enter"], text: "저장 (저장 버튼 옆에 표기된 화면)" }
    ]
  },
  {
    title: "날짜 입력 칸",
    items: [
      { keys: ["숫자만"], text: "20260930 · 260930 · 0930 처럼 구분 기호 없이 입력" },
      { keys: ["↑", "↓"], text: "하루 뒤·앞 (월 입력은 한 달)" },
      { keys: ["PageUp", "PageDown"], text: "한 달 앞·뒤 (월 입력은 한 해)" },
      { keys: ["T"], text: "오늘" },
      { keys: ["F2", "F4", "Alt+↓"], text: "달력 열기" }
    ]
  },
  {
    title: "코드 입력 칸",
    items: [
      { keys: ["코드·명칭 입력"], text: "입력하는 동안 후보 표시" },
      { keys: ["↑", "↓"], text: "후보 선택" },
      { keys: ["Enter"], text: "선택한 후보 확정" },
      { keys: ["F2"], text: "전체 검색 창 열기" }
    ]
  },
  {
    title: "표 (행·칸 이동)",
    items: [
      { keys: ["←", "→", "↑", "↓"], text: "칸 이동" },
      { keys: ["Home", "End"], text: "줄의 처음·끝 칸" },
      { keys: ["Ctrl+Home", "Ctrl+End"], text: "표의 처음·끝 칸" },
      { keys: ["Enter", "Space"], text: "행 열기 (행 클릭이 되는 표)" }
    ]
  },
  {
    title: "달력 (달력에 포커스가 있을 때)",
    items: [
      { keys: ["T"], text: "오늘로" },
      { keys: ["N", "PageDown"], text: "다음 기간" },
      { keys: ["P", "PageUp"], text: "이전 기간" },
      { keys: ["M", "W", "D", "A"], text: "월 · 주 · 일 · 목록 보기" },
      { keys: ["C"], text: "일정 추가" }
    ]
  },
  {
    title: "간트 · 칸반 (막대·카드에 포커스)",
    items: [
      { keys: ["←", "→"], text: "간트: 막대 옮기기" },
      { keys: ["Shift+←", "Shift+→"], text: "간트: 끝 날짜 조절" },
      { keys: ["Alt+←", "Alt+→"], text: "간트: 시작 날짜 조절 / 칸반: 옆 열로 옮기기" },
      { keys: ["Enter"], text: "열기" }
    ]
  },
  {
    title: "메뉴",
    items: [
      { keys: ["↓"], text: "메뉴 열기 · 다음 항목" },
      { keys: ["↑", "Home", "End"], text: "이전 · 처음 · 마지막 항목" },
      { keys: ["Esc"], text: "닫고 버튼으로 돌아가기" }
    ]
  }
];
function ev(e, t, a) {
  return a || t.ctrl || t.alt || t.meta ? !1 : e === "?";
}
const tv = "_grid_yplhe_1", nv = "_group_yplhe_2", av = "_h_yplhe_3", rv = "_list_yplhe_4", ov = "_row_yplhe_5", sv = "_keys_yplhe_6", lv = "_text_yplhe_7", cv = "_or_yplhe_8", iv = "_kbd_yplhe_9", ct = {
  grid: tv,
  group: nv,
  h: av,
  list: rv,
  row: ov,
  keys: sv,
  text: lv,
  or: cv,
  kbd: iv
};
function uv({ onClose: e, extra: t }) {
  const a = [...t != null ? t : [], ...Zg];
  return /* @__PURE__ */ n.createElement(Pn, { title: "단축키", onClose: e, closeOnEsc: !0, confirmDiscard: !1, wide: !0 }, /* @__PURE__ */ n.createElement("div", { className: ct.grid }, a.map((r) => /* @__PURE__ */ n.createElement("section", { key: r.title, className: ct.group }, /* @__PURE__ */ n.createElement("h3", { className: ct.h }, r.title), /* @__PURE__ */ n.createElement("dl", { className: ct.list }, r.items.map((o, s) => /* @__PURE__ */ n.createElement("div", { key: s, className: ct.row }, /* @__PURE__ */ n.createElement("dt", { className: ct.keys }, o.keys.map((l, c) => /* @__PURE__ */ n.createElement("span", { key: l }, c > 0 && /* @__PURE__ */ n.createElement("span", { className: ct.or }, " 또는 "), /* @__PURE__ */ n.createElement("kbd", { className: ct.kbd }, l)))), /* @__PURE__ */ n.createElement("dd", { className: ct.text }, o.text))))))));
}
function mv(e) {
  const t = e;
  return !t || typeof t.closest != "function" ? !1 : !!t.closest('input, textarea, select, [contenteditable="true"], [role="combobox"], [role="textbox"]');
}
function Gk(e = {}) {
  const { enabled: t = !0, extra: a } = e, [r, o] = A(!1);
  return U(() => {
    if (!t) return;
    const s = (l) => {
      ev(l.key, { ctrl: l.ctrlKey, alt: l.altKey, meta: l.metaKey }, mv(l.target)) && (document.querySelector('[role="dialog"][aria-modal="true"]') || (l.preventDefault(), o(!0)));
    };
    return document.addEventListener("keydown", s), () => document.removeEventListener("keydown", s);
  }, [t]), { open: () => o(!0), dialog: r ? /* @__PURE__ */ n.createElement(uv, { extra: a, onClose: () => o(!1) }) : null };
}
const ur = 30, dv = BigInt(10);
function Yt(e) {
  let t = BigInt(1);
  for (let a = 0; a < e; a += 1) t = t * dv;
  return t;
}
function ut(e, t = 0) {
  return { u: e, s: t };
}
const Qr = ut(BigInt(0));
function Jr(e, t) {
  if (e.s === t.s) return [e.u, t.u, e.s];
  const a = Math.max(e.s, t.s);
  return [e.u * Yt(a - e.s), t.u * Yt(a - t.s), a];
}
function _n(e, t) {
  const [a, r, o] = Jr(e, t);
  return ut(a + r, o);
}
function va(e, t) {
  const [a, r, o] = Jr(e, t);
  return ut(a - r, o);
}
function Ze(e, t) {
  return ut(e.u * t.u, e.s + t.s);
}
function jt(e, t) {
  if (t.u === BigInt(0)) return null;
  const a = e.u * Yt(t.s + ur), r = t.u * Yt(e.s);
  return ut(a / r, ur);
}
function Zr(e) {
  return ut(-e.u, e.s);
}
function mt(e, t, a) {
  if (t >= e.s)
    return ut(e.u * Yt(t - e.s), t);
  const r = Yt(e.s - t), o = e.u < BigInt(0), s = o ? -e.u : e.u, l = s / r, c = s % r;
  let i;
  return c === BigInt(0) || a === "down" ? i = l : a === "up" ? i = l + BigInt(1) : i = c * BigInt(2) >= r ? l + BigInt(1) : l, ut(o ? -i : i, t);
}
function be(e) {
  const t = e.trim().replace(/,/g, "");
  if (!/^[+-]?(\d+(\.\d*)?|\.\d+)$/.test(t)) return null;
  const a = t.startsWith("-"), r = t.replace(/^[+-]/, ""), o = r.indexOf("."), s = o < 0 ? r : r.slice(0, o) + r.slice(o + 1), l = o < 0 ? 0 : r.length - o - 1, c = BigInt(s === "" ? "0" : s);
  return ut(a ? -c : c, l);
}
function ka(e) {
  var a;
  const t = be(String(e));
  return t || ((a = be(e.toFixed(20))) != null ? a : Qr);
}
function Ke(e, t = e.s, a = !1) {
  const r = mt(e, Math.max(t, 0), "half"), o = r.u < BigInt(0), s = (o ? -r.u : r.u).toString().padStart(t + 1, "0"), l = s.length - t;
  let c = s.slice(0, l);
  const i = s.slice(l);
  return a && (c = c.replace(/\B(?=(\d{3})+(?!\d))/g, ",")), (o ? "-" : "") + c + (t > 0 ? "." + i : "");
}
function ua(e) {
  const t = /^(\d{4})-(\d{2})-(\d{2})$/.exec(e.trim());
  if (!t) return null;
  const a = Number(t[1]), r = Number(t[2]), o = Number(t[3]);
  return r < 1 || r > 12 || o < 1 || o > Le(a, r) ? null : { y: a, m: r, d: o };
}
function Wt({ y: e, m: t, d: a }) {
  const r = Math.floor((14 - t) / 12), o = e + 4800 - r, s = t + 12 * r - 3;
  return a + Math.floor((153 * s + 2) / 5) + 365 * o + Math.floor(o / 4) - Math.floor(o / 100) + Math.floor(o / 400) - 32045;
}
function eo(e, t) {
  const a = Wt(e) + t + 32044, r = Math.floor((4 * a + 3) / 146097), o = a - Math.floor(146097 * r / 4), s = Math.floor((4 * o + 3) / 1461), l = o - Math.floor(1461 * s / 4), c = Math.floor((5 * l + 2) / 153);
  return {
    d: l - Math.floor((153 * c + 2) / 5) + 1,
    m: c + 3 - 12 * Math.floor(c / 10),
    y: 100 * r + s - 4800 + Math.floor(c / 10)
  };
}
function to(e, t, a = "exclude-first") {
  const r = Wt(e) > Wt(t), o = r ? t : e, s = r ? e : t, l = a === "include-first", c = Wt(s) - Wt(o) + (l ? 1 : 0), i = l ? eo(s, 1) : s;
  let m = i.y - o.y, u = i.m - o.m, f = i.d - o.d;
  if (f < 0) {
    u -= 1;
    const p = i.m === 1 ? 12 : i.m - 1, _ = i.m === 1 ? i.y - 1 : i.y;
    f += Le(_, p);
  }
  return u < 0 && (m -= 1, u += 12), { days: c, y: m, m: u, d: f, swapped: r };
}
function qn(e, t) {
  return eo(e, t);
}
function mr(e, t) {
  const a = e.y * 12 + (e.m - 1) + t, r = Math.floor(a / 12), o = a % 12 + 1;
  return { y: r, m: o, d: Math.min(e.d, Le(r, o)) };
}
const fv = ["월", "화", "수", "목", "금", "토", "일"];
function ma(e) {
  return fv[Wt(e) % 7];
}
function ze(e) {
  return `${e.y}-${String(e.m).padStart(2, "0")}-${String(e.d).padStart(2, "0")}`;
}
const rn = [
  { code: "KRW", label: "원", per: 1, krw: "1" },
  { code: "JPY", label: "엔", per: 100, krw: "941.20" },
  { code: "USD", label: "달러", per: 1, krw: "1386.50" },
  { code: "EUR", label: "유로", per: 1, krw: "1501.30" },
  { code: "CNY", label: "위안", per: 1, krw: "190.40" },
  { code: "GBP", label: "파운드", per: 1, krw: "1752.80" }
], ea = {
  원: "KRW",
  엔: "JPY",
  달러: "USD",
  불: "USD",
  유로: "EUR",
  위안: "CNY",
  파운드: "GBP"
};
function dr(e) {
  var t;
  return (t = ea[e]) != null ? t : e in ea ? ea[e] : null;
}
function da(e, t) {
  return e.find((a) => a.code === t);
}
function no(e) {
  return e.code === "KRW" ? "KRW 기준" : `${e.code} ${e.per} = ${e.krw}원`;
}
function ao(e, t, a, r) {
  const o = da(e, a), s = da(e, r);
  if (!o || !s) return null;
  const l = be(o.krw), c = be(s.krw), i = be(String(o.per)), m = be(String(s.per));
  if (!l || !c || !i || !m) return null;
  const u = jt(Ze(t, l), i);
  if (!u) return null;
  const f = jt(Ze(u, m), c);
  return f ? {
    value: mt(f, 2, "half"),
    notice: `${no(o)} · 참고용 환율`
  } : null;
}
function pv(e, t) {
  let a = null;
  for (const o of e)
    if (o.value) {
      if (a === null) {
        a = o.sign === "-" ? Zr(o.value) : o.value;
        continue;
      }
      switch (o.sign) {
        case "+":
          a = _n(a, o.value);
          break;
        case "-":
          a = va(a, o.value);
          break;
        case "*":
          a = Ze(a, o.value);
          break;
        default: {
          const s = jt(a, o.value);
          if (!s) return { ok: !1, error: "divide-by-zero" };
          a = s;
          break;
        }
      }
    }
  const r = a != null ? a : Qr;
  return { ok: !0, value: t ? mt(r, t.digits, t.mode) : r };
}
const fr = [
  { key: "+", label: "+", hot: "A" },
  { key: "-", label: "−", hot: "S" },
  { key: "*", label: "×", hot: "D" },
  { key: "/", label: "÷", hot: "F" }
];
function ln() {
  return { sign: "+", text: "" };
}
function _v(e) {
  const t = e.replace(/[^\d.-]/g, ""), a = t.startsWith("-"), r = t.replace(/-/g, ""), o = r.indexOf("."), s = o < 0 ? r : r.slice(0, o), l = o < 0 ? "" : "." + r.slice(o + 1).replace(/\./g, "");
  return (a ? "-" : "") + s.replace(/\B(?=(\d{3})+(?!\d))/g, ",") + l;
}
function yv(e) {
  return e.map((t) => ({ sign: t.sign, value: be(t.text) }));
}
function bv(e) {
  const { lines: t, onLines: a, active: r, onActive: o, digits: s, onDigits: l, mode: c, onMode: i } = e, m = B([]), u = Math.min(r, t.length - 1);
  U(() => {
    var g;
    (g = m.current[u]) == null || g.focus();
  }, [u, t.length]);
  const f = pv(yv(t), { digits: s, mode: c }), p = f.ok ? Ke(f.value, s, !0) : "0으로 나눌 수 없음", _ = (g, x) => {
    a(t.map((h, w) => w === g ? { ...h, ...x } : h));
  }, y = (g = t.length, x = "") => {
    const h = [...t];
    h.splice(g, 0, { ...ln(), text: x }), a(h), o(g);
  }, d = (g) => {
    if (t.length === 1) {
      a([ln()]);
      return;
    }
    a(t.filter((x, h) => h !== g)), o(Math.max(0, g - 1));
  }, b = () => {
    f.ok && y(t.length, Ke(f.value, s, !0));
  }, N = (g, x) => {
    const h = g.key, w = Ev(h);
    if (w && !(h === "-" && t[x].text === "")) {
      g.preventDefault(), _(x, { sign: w });
      return;
    }
    if (h === "v" || h === "V") {
      g.preventDefault(), b();
      return;
    }
    h === "Enter" ? (g.preventDefault(), x === t.length - 1 ? y() : o(x + 1)) : h === "ArrowDown" ? (g.preventDefault(), o(Math.min(x + 1, t.length - 1))) : h === "ArrowUp" ? (g.preventDefault(), o(Math.max(x - 1, 0))) : h === "Insert" ? (g.preventDefault(), y(x + 1)) : h === "Delete" && t[x].text === "" ? (g.preventDefault(), d(x)) : h === "F4" && (g.preventDefault(), $());
  }, $ = () => {
    a([ln()]), o(0);
  };
  return /* @__PURE__ */ n.createElement("div", { className: "bical-general" }, /* @__PURE__ */ n.createElement("div", { className: "bical-side" }, /* @__PURE__ */ n.createElement("div", { className: "bical-keys" }, /* @__PURE__ */ n.createElement("button", { type: "button", className: "bical-key", onClick: () => y(u + 1) }, "행 추가 (Ins)"), /* @__PURE__ */ n.createElement("button", { type: "button", className: "bical-key", onClick: () => d(u) }, "행 삭제 (Del)"), /* @__PURE__ */ n.createElement("button", { type: "button", className: "bical-key", onClick: b }, "현재금액추가 (V)"), /* @__PURE__ */ n.createElement("button", { type: "button", className: "bical-key", onClick: $ }, "초기화 (F4)")), /* @__PURE__ */ n.createElement("div", { className: "bical-sub" }, "부호"), /* @__PURE__ */ n.createElement("div", { className: "bical-keys" }, fr.map((g) => {
    var x;
    return /* @__PURE__ */ n.createElement(
      "button",
      {
        key: g.key,
        type: "button",
        className: "bical-key",
        "aria-pressed": ((x = t[u]) == null ? void 0 : x.sign) === g.key,
        onClick: () => _(u, { sign: g.key })
      },
      g.label,
      " (",
      g.hot,
      ")"
    );
  })), /* @__PURE__ */ n.createElement("div", { className: "bical-sub" }, "결과값 자리수"), /* @__PURE__ */ n.createElement("select", { "aria-label": "결과값 자리수", className: "bical-select", value: s, onChange: (g) => l(Number(g.target.value)) }, [0, 1, 2, 3, 4].map((g) => /* @__PURE__ */ n.createElement("option", { key: g, value: g }, g))), /* @__PURE__ */ n.createElement("div", { className: "bical-sub" }, "표기방법"), /* @__PURE__ */ n.createElement("select", { "aria-label": "표기방법", className: "bical-select", value: c, onChange: (g) => i(g.target.value) }, /* @__PURE__ */ n.createElement("option", { value: "half" }, "반올림"), /* @__PURE__ */ n.createElement("option", { value: "up" }, "올림"), /* @__PURE__ */ n.createElement("option", { value: "down" }, "버림"))), /* @__PURE__ */ n.createElement("div", { style: { flex: 1 } }, /* @__PURE__ */ n.createElement("div", { className: "bical-grid" }, t.map((g, x) => {
    var h;
    return /* @__PURE__ */ n.createElement("div", { key: x, className: `bical-line${x === u ? " bical-line--active" : ""}` }, /* @__PURE__ */ n.createElement("span", { className: "bical-caret" }, x === u ? "❯" : ""), /* @__PURE__ */ n.createElement("span", { className: "bical-sign" }, (h = fr.find((w) => w.key === g.sign)) == null ? void 0 : h.label), /* @__PURE__ */ n.createElement(
      "input",
      {
        ref: (w) => {
          m.current[x] = w;
        },
        value: g.text,
        inputMode: "decimal",
        "aria-label": `${x + 1}번째 금액`,
        onFocus: () => o(x),
        onChange: (w) => _(x, { text: _v(w.target.value) }),
        onKeyDown: (w) => N(w, x)
      }
    ));
  })), /* @__PURE__ */ n.createElement("div", { className: `bical-result${f.ok ? "" : " bical-error"}` }, /* @__PURE__ */ n.createElement("div", { className: "bical-explain" }, "결과값 · 좌→우 순차 계산(연산자 우선순위 없음)"), /* @__PURE__ */ n.createElement("div", { className: "bical-value" }, p))));
}
function Ev(e) {
  const t = e.toLowerCase();
  return t === "a" || e === "+" ? "+" : t === "s" || e === "-" ? "-" : t === "d" || e === "*" ? "*" : t === "f" || e === "/" ? "/" : null;
}
function hv(e) {
  const t = [];
  let a = 0;
  for (; a < e.length; ) {
    const r = e[a];
    if (r === " " || r === "	" || r === `
`)
      a += 1;
    else if (r >= "0" && r <= "9" || r === "." || r === ",") {
      let o = a;
      for (; o < e.length && (e[o] >= "0" && e[o] <= "9" || e[o] === "." || e[o] === ","); ) o += 1;
      const s = be(e.slice(a, o));
      if (!s) return null;
      t.push({ t: "num", v: s }), a = o;
    } else if (r === "+" || r === "-" || r === "*" || r === "/")
      t.push({ t: "op", v: r }), a += 1;
    else if (r === "(")
      t.push({ t: "(" }), a += 1;
    else if (r === ")")
      t.push({ t: ")" }), a += 1;
    else
      return null;
  }
  return t;
}
class gv {
  constructor(t) {
    this.tokens = t, this.at = 0;
  }
  parse() {
    const t = this.expr();
    return t.ok && this.at !== this.tokens.length ? { ok: !1, error: "syntax" } : t;
  }
  peek() {
    return this.tokens[this.at];
  }
  expr() {
    let t = this.term();
    if (!t.ok) return t;
    for (; ; ) {
      const a = this.peek();
      if (!a || a.t !== "op" || a.v !== "+" && a.v !== "-") return t;
      this.at += 1;
      const r = this.term();
      if (!r.ok) return r;
      t = { ok: !0, value: a.v === "+" ? _n(t.value, r.value) : va(t.value, r.value) };
    }
  }
  term() {
    let t = this.unary();
    if (!t.ok) return t;
    for (; ; ) {
      const a = this.peek();
      if (!a || a.t !== "op" || a.v !== "*" && a.v !== "/") return t;
      this.at += 1;
      const r = this.unary();
      if (!r.ok) return r;
      if (a.v === "*")
        t = { ok: !0, value: Ze(t.value, r.value) };
      else {
        const o = jt(t.value, r.value);
        if (!o) return { ok: !1, error: "divide-by-zero" };
        t = { ok: !0, value: o };
      }
    }
  }
  unary() {
    const t = this.peek();
    if (t && t.t === "op" && (t.v === "+" || t.v === "-")) {
      this.at += 1;
      const a = this.unary();
      return a.ok ? { ok: !0, value: t.v === "-" ? Zr(a.value) : a.value } : a;
    }
    return this.primary();
  }
  primary() {
    const t = this.peek();
    if (!t) return { ok: !1, error: "syntax" };
    if (t.t === "num")
      return this.at += 1, { ok: !0, value: t.v };
    if (t.t === "(") {
      this.at += 1;
      const a = this.expr();
      if (!a.ok) return a;
      const r = this.peek();
      return !r || r.t !== ")" ? { ok: !1, error: "syntax" } : (this.at += 1, a);
    }
    return { ok: !1, error: "syntax" };
  }
}
function vv(e) {
  const t = hv(e);
  return !t || t.length === 0 ? { ok: !1, error: "syntax" } : new gv(t).parse();
}
const cn = [
  "산술식 — 1,200만 + 350만 × 2",
  "비율 — 3,000,000의 15%",
  "기간 — 2026-01-01부터 2026-03-31까지 며칠",
  "날짜 가감 — 2026-07-17부터 90일 후",
  "환율 — 150만엔을 원화로 (참고용 환율)"
], kv = /(\d{4})\s*[.\-/년]\s*(\d{1,2})\s*[.\-/월]\s*(\d{1,2})\s*일?/g;
function wv(e, t) {
  return e.replace(/오늘/g, ze(t)).replace(/내일/g, ze(qn(t, 1))).replace(/어제/g, ze(qn(t, -1)));
}
function Nv(e) {
  const t = [];
  for (const a of e.matchAll(kv)) {
    const r = ua(`${a[1]}-${a[2].padStart(2, "0")}-${a[3].padStart(2, "0")}`);
    r && t.push(r);
  }
  return t;
}
const $v = /부터|까지|에서|일수|며칠|기간|차이|~/;
function xv(e, t) {
  if (t.length < 2 || !$v.test(e)) return null;
  const a = /초일\s*산입|양편넣기/.test(e), r = to(t[0], t[1], a ? "include-first" : "exclude-first"), o = a ? "초일산입 말일산입" : "초일불산입 말일산입";
  return {
    ok: !0,
    explain: `${ze(t[0])} ~ ${ze(t[1])} 기간(${o})` + (r.swapped ? " · 역순 입력" : ""),
    value: `${r.days}일 (${r.y}년 ${r.m}개월 ${r.d}일)`
  };
}
const Dv = /(\d+)\s*(일|주|개월|달|년)\s*(후|뒤|이후|전|이전)/;
function Av(e, t) {
  if (t.length !== 1) return null;
  const a = Dv.exec(e);
  if (!a) return null;
  const r = Number(a[1]), o = a[3] === "전" || a[3] === "이전", s = o ? -r : r, l = t[0];
  let c;
  return a[2] === "일" ? c = qn(l, s) : a[2] === "주" ? c = qn(l, s * 7) : a[2] === "년" ? c = mr(l, s * 12) : c = mr(l, s), {
    ok: !0,
    explain: `${ze(l)} 에서 ${r}${a[2]} ${o ? "전" : "후"}`,
    value: `${ze(c)} (${ma(c)})`
  };
}
function Cv(e, t) {
  if (t.length === 0) return null;
  const a = /([\d,]+(?:\.\d+)?)\s*(억|천만|백만|십만|만|천)?\s*(엔|달러|불|유로|위안|파운드|원)/.exec(e);
  if (!a) return null;
  const r = a[2] ? ro(a[2]) : null, o = be(a[1]);
  if (!o) return null;
  const s = r ? Ze(o, r) : o, l = dr(a[3]);
  if (!l) return null;
  const i = l !== "KRW" ? "KRW" : dr(Sv(e));
  if (!i || i === l) return null;
  const m = ao(t, s, l, i);
  return m ? {
    ok: !0,
    explain: `${Ke(s, s.s, !0)} ${l} → ${i} · ${m.notice}`,
    value: `${Ke(m.value, 2, !0)} ${i}`
  } : null;
}
function Sv(e) {
  const t = /(?:을|를|으로|로)\s*(엔|달러|불|유로|위안|파운드|원)/.exec(e);
  return t ? t[1] : "원";
}
const Mv = {
  억: "100000000",
  천만: "10000000",
  백만: "1000000",
  십만: "100000",
  만: "10000",
  천: "1000",
  백: "100"
};
function ro(e) {
  var t;
  return (t = be(Mv[e])) != null ? t : ka(1);
}
const qv = /((?:[\d,]+(?:\.\d+)?\s*(?:억|천만|백만|십만|만|천|백)\s*)+(?:[\d,]+(?:\.\d+)?)?)/g, Tv = /([\d,]+(?:\.\d+)?)\s*(억|천만|백만|십만|만|천|백)?/g;
function Bv(e) {
  return e.replace(qv, (t) => {
    let a = be("0"), r = !1;
    for (const o of t.matchAll(Tv)) {
      const s = be(o[1]);
      s && (r = !0, a = _n(a, o[2] ? Ze(s, ro(o[2])) : s));
    }
    return r ? Ke(a, a.s) : t;
  });
}
const Lv = /원화|원|엔|씩|개월|개|명|건/g;
function jv(e) {
  return Bv(e).replace(/(\d),(?=\d)/g, "$1").replace(/[×xX]/g, "*").replace(/÷/g, "/").replace(/더하기|플러스/g, "+").replace(/빼기|마이너스/g, "-").replace(/곱하기/g, "*").replace(/나누기/g, "/").replace(Lv, "").replace(/([\d.]+)\s*의\s*([\d.]+)\s*%/g, "($1*($2/100))").replace(/([\d.]+)\s*([+-])\s*([\d.]+)\s*%/g, "(($1)*(1$2$3/100))").trim();
}
const Iv = /[+＋]?\s*(부가세|소비세|消費税)\s*(?:([\d.]+)\s*%)?\s*(가산|포함|税込|税抜)?\s*$/;
function Rv(e, t, a) {
  const r = be("1"), o = Ke(Ze(t, ka(100)), 0);
  if (a === "add")
    return {
      value: mt(Ze(e, _n(r, t)), 0, "half"),
      explain: `消費税 ${o}% 가산(税抜 기준)`
    };
  const s = jt(Ze(e, t), _n(r, t));
  return {
    value: s ? mt(s, 0, "down") : e,
    explain: `消費税 ${o}% 역산(税込 기준 · 1円 미만 切捨て)`
  };
}
function Ov(e, t) {
  var i;
  const a = e.trim();
  if (!a) return { ok: !1, supported: cn };
  const r = wv(a, t.today), o = Nv(r), s = xv(r, o);
  if (s) return s;
  const l = Av(r, o);
  if (l) return l;
  const c = Cv(r, (i = t.rates) != null ? i : []);
  return c || Pv(r, t);
}
function Pv(e, t) {
  var m, u;
  const a = Iv.exec(e), r = a ? e.slice(0, a.index) : e, o = jv(r);
  if (!o) return { ok: !1, supported: cn };
  const s = vv(o);
  if (!s.ok)
    return { ok: !1, supported: cn };
  if (!a)
    return { ok: !0, explain: o, value: pr(s.value), expr: o };
  const l = (u = (m = zv(a[2])) != null ? m : t.taxRate) != null ? u : null;
  if (!l)
    return {
      ok: !1,
      supported: ["소비세율을 아직 받지 못했습니다 — 세제개정 기준값을 불러오면 계산합니다", ...cn]
    };
  const c = a[3] === "가산" || a[3] === "税抜" ? "add" : "extract", i = Rv(s.value, l, c);
  return {
    ok: !0,
    explain: `${o} · ${i.explain}`,
    value: pr(i.value),
    expr: o
  };
}
function zv(e) {
  var a;
  if (!e) return null;
  const t = be(e);
  return t && (a = jt(t, ka(100))) != null ? a : null;
}
function pr(e) {
  const t = mt(e, 2, "half"), a = mt(t, 0, "down");
  return va(t, a).u === BigInt(0) ? Ke(t, 0, !0) : Ke(t, 2, !0);
}
const We = {
  area: {
    label: "넓이",
    base: "㎡",
    units: [
      { key: "m2", label: "㎡", factor: "1" },
      { key: "are", label: "아르", factor: "100" },
      { key: "ha", label: "헥타르", factor: "10000" },
      { key: "km2", label: "㎢", factor: "1000000" },
      { key: "pyeong", label: "평", factor: "3.305785" },
      { key: "ft2", label: "ft²", factor: "0.09290304" },
      { key: "yd2", label: "yd²", factor: "0.83612736" },
      { key: "acre", label: "에이커", factor: "4046.8564224" }
    ]
  },
  mass: {
    label: "중량·질량",
    base: "g",
    units: [
      { key: "mg", label: "mg", factor: "0.001" },
      { key: "g", label: "g", factor: "1" },
      { key: "kg", label: "kg", factor: "1000" },
      { key: "t", label: "t", factor: "1000000" },
      { key: "don", label: "돈", factor: "3.75" },
      { key: "geun", label: "근", factor: "600" },
      { key: "oz", label: "oz", factor: "28.349523125" },
      { key: "lb", label: "lb", factor: "453.59237" }
    ]
  },
  length: {
    label: "길이",
    base: "m",
    units: [
      { key: "mm", label: "mm", factor: "0.001" },
      { key: "cm", label: "cm", factor: "0.01" },
      { key: "m", label: "m", factor: "1" },
      { key: "km", label: "km", factor: "1000" },
      { key: "in", label: "in", factor: "0.0254" },
      { key: "ft", label: "ft", factor: "0.3048" },
      { key: "yd", label: "yd", factor: "0.9144" },
      { key: "mile", label: "mile", factor: "1609.344" },
      { key: "shaku", label: "자(尺)", factor: "0.30303" }
    ]
  }
};
function _r(e, t) {
  const a = We[e].units.find((o) => o.key === t);
  if (!a) return null;
  const r = be(a.factor);
  if (!r) throw new Error("단위 변환 정보를 불러오지 못했습니다");
  return r;
}
function Xv(e, t, a, r, o = 4, s = "half") {
  const l = _r(e, t), c = _r(e, a);
  if (!l || !c) return null;
  const i = jt(Ze(r, l), c);
  return i ? mt(i, o, s) : null;
}
const Fv = [0, 1, 2, 3, 4, 6], Hv = [
  { key: "text", label: "AI 텍스트계산" },
  { key: "general", label: "일반계산" },
  { key: "date", label: "날짜계산" },
  { key: "unit", label: "단위계산" },
  { key: "fx", label: "환율계산" }
];
function Wv(e) {
  const { tab: t, onTab: a, seed: r, onClose: o, history: s, onHistory: l } = e, [c, i] = A(() => r == null ? [ln()] : [{ sign: "+", text: Ke(Jv(r), 0, !0) }]), [m, u] = A(0), [f, p] = A(0), [_, y] = A("half"), d = B(null);
  U(() => {
    const N = ($) => {
      $.key === "Escape" && ($.preventDefault(), o());
    };
    return document.addEventListener("keydown", N), () => document.removeEventListener("keydown", N);
  }, [o]), U(() => {
    var N, $;
    ($ = (N = d.current) == null ? void 0 : N.querySelector("[data-autofocus]")) == null || $.focus();
  }, [t]);
  const b = (N) => {
    const $ = [...c.filter((g) => g.text !== ""), { sign: "+", text: N }, ln()];
    i($), u($.length - 1), a("general");
  };
  return /* @__PURE__ */ n.createElement("div", { className: "bical-overlay", role: "presentation" }, /* @__PURE__ */ n.createElement("div", { className: "bical-modal", role: "dialog", "aria-modal": "true", "aria-label": "계산기", ref: d }, /* @__PURE__ */ n.createElement("div", { className: "bical-head" }, /* @__PURE__ */ n.createElement("span", { className: "bical-title" }, "계산기"), /* @__PURE__ */ n.createElement("span", { className: "bical-hint" }, "장부에 쓰지 않습니다 — 복사·일반계산 추가로만 내보냅니다"), /* @__PURE__ */ n.createElement("button", { type: "button", className: "bical-x", "aria-label": "닫기", onClick: o }, "✕")), /* @__PURE__ */ n.createElement("div", { className: "bical-tabs", role: "tablist" }, Hv.map((N) => /* @__PURE__ */ n.createElement(
    "button",
    {
      key: N.key,
      type: "button",
      role: "tab",
      className: "bical-tab",
      "aria-selected": N.key === t,
      onClick: () => a(N.key)
    },
    N.label
  ))), /* @__PURE__ */ n.createElement("div", { className: "bical-body" }, t === "text" && /* @__PURE__ */ n.createElement(Gv, { history: s, onHistory: l, onPush: b }), t === "general" && /* @__PURE__ */ n.createElement(
    bv,
    {
      lines: c,
      onLines: i,
      active: m,
      onActive: u,
      digits: f,
      onDigits: p,
      mode: _,
      onMode: y
    }
  ), t === "date" && /* @__PURE__ */ n.createElement(Yv, null), t === "unit" && /* @__PURE__ */ n.createElement(Vv, null), t === "fx" && /* @__PURE__ */ n.createElement(Qv, null)), /* @__PURE__ */ n.createElement("div", { className: "bical-foot" }, /* @__PURE__ */ n.createElement("button", { type: "button", className: "bical-btn", onClick: o }, "닫기"))));
}
const Kv = [
  "1,200만 + 350만 × 2",
  "3,000,000의 15%",
  "2026-01-01부터 2026-03-31까지 며칠",
  "2026-07-17부터 90일 후",
  "150만엔을 원화로",
  "오늘부터 10일 후"
], Uv = 20;
function Gv({ history: e, onHistory: t, onPush: a }) {
  var y;
  const [r, o] = A(""), [s, l] = A(null), [c, i] = A(!1), [m, u] = A(!1), f = B(!1), p = ke(wa, []), _ = (d) => {
    o(d), u(!1);
    const b = Ov(d, { today: p, rates: rn, taxRate: null });
    l(b), d.trim() && t([d, ...e.filter((N) => N !== d)].slice(0, Uv));
  };
  return /* @__PURE__ */ n.createElement("div", null, /* @__PURE__ */ n.createElement(
    "textarea",
    {
      className: "bical-textarea",
      "aria-label": "계산할 문장",
      "data-autofocus": !0,
      value: r,
      placeholder: "문장으로 물어보세요 — Enter 계산 · Shift+Enter 줄바꿈",
      onChange: (d) => o(d.target.value),
      onCompositionStart: () => {
        f.current = !0;
      },
      onCompositionEnd: () => {
        f.current = !1;
      },
      onKeyDown: (d) => {
        d.key === "Enter" && !d.shiftKey && !f.current && !d.nativeEvent.isComposing && (d.preventDefault(), _(r));
      }
    }
  ), /* @__PURE__ */ n.createElement("div", { className: "bical-chips" }, Kv.map((d) => /* @__PURE__ */ n.createElement("button", { key: d, type: "button", className: "bical-chip", onClick: () => _(d) }, d))), s && (s.ok ? /* @__PURE__ */ n.createElement("div", { className: "bical-result" }, /* @__PURE__ */ n.createElement("div", { className: "bical-explain" }, s.explain), /* @__PURE__ */ n.createElement("div", { className: "bical-value" }, s.value), /* @__PURE__ */ n.createElement("div", { className: "bical-chips" }, /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      className: "bical-btn",
      onClick: () => {
        var d;
        (d = navigator.clipboard) == null || d.writeText(s.value).then(
          () => u(!0),
          () => u(!1)
        );
      }
    },
    m ? "복사함" : "결과복사"
  ), /* @__PURE__ */ n.createElement("button", { type: "button", className: "bical-btn", onClick: () => a(s.value) }, "일반계산에 추가"))) : /* @__PURE__ */ n.createElement("div", { className: "bical-result bical-notice" }, /* @__PURE__ */ n.createElement("div", { className: "bical-explain" }, "읽지 못했습니다 — 지원하는 형식입니다"), /* @__PURE__ */ n.createElement("ul", { style: { margin: "4px 0 0", paddingLeft: 16 } }, ((y = s.supported) != null ? y : cn).map((d) => /* @__PURE__ */ n.createElement("li", { key: d }, d))))), e.length > 0 && /* @__PURE__ */ n.createElement("div", { className: "bical-log" }, /* @__PURE__ */ n.createElement("button", { type: "button", onClick: () => i((d) => !d) }, "기록 ", e.length, "건 ", c ? "접기" : "펼치기"), c && /* @__PURE__ */ n.createElement("ol", null, e.map((d) => /* @__PURE__ */ n.createElement("li", { key: d }, /* @__PURE__ */ n.createElement("button", { type: "button", onClick: () => _(d) }, d))))), /* @__PURE__ */ n.createElement("div", { className: "bical-sub", style: { marginTop: 8 } }, "기록은 이 세션에만 남고 저장하지 않습니다."));
}
function Yv() {
  const e = ke(wa, []), [t, a] = A(ze(e)), [r, o] = A(ze(e)), [s, l] = A("exclude-first"), c = ua(t), i = ua(r), m = c && i ? to(c, i, s) : null;
  return /* @__PURE__ */ n.createElement("div", null, /* @__PURE__ */ n.createElement("div", { className: "bical-row" }, /* @__PURE__ */ n.createElement("span", { className: "bical-label" }, "계산 방식"), /* @__PURE__ */ n.createElement("select", { "aria-label": "계산 방식", className: "bical-select", value: s, onChange: (u) => l(u.target.value) }, /* @__PURE__ */ n.createElement("option", { value: "exclude-first" }, "초일불산입 말일산입"), /* @__PURE__ */ n.createElement("option", { value: "include-first" }, "초일산입 말일산입"))), /* @__PURE__ */ n.createElement("div", { className: "bical-row" }, /* @__PURE__ */ n.createElement("span", { className: "bical-label" }, "기간"), /* @__PURE__ */ n.createElement("input", { "aria-label": "시작일", className: "bical-input", type: "date", "data-autofocus": !0, value: t, onChange: (u) => a(u.target.value) }), /* @__PURE__ */ n.createElement("span", null, "~"), /* @__PURE__ */ n.createElement("input", { "aria-label": "종료일", className: "bical-input", type: "date", value: r, onChange: (u) => o(u.target.value) })), m ? /* @__PURE__ */ n.createElement("div", { className: "bical-result" }, /* @__PURE__ */ n.createElement("div", { className: "bical-explain" }, ze(c), "(", ma(c), ") ~ ", ze(i), "(", ma(i), ")", m.swapped ? " · 역순 입력" : ""), /* @__PURE__ */ n.createElement("div", { className: "bical-value" }, m.days.toLocaleString(), "일"), /* @__PURE__ */ n.createElement("div", { className: "bical-sub" }, "차이(년, 월, 일) — ", m.y, "년 ", m.m, "개월 ", m.d, "일")) : /* @__PURE__ */ n.createElement("div", { className: "bical-result bical-notice" }, "날짜를 두 개 모두 입력하세요."));
}
function Vv() {
  const [e, t] = A("area"), [a, r] = A(We.area.units[0].key), [o, s] = A(We.area.units[4].key), [l, c] = A(""), [i, m] = A(4), [u, f] = A("half"), p = (d) => {
    t(d), r(We[d].units[0].key), s(We[d].units[1].key), c("");
  }, _ = be(l), y = _ ? Xv(e, a, o, _, i, u) : null;
  return /* @__PURE__ */ n.createElement("div", null, /* @__PURE__ */ n.createElement("div", { className: "bical-row" }, /* @__PURE__ */ n.createElement("span", { className: "bical-label" }, "분류"), /* @__PURE__ */ n.createElement("select", { "aria-label": "분류", className: "bical-select", value: e, onChange: (d) => p(d.target.value) }, Object.keys(We).map((d) => /* @__PURE__ */ n.createElement("option", { key: d, value: d }, We[d].label))), /* @__PURE__ */ n.createElement("span", { className: "bical-sub" }, "기준 ", We[e].base)), /* @__PURE__ */ n.createElement("div", { className: "bical-row" }, /* @__PURE__ */ n.createElement("span", { className: "bical-label" }, "값"), /* @__PURE__ */ n.createElement(
    "input",
    {
      className: "bical-input bical-num",
      "aria-label": "값",
      "data-autofocus": !0,
      inputMode: "decimal",
      value: l,
      onChange: (d) => c(d.target.value.replace(/[^\d.-]/g, ""))
    }
  ), /* @__PURE__ */ n.createElement("select", { "aria-label": "변환 전 단위", className: "bical-select", value: a, onChange: (d) => r(d.target.value) }, We[e].units.map((d) => /* @__PURE__ */ n.createElement("option", { key: d.key, value: d.key }, d.label))), /* @__PURE__ */ n.createElement("span", null, "→"), /* @__PURE__ */ n.createElement("select", { "aria-label": "변환 후 단위", className: "bical-select", value: o, onChange: (d) => s(d.target.value) }, We[e].units.map((d) => /* @__PURE__ */ n.createElement("option", { key: d.key, value: d.key }, d.label)))), /* @__PURE__ */ n.createElement("div", { className: "bical-row" }, /* @__PURE__ */ n.createElement("span", { className: "bical-label" }, "자리수"), /* @__PURE__ */ n.createElement("select", { "aria-label": "자리수", className: "bical-select", value: i, onChange: (d) => m(Number(d.target.value)) }, Fv.map((d) => /* @__PURE__ */ n.createElement("option", { key: d, value: d }, d))), /* @__PURE__ */ n.createElement("select", { "aria-label": "표기 방법", className: "bical-select", value: u, onChange: (d) => f(d.target.value) }, /* @__PURE__ */ n.createElement("option", { value: "half" }, "반올림"), /* @__PURE__ */ n.createElement("option", { value: "up" }, "올림"), /* @__PURE__ */ n.createElement("option", { value: "down" }, "버림"))), /* @__PURE__ */ n.createElement("div", { className: "bical-result" }, /* @__PURE__ */ n.createElement("div", { className: "bical-explain" }, yr(e, a), " → ", yr(e, o), " · 기준단위 1단계 환산"), /* @__PURE__ */ n.createElement("div", { className: "bical-value" }, y ? Ke(y, i, !0) : "—")));
}
function yr(e, t) {
  var a, r;
  return (r = (a = We[e].units.find((o) => o.key === t)) == null ? void 0 : a.label) != null ? r : t;
}
function Qv() {
  const e = ke(wa, []), [t, a] = A(ze(e)), [r, o] = A("JPY"), [s, l] = A("KRW"), [c, i] = A(""), m = be(c), u = m ? ao(rn, m, r, s) : null, f = da(rn, r);
  return /* @__PURE__ */ n.createElement("div", null, /* @__PURE__ */ n.createElement("div", { className: "bical-row" }, /* @__PURE__ */ n.createElement("span", { className: "bical-label" }, "기준일자"), /* @__PURE__ */ n.createElement("input", { "aria-label": "기준일자", className: "bical-input", type: "date", value: t, onChange: (p) => a(p.target.value) })), /* @__PURE__ */ n.createElement("div", { className: "bical-row" }, /* @__PURE__ */ n.createElement("span", { className: "bical-label" }, "금액"), /* @__PURE__ */ n.createElement(
    "input",
    {
      className: "bical-input bical-num",
      "aria-label": "금액",
      "data-autofocus": !0,
      inputMode: "decimal",
      value: c,
      onChange: (p) => i(p.target.value.replace(/[^\d.-]/g, ""))
    }
  ), /* @__PURE__ */ n.createElement("select", { "aria-label": "변환 전 통화", className: "bical-select", value: r, onChange: (p) => o(p.target.value) }, rn.map((p) => /* @__PURE__ */ n.createElement("option", { key: p.code, value: p.code }, p.code, " (", p.label, ")"))), /* @__PURE__ */ n.createElement("span", null, "→"), /* @__PURE__ */ n.createElement("select", { "aria-label": "변환 후 통화", className: "bical-select", value: s, onChange: (p) => l(p.target.value) }, rn.map((p) => /* @__PURE__ */ n.createElement("option", { key: p.code, value: p.code }, p.code, " (", p.label, ")")))), /* @__PURE__ */ n.createElement("div", { className: "bical-result" }, /* @__PURE__ */ n.createElement("div", { className: "bical-explain" }, f ? no(f) : ""), /* @__PURE__ */ n.createElement("div", { className: "bical-value" }, u ? Ke(u.value, 2, !0) : "—")), /* @__PURE__ */ n.createElement("div", { className: "bical-result bical-notice" }, /* @__PURE__ */ n.createElement("b", null, "참고용 환율입니다."), " 토·일·공휴일 데이터가 없고, 기준통화·전신환 구분(TTM/TTS/TTB)도 정해지지 않았습니다. 신고·장부 목적에 쓰지 마세요."));
}
function wa() {
  const e = /* @__PURE__ */ new Date();
  return { y: e.getFullYear(), m: e.getMonth() + 1, d: e.getDate() };
}
function Jv(e) {
  var t;
  return mt((t = be(String(e))) != null ? t : be("0"), 0, "half");
}
const oo = Bn(null);
function Yk({ children: e }) {
  const [t, a] = A(!1), [r, o] = A("text"), [s, l] = A(null), [c, i] = A([]), [m, u] = A(0), f = ke(() => ({
    open: (p) => {
      var _, y;
      o((_ = p == null ? void 0 : p.tab) != null ? _ : "text"), l((y = p == null ? void 0 : p.seed) != null ? y : null), u((d) => d + 1), a(!0);
    },
    close: () => a(!1)
  }), []);
  return /* @__PURE__ */ n.createElement(oo.Provider, { value: f }, e, t && /* @__PURE__ */ n.createElement(
    Wv,
    {
      key: m,
      tab: r,
      onTab: o,
      seed: s,
      onClose: f.close,
      history: c,
      onHistory: i
    }
  ));
}
function Vk() {
  var e;
  return (e = Tn(oo)) != null ? e : { open: () => {
  }, close: () => {
  } };
}
class Qk extends br {
  constructor() {
    super(...arguments), this.rootRef = co(), this.resizeSensor = null;
  }
  componentDidMount() {
    this.rootRef.current && (this.resizeSensor = new wr(this.rootRef.current, this.props.onResize));
  }
  componentWillUnmount() {
    this.resizeSensor && (this.resizeSensor.detach(), this.resizeSensor = null);
  }
  render() {
    const { onResize: t, children: a, ...r } = this.props;
    return /* @__PURE__ */ n.createElement("div", { ref: this.rootRef, ...r }, a);
  }
}
export {
  O0 as $,
  Wk as A,
  mk as B,
  Wv as C,
  h_ as D,
  tk as E,
  sk as F,
  Y0 as G,
  V0 as H,
  qk as I,
  b0 as J,
  Fo as K,
  Lc as L,
  Sr as M,
  y0 as N,
  mn as O,
  na as P,
  fk as Q,
  Tk as R,
  yk as S,
  bk as T,
  _a as U,
  Rk as V,
  wk as W,
  $k as X,
  xk as Y,
  R0 as Z,
  Pn as _,
  us as a,
  Qp as a$,
  Qf as a0,
  pk as a1,
  X0 as a2,
  Nk as a3,
  Eo as a4,
  n0 as a5,
  ck as a6,
  Ik as a7,
  _0 as a8,
  r0 as a9,
  d0 as aA,
  uk as aB,
  kr as aC,
  Fk as aD,
  Hk as aE,
  Xp as aF,
  Po as aG,
  Uk as aH,
  J0 as aI,
  It as aJ,
  N0 as aK,
  z0 as aL,
  E0 as aM,
  qr as aN,
  Ak as aO,
  Dk as aP,
  Pr as aQ,
  Jf as aR,
  Zg as aS,
  Lr as aT,
  Vt as aU,
  Qk as aV,
  wr as aW,
  Qn as aX,
  $r as aY,
  P0 as aZ,
  Dm as a_,
  Mk as aa,
  gk as ab,
  kk as ac,
  Qy as ad,
  vk as ae,
  Yp as af,
  Ek as ag,
  zk as ah,
  Q0 as ai,
  p0 as aj,
  l0 as ak,
  f0 as al,
  Fp as am,
  uv as an,
  c0 as ao,
  u0 as ap,
  i0 as aq,
  C0 as ar,
  D0 as as,
  x0 as at,
  Pk as au,
  m0 as av,
  _k as aw,
  Wa as ax,
  Ok as ay,
  A0 as az,
  o0 as b,
  s0 as b$,
  ra as b0,
  Li as b1,
  ji as b2,
  Dr as b3,
  nk as b4,
  g_ as b5,
  zl as b6,
  W0 as b7,
  ev as b8,
  Wl as b9,
  Lk as bA,
  hE as bB,
  Kt as bC,
  Ur as bD,
  jr as bE,
  j0 as bF,
  Em as bG,
  T0 as bH,
  g0 as bI,
  h0 as bJ,
  Hc as bK,
  v0 as bL,
  Yc as bM,
  Br as bN,
  ek as bO,
  Vk as bP,
  H0 as bQ,
  Zf as bR,
  Z0 as bS,
  z_ as bT,
  F0 as bU,
  G0 as bV,
  U0 as bW,
  hk as bX,
  $0 as bY,
  K0 as bZ,
  Gk as b_,
  ty as ba,
  is as bb,
  a0 as bc,
  Hl as bd,
  Nr as be,
  jk as bf,
  Sh as bg,
  Mh as bh,
  Mn as bi,
  Ft as bj,
  Kp as bk,
  tn as bl,
  Wr as bm,
  Up as bn,
  Ha as bo,
  B0 as bp,
  ni as bq,
  Vc as br,
  Jp as bs,
  Kr as bt,
  x_ as bu,
  Fl as bv,
  xr as bw,
  Xl as bx,
  Ts as by,
  w_ as bz,
  Vf as c,
  Kk as c0,
  w0 as c1,
  Qt as c2,
  Nb as c3,
  Ck as d,
  et as e,
  Yk as f,
  I0 as g,
  Mr as h,
  Xk as i,
  Bk as j,
  ir as k,
  ok as l,
  q0 as m,
  M0 as n,
  ik as o,
  S0 as p,
  ak as q,
  rk as r,
  lk as s,
  La as t,
  L0 as u,
  Sk as v,
  dk as w,
  k0 as x,
  Hr as y,
  Pl as z
};
